import {
  Unit_instanceat14thlj150z as Unit_instance,
  compareTo3ankvs086tmwq as compareTo,
  coerceIn10f36k81le1mm as coerceIn,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  StringBuildermazzzhj6kkai as StringBuilder,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Enum3alwj03lh1n41 as Enum,
  ArrayList3it5z8td81qkl as ArrayList,
  addAll1k27qatfgp3k5 as addAll,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  lazy2hsh8ze7j6ikd as lazy,
  binarySearchyyczvdessj07 as binarySearch,
  first58ocm7j58k3q as first,
  last1vo29oleiqj36 as last,
  getOrNull1go7ef9ldk0df as getOrNull,
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfvhqybd2zx248 as listOf,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  protoOf180f3jzyo7rfj as protoOf,
  contentEquals5p44wfjhu6ta as contentEquals,
  contentHashCodem24x0wy7gjt7 as contentHashCode,
  contentToString28hodxfcotn0 as contentToString,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  until1jbpn0z3f8lbg as until,
  createThis2j2avj17cvnv2 as createThis,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  listOf1jh22dvmctj1r as listOf_0,
  last3s1sh0kl8j0vf as last_0,
  joinToString1cxrrlmo0chqs as joinToString,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  captureStack1fzi4aczwc4hg as captureStack,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  step18s9qzr5xwxat as step,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  numberToDouble210hrknaofnhf as numberToDouble,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trimEnd17pt8cbotbalj as trimEnd,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  toString30pk9tzaqopn as toString_0,
  Comparable198qfk8pnblz0 as Comparable,
  enumEntries20mr21zbe3az4 as enumEntries,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  replaceqbix900hl8kl as replace,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  KProperty02ce7r476m8633 as KProperty0,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  IntArrayList3liuagbdnwmna as IntArrayList,
  _BSearchResult___init__impl__em6zam3kgjdixysmohf as _BSearchResult___init__impl__em6zam,
  _BSearchResult___get_found__impl__om04iz3bh6o9yjop0o as _BSearchResult___get_found__impl__om04iz,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  PointArrayList281mrsgyr6ua1 as PointArrayList,
  getCyclic28wvgqye98jqx as getCyclic,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  sort23bpsawysis6n as sort,
  pointArrayListOf7rbgdbqf3x4b as pointArrayListOf,
  pointArrayListOf2s9je3njyg83l as pointArrayListOf_0,
  pointArrayListOf36sb9r6prgwk4 as pointArrayListOf_1,
  binarySearch1lxbagta5e4q4 as binarySearch_0,
  _BSearchResult___get_index__impl__b5kraz2d2rlh08ytgci as _BSearchResult___get_index__impl__b5kraz,
  _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2 as _BSearchResult___get_nearIndex__impl__s8nq43,
  getCyclic18d9063nmuul as getCyclic_0,
  swap3upf401qn4fc8 as swap,
  rotateRight96vk8nw2c6nx as rotateRight,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  get_size3oaoh8cpamcqc as get_size,
  Pool1zbsw0zhvh8ca as Pool,
  SortOps3rp25tm4jbjru as SortOps,
  genericSort3vhmyxbppxo3h as genericSort,
  PointIntArrayList1s7gare9hr1oh as PointIntArrayList,
  ConcurrentPool3ky1e4r5za9ab as ConcurrentPool,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_0,
  _Angle___init__impl__g23q1m36yxttgnpy5tv as _Angle___init__impl__g23q1m,
  adjustFromUp1ak85cceintt4 as adjustFromUp,
  Angle__minus_impl_xeau7ko02ca30grn4a as Angle__minus_impl_xeau7k,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__plus_impl_26v37karx983dsduoy as Angle__plus_impl_26v37k,
  _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle as _Angle___get_absoluteValue__impl__4qoakv,
  Angle__umod_impl_4wilf71vq5gai237g1r as Angle__umod_impl_4wilf7,
  Angle__compareTo_impl_a0hfds24obl4qqhxk1t as Angle__compareTo_impl_a0hfds,
  _Angle___get_ratio__impl__ap3on435dv91f5cbp85 as _Angle___get_ratio__impl__ap3on4,
  interpolatewhd2sgxffql5 as interpolate,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__cosine_impl_bgvzun1b2925dagclby as Angle__cosine_impl_bgvzun,
  Angle__sine_impl_3l11xv3pgl8zzgp52i0 as Angle__sine_impl_3l11xv,
  interpolateAngleDenormalized1hkwzk523mo1c as interpolateAngleDenormalized,
  transformY3ktoxhxwkzwk1 as transformY,
  transformX33nszy4vzqsfy as transformX,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_1,
  Line2D2pf35pcx71ncp as Line2D,
  Angle2itorpob18n08 as Angle,
  outerCircle30hn5vvbpz9gu as outerCircle,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_2,
  _Angle___get_normalized__impl__9s30ys1q15xt9x23bx as _Angle___get_normalized__impl__9s30ys,
  _Angle___get_radians__impl__n00yt518seywpfbf9fr as _Angle___get_radians__impl__n00yt5,
  Angle__times_impl_v3s9y21yznxo5bj1uj7 as Angle__times_impl_v3s9y2,
  Angle__div_impl_ut2btd1qmy7ftoy1opp as Angle__div_impl_ut2btd,
  _Angle___get_cosine__impl__vprvmu3ab5uwcliuboq as _Angle___get_cosine__impl__vprvmu,
  _Angle___get_sine__impl__15nmyi39oh4tio4auz1 as _Angle___get_sine__impl__15nmyi,
  _Angle___get_tangent__impl__vushdy2zy6w59e4l7qg as _Angle___get_tangent__impl__vushdy,
  Size2Dum5ayuyhhau7 as Size2D,
  Rectangle3q03woyn9k8x1 as Rectangle,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_3,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x,
  Companion_getInstance2yu48324co92b as Companion_getInstance_4,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Vector2I2k5512l4eeahb as Vector2I,
  toIntu0rc68akxu7a as toInt,
  Angle__unaryPlus_impl_eyi5plrfyn5fslhvdp as Angle__unaryPlus_impl_eyi5pl,
  Angle__unaryMinus_impl_7901fruk5m76f5kg06 as Angle__unaryMinus_impl_7901fr,
  BoundsBuilder162uwsje56mvu as BoundsBuilder,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x_0,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance3qti4zygy7usz as Companion_getInstance_5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_6,
  _Ratio___get_absoluteValue__impl__92ozif2q8z2akxn3hd8 as _Ratio___get_absoluteValue__impl__92ozif,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  toRatioClampedeq87m2alw3kr as toRatioClamped,
  toRatioa3v13oich5q as toRatio,
  toRatio1hooqit5gulhr as toRatio_0,
  Ratio136tf4z2t0p2d as Ratio,
  clamp1qclpmpfxm7xb as clamp,
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  convertRange139vj18oahy2c as convertRange,
  Ratio__minus_impl_s1uwyg39ebtqskl4ycn as Ratio__minus_impl_s1uwyg,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  Ratio__times_impl_ucdh7yuy2trpt4sqvt as Ratio__times_impl_ucdh7y_0,
  _Ratio___get_value__impl__57cli6w1n0arietzij as _Ratio___get_value__impl__57cli6,
  normalizeZero2ksfd6bzt4qwz as normalizeZero,
  isAlmostEquals18m8qk24p7w0q as isAlmostEquals,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals_0,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__hashCode_impl_quhc2v2f99yx2uv51mf as Ratio__hashCode_impl_quhc2v,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  isAlmostZero7baqs51et9hm as isAlmostZero,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  convertRange1a6ancvyn151r as convertRange_0,
  interpolate2g7wzskc23f1q as interpolate_0,
  interpolate35pbs3ac913y4 as interpolate_1,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2_0,
  umod164hvijxhfi8p as umod,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  insert2fz5125p2hdyd as insert_0,
  clamp31lhm66c28ic8 as clamp_0,
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_7,
  invoke3idfsdzzpzmqq as invoke,
  invoke1y68e7g1lbvl5 as invoke_0,
  Easing3266vfl8a4o75 as Easing,
  toRatiolga1a9coidva as toRatio_1,
  clampdicp8njiht45 as clamp_1,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  hasExtra1969mplo13qgb as hasExtra,
  Property1m5vulkepgwzd as Property,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class IntSegmentSet {
  constructor() {
    this.t3b_1 = IntArrayList.m2o(16);
    this.u3b_1 = IntArrayList.m2o(16);
  }
  f1() {
    return this.t3b_1.f1();
  }
  h1() {
    return this.f1() === 0;
  }
  l2c() {
    return this.f1() > 0;
  }
  hh() {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.clear.<anonymous>' call
    this.t3b_1.k3();
    this.u3b_1.k3();
    return this;
  }
  v3b() {
    return this.l2c() ? this.t3b_1.sz(0) : 0;
  }
  w3b() {
    return this.l2c() ? this.u3b_1.sz(this.u3b_1.f1() - 1 | 0) : 0;
  }
  x3b(x) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = this.f1() - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findNearIndex.<anonymous>' call
        var min = this.t3b_1.sz(mid);
        var max = this.u3b_1.sz(mid);
        var mval = x < min ? 1 : x > max ? -1 : 0;
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.datastructure.genericBinarySearch.<anonymous>' call
      tmp$ret$1 = (-low | 0) - 1 | 0;
    }
    return _BSearchResult___init__impl__em6zam(tmp$ret$1);
  }
  y3b(x) {
    // Inline function 'korlibs.math.segment.genericBinarySearchLeft' call
    var toIndex = this.f1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findLeftBound.<anonymous>' call
        var mval = compareTo(this.t3b_1.sz(mid), x);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.math.segment.genericBinarySearchLeft.<anonymous>' call
      var low_0 = low;
      // Inline function 'kotlin.math.min' call
      var b = high;
      var tmp$ret$2 = Math.min(low_0, b);
      tmp$ret$1 = coerceIn(tmp$ret$2, 0, toIndex - 1 | 0);
    }
    var tmp$ret$4 = tmp$ret$1;
    return coerceIn(tmp$ret$4, 0, this.f1() - 1 | 0);
  }
  z3b(x) {
    // Inline function 'korlibs.math.segment.genericBinarySearchRight' call
    var toIndex = this.f1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findRightBound.<anonymous>' call
        var mval = compareTo(this.u3b_1.sz(mid), x);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.math.segment.genericBinarySearchRight.<anonymous>' call
      var low_0 = low;
      // Inline function 'kotlin.math.max' call
      var b = high;
      var tmp$ret$2 = Math.max(low_0, b);
      tmp$ret$1 = coerceIn(tmp$ret$2, 0, toIndex - 1 | 0);
    }
    var tmp$ret$4 = tmp$ret$1;
    return coerceIn(tmp$ret$4, 0, this.f1() - 1 | 0);
  }
  l2w(min, max) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    $l$block_0: {
      // Inline function 'korlibs.math.segment.IntSegmentSet.add.<anonymous>' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(min <= max)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.h5(toString(message));
      }
      if (this.h1()) {
        insertAt(this, this.f1(), min, max);
      } else if (min === this.w3b()) {
        this.u3b_1.x2o(this.u3b_1.f1() - 1 | 0, max);
      } else if (max === this.v3b()) {
        this.t3b_1.x2o(0, min);
      } else {
        var removeStart = -1;
        var removeCount = -1;
        $l$block: {
          // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEachInterestingRange' call
          if (this.h1()) {
            break $l$block;
          }
          var nmin = this.y3b(min);
          var nmax = this.z3b(max);
          var inductionVariable = nmin;
          if (inductionVariable <= nmax)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.math.segment.IntSegmentSet.add.<anonymous>.<anonymous>' call
              var n_0 = n;
              var x1 = this.t3b_1.sz(n);
              var x2 = this.u3b_1.sz(n);
              if (this.a3c(x1, x2, min, max)) {
                if (removeStart === -1)
                  removeStart = n_0;
                var tmp = removeStart;
                // Inline function 'kotlin.math.min' call
                var a = this.t3b_1.sz(removeStart);
                // Inline function 'kotlin.math.min' call
                var b = Math.min(x1, min);
                var tmp$ret$3 = Math.min(a, b);
                this.t3b_1.x2o(tmp, tmp$ret$3);
                var tmp_0 = removeStart;
                // Inline function 'kotlin.math.max' call
                var a_0 = this.u3b_1.sz(removeStart);
                // Inline function 'kotlin.math.max' call
                var b_0 = Math.max(x2, max);
                var tmp$ret$5 = Math.max(a_0, b_0);
                this.u3b_1.x2o(tmp_0, tmp$ret$5);
                removeCount = removeCount + 1 | 0;
              }
            }
             while (!(n === nmax));
        }
        if (removeCount !== 0)
          if (removeCount > 0) {
            removeAt(this, removeStart + 1 | 0, removeCount);
          } else if (max < this.v3b()) {
            insertAt(this, 0, min, max);
          } else if (min > this.w3b()) {
            insertAt(this, this.f1(), min, max);
          } else {
            var inductionVariable_0 = coerceAtLeast(this.y3b(min), 1);
            var last = this.z3b(max);
            if (inductionVariable_0 <= last)
              do {
                var m = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var prevMax = this.u3b_1.sz(m - 1 | 0);
                var currMin = this.t3b_1.sz(m);
                if (min > prevMax && max < currMin) {
                  insertAt(this, m, min, max);
                  break $l$block_0;
                }
              }
               while (!(m === last));
            // Inline function 'kotlin.error' call
            var message_0 = 'Unexpected';
            throw IllegalStateException.h5(toString(message_0));
          }
      }
    }
    return this;
  }
  hp(v) {
    return _BSearchResult___get_found__impl__om04iz(this.x3b(v));
  }
  b3c(a, b) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>' call
    var aSmaller = a.f1() < b.f1();
    var av = aSmaller ? a : b;
    var bv = aSmaller ? b : a;
    // Inline function 'kotlin.also' call
    this.hh();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
    var inductionVariable = 0;
    var last = av.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>.<anonymous>' call
        var x1 = av.t3b_1.sz(n);
        // Inline function 'korlibs.math.segment.IntSegmentSet.intersection' call
        var max = av.u3b_1.sz(n);
        var count = 0;
        $l$block: {
          // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEachInterestingRange' call
          if (bv.h1()) {
            break $l$block;
          }
          var nmin = bv.y3b(x1);
          var nmax = bv.z3b(max);
          var inductionVariable_0 = nmin;
          if (inductionVariable_0 <= nmax)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'korlibs.math.segment.IntSegmentSet.intersection.<anonymous>' call
              var x1_0 = bv.t3b_1.sz(n_0);
              var x2 = bv.u3b_1.sz(n_0);
              if (bv.a3c(x1_0, x2, x1, max)) {
                // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.math.max' call
                var min = Math.max(x1_0, x1);
                // Inline function 'kotlin.math.min' call
                var max_0 = Math.min(x2, max);
                this.l2w(min, max_0);
                count = count + 1 | 0;
              }
            }
             while (!(n_0 === nmax));
        }
      }
       while (inductionVariable < last);
    return this;
  }
  a3c(x1, x2, y1, y2) {
    return x2 >= y1 && y2 >= x1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.toString.<anonymous>' call
    this_0.bc('[');
    // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.toString.<anonymous>.<anonymous>' call
        var min = this.t3b_1.sz(n);
        var max = this.u3b_1.sz(n);
        var first = n === 0;
        if (!first) {
          this_0.bc(', ');
        }
        this_0.bc('' + min + '-' + max);
      }
       while (inductionVariable < last);
    this_0.bc(']');
    return this_0.toString();
  }
}
class StrokePointsMode extends Enum {}
class StrokePointsBuilder {
  constructor(width, mode, generateDebug) {
    mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
    generateDebug = generateDebug === VOID ? false : generateDebug;
    this.l3c_1 = width;
    this.m3c_1 = mode;
    this.n3c_1 = generateDebug;
    this.o3c_1 = 20;
    var tmp = this;
    var tmp_0;
    switch (this.m3c_1.r3_1) {
      case 0:
        tmp_0 = 6;
        break;
      case 1:
        tmp_0 = 2;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.p3c_1 = new DoubleVectorArrayList(tmp_0);
    this.q3c_1 = new PointArrayList();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.r3c_1 = ArrayList.j1();
  }
  t3c() {
    return this.p3c_1;
  }
  toString() {
    return 'StrokePointsBuilder(' + this.l3c_1 + ', ' + this.p3c_1.toString() + ')';
  }
  u3c(pos, normal, width, maxWidth) {
    switch (this.m3c_1.r3_1) {
      case 0:
        // Inline function 'kotlin.math.absoluteValue' call

        var tmp$ret$0 = Math.abs(maxWidth);
        this.p3c_1.n2p(pos.a2a_1, pos.b2a_1, normal.a2a_1, normal.b2a_1, width, tmp$ret$0);
        break;
      case 1:
        this.p3c_1.l2p(pos.a2a_1 + normal.a2a_1 * width, pos.b2a_1 + normal.b2a_1 * width);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  v3c(pos, normal, width, maxWidth, $super) {
    maxWidth = maxWidth === VOID ? width : maxWidth;
    var tmp;
    if ($super === VOID) {
      this.u3c(pos, normal, width, maxWidth);
      tmp = Unit_instance;
    } else {
      tmp = $super.u3c.call(this, pos, normal, width, maxWidth);
    }
    return tmp;
  }
  w3c(center, pos, sign) {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var dist = Vector2D.k2c(pos.a2a_1 - center.a2a_1, pos.b2a_1 - center.b2a_1);
    var tmp;
    if (sign < 0.0) {
      // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
      tmp = Vector2D.k2c(-dist.a2a_1, -dist.b2a_1);
    } else {
      tmp = dist;
    }
    var normal = tmp;
    this.v3c(center, normal.b2l(), dist.a() * sign);
  }
  x3c(center, pos, sign, $super) {
    sign = sign === VOID ? 1.0 : sign;
    var tmp;
    if ($super === VOID) {
      this.w3c(center, pos, sign);
      tmp = Unit_instance;
    } else {
      tmp = $super.w3c.call(this, center, pos, sign);
    }
    return tmp;
  }
  y3c(pos, normal, width) {
    this.v3c(pos, normal, width);
    this.v3c(pos, normal, -width);
  }
  z3c(curr, next, kind, miterLimitRatio) {
    var commonPoint = curr.a3d(Companion_getInstance_6().pz_1);
    var currTangent = curr.b3d(Companion_getInstance_6().pz_1);
    var currNormal = curr.c3d(Companion_getInstance_6().pz_1);
    var nextTangent = next.b3d(Companion_getInstance_6().mz_1);
    var nextNormal = next.c3d(Companion_getInstance_6().mz_1);
    var tmp = Companion_instance_15;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = this.l3c_1;
    var that = Vector2D.k2c(currNormal.a2a_1 * scale, currNormal.b2a_1 * scale);
    var tmp$ret$1 = Vector2D.k2c(commonPoint.a2a_1 + that.a2a_1, commonPoint.b2a_1 + that.b2a_1);
    var currLine0 = tmp.d3d(tmp$ret$1, currTangent);
    var tmp_0 = Companion_instance_15;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_0 = -this.l3c_1;
    var that_0 = Vector2D.k2c(currNormal.a2a_1 * scale_0, currNormal.b2a_1 * scale_0);
    var tmp$ret$3 = Vector2D.k2c(commonPoint.a2a_1 + that_0.a2a_1, commonPoint.b2a_1 + that_0.b2a_1);
    var currLine1 = tmp_0.d3d(tmp$ret$3, currTangent);
    var tmp_1 = Companion_instance_15;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_1 = this.l3c_1;
    var that_1 = Vector2D.k2c(nextNormal.a2a_1 * scale_1, nextNormal.b2a_1 * scale_1);
    var tmp$ret$5 = Vector2D.k2c(commonPoint.a2a_1 + that_1.a2a_1, commonPoint.b2a_1 + that_1.b2a_1);
    var nextLine0 = tmp_1.d3d(tmp$ret$5, nextTangent);
    var tmp_2 = Companion_instance_15;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_2 = -this.l3c_1;
    var that_2 = Vector2D.k2c(nextNormal.a2a_1 * scale_2, nextNormal.b2a_1 * scale_2);
    var tmp$ret$7 = Vector2D.k2c(commonPoint.a2a_1 + that_2.a2a_1, commonPoint.b2a_1 + that_2.b2a_1);
    var nextLine1 = tmp_2.d3d(tmp$ret$7, nextTangent);
    var intersection0 = lineIntersectionPoint(Companion_instance_15, currLine0, nextLine0);
    var intersection1 = lineIntersectionPoint(Companion_instance_15, currLine1, nextLine1);
    if (intersection0 == null || intersection1 == null) {
      this.y3c(commonPoint, currNormal, this.l3c_1);
      return Unit_instance;
    }
    var direction = Companion_getInstance().w2k(currTangent, nextTangent);
    var miterLength = Companion_getInstance().t2k(intersection0, intersection1);
    var miterLimit = miterLimitRatio * this.l3c_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    Companion_getInstance_0();
    var up = Companion_getInstance().g2a_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    var x = nextTangent.a2a_1;
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    // Inline function 'kotlin.math.atan2' call
    var x_0 = nextTangent.b2a_1;
    var radians = Math.atan2(x, x_0);
    var tmp$ret$9 = _Angle___init__impl__g23q1m(radians);
    var tmp_3 = adjustFromUp(tmp$ret$9, up);
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    Companion_getInstance_0();
    var up_0 = Companion_getInstance().g2a_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    var x_1 = currTangent.a2a_1;
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    // Inline function 'kotlin.math.atan2' call
    var x_2 = currTangent.b2a_1;
    var radians_0 = Math.atan2(x_1, x_2);
    var tmp$ret$13 = _Angle___init__impl__g23q1m(radians_0);
    var tmp$ret$15 = adjustFromUp(tmp$ret$13, up_0);
    var angle = Angle__minus_impl_xeau7k(tmp_3, tmp$ret$15);
    if (!kind.equals(LineJoin_MITER_getInstance()) || miterLength > miterLimit) {
      var p1 = direction <= 0.0 ? projectedPoint(currLine0, commonPoint) : projectedPoint(nextLine1, commonPoint);
      var p2 = direction <= 0.0 ? projectedPoint(nextLine0, commonPoint) : projectedPoint(currLine1, commonPoint);
      var p3 = direction <= 0.0 ? lineIntersectionPoint(Companion_instance_15, currLine1, nextLine1) : lineIntersectionPoint(Companion_instance_15, currLine0, nextLine0);
      var p4Line = direction < 0.0 ? nextLine1 : nextLine0;
      var p4 = projectedPoint(p4Line, commonPoint);
      if (p3 == null) {
        p3 = p4;
      }
      var angleB = _Angle___get_absoluteValue__impl__4qoakv(Angle__plus_impl_26v37k(angle, get_degrees(180)));
      var angle2 = _Angle___get_absoluteValue__impl__4qoakv(Angle__umod_impl_4wilf7(angle, get_degrees(180)));
      var angle3 = Angle__compareTo_impl_a0hfds(angle2, get_degrees(90)) >= 0 ? Angle__minus_impl_xeau7k(get_degrees(180), angle2) : angle2;
      var ratio = toRatioClamped(Ratio__times_impl_ucdh7y(_Ratio___get_absoluteValue__impl__92ozif(_Angle___get_ratio__impl__ap3on4(angle3)), 4.0));
      var p5 = interpolate(toRatio(ratio), p4, ensureNotNull(p3));
      if (this.n3c_1) {
        this.r3c_1.h(nextLine1.g3d(1000.0).uz());
        this.r3c_1.h(currLine1.g3d(1000.0).uz());
        this.r3c_1.h(nextLine0.g3d(1000.0).uz());
        this.r3c_1.h(currLine0.g3d(1000.0).uz());
        this.r3c_1.h(Companion_instance_15.d3d(commonPoint, currTangent).g3d(1000.0).uz());
        this.r3c_1.h(Companion_instance_15.d3d(commonPoint, nextTangent).g3d(1000.0).uz());
        this.q3c_1.w2v(p3);
        this.q3c_1.w2v(p4);
        this.q3c_1.w2v(p5);
      }
      var p6 = p5;
      if (direction < 0.0) {
        this.x3c(commonPoint, p1);
        this.w3c(commonPoint, p6, -1.0);
        this.x3c(commonPoint, p2);
        this.w3c(commonPoint, p6, -1.0);
      } else {
        this.x3c(commonPoint, p6);
        this.w3c(commonPoint, p2, -1.0);
        this.x3c(commonPoint, p6);
        this.w3c(commonPoint, p1, -1.0);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var d0 = Vector2D.k2c(intersection0.a2a_1 - commonPoint.a2a_1, intersection0.b2a_1 - commonPoint.b2a_1);
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var d1 = Vector2D.k2c(commonPoint.a2a_1 - intersection1.a2a_1, commonPoint.b2a_1 - intersection1.b2a_1);
    var tmp_4 = d0.b2l();
    var tmp_5 = d0.a();
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = d0.a();
    var tmp$ret$18 = Math.abs(this_0);
    this.u3c(commonPoint, tmp_4, tmp_5, tmp$ret$18);
    var tmp_6 = d1.b2l();
    var tmp_7 = -d1.a();
    // Inline function 'kotlin.math.absoluteValue' call
    var this_1 = d1.a();
    var tmp$ret$19 = Math.abs(this_1);
    this.u3c(commonPoint, tmp_6, tmp_7, tmp$ret$19);
  }
  h3d(curr, ratio, kind) {
    switch (kind.r3_1) {
      case 1:
      case 2:
        // Inline function 'kotlin.let' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.math.geom.bezier.StrokePointsBuilder.addCap.<anonymous>' call

        var it = curr.c3d(ratio).c2l();
        var tmp;
        if (equals(ratio, Companion_getInstance_6().pz_1)) {
          // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
          tmp = Vector2D.k2c(-it.a2a_1, -it.b2a_1);
        } else {
          tmp = it;
        }

        var derivate = tmp;
        switch (kind.r3_1) {
          case 1:
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            var this_0 = curr.a3d(ratio);
            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale = this.l3c_1;
            var that = Vector2D.k2c(derivate.a2a_1 * scale, derivate.b2a_1 * scale);
            var tmp$ret$4 = Vector2D.k2c(this_0.a2a_1 + that.a2a_1, this_0.b2a_1 + that.b2a_1);
            this.y3c(tmp$ret$4, curr.c3d(ratio), this.l3c_1);
            break;
          case 2:
            var mid = curr.a3d(ratio);
            var normal = curr.c3d(ratio);
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale_0 = this.l3c_1;
            var that_0 = Vector2D.k2c(normal.a2a_1 * scale_0, normal.b2a_1 * scale_0);
            var p0 = Vector2D.k2c(mid.a2a_1 + that_0.a2a_1, mid.b2a_1 + that_0.b2a_1);
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale_1 = -this.l3c_1;
            var that_1 = Vector2D.k2c(normal.a2a_1 * scale_1, normal.b2a_1 * scale_1);
            var p3 = Vector2D.k2c(mid.a2a_1 + that_1.a2a_1, mid.b2a_1 + that_1.b2a_1);
            var a = equals(ratio, Companion_getInstance_6().mz_1) ? p0 : p3;
            var b = equals(ratio, Companion_getInstance_6().mz_1) ? p3 : p0;
            this.i3d(a, b, ratio, mid);
            break;
          default:
            // Inline function 'kotlin.error' call

            var message = "Can't happen";
            throw IllegalStateException.h5(toString(message));
        }

        break;
      case 0:
        this.y3c(curr.a3d(ratio), curr.c3d(ratio), this.l3c_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  j3d(p0, p3, ratio, mid, nsteps) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var up = Companion_getInstance().g2a_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0 = mid.a2a_1;
    var y0 = mid.b2a_1;
    var x1 = p0.a2a_1;
    var y1 = p0.b2a_1;
    var angleStart = Angle_between(x0, y0, x1, y1, up);
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var up_0 = Companion_getInstance().g2a_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0_0 = mid.a2a_1;
    var y0_0 = mid.b2a_1;
    var x1_0 = p3.a2a_1;
    var y1_0 = p3.b2a_1;
    var angleEnd = Angle_between(x0_0, y0_0, x1_0, y1_0, up_0);
    if (equals(ratio, Companion_getInstance_6().pz_1)) {
      // Inline function 'korlibs.math.geom.Companion.polar' call
      // Inline function 'korlibs.math.geom.Companion.polar' call
      var up_1 = Companion_getInstance().g2a_1;
      var tmp$ret$8 = Vector2D.k2c(0.0 + Angle__cosine_impl_bgvzun(angleEnd, up_1) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angleEnd, up_1) * 1.0);
      this.y3c(mid, tmp$ret$8, this.l3c_1);
    }
    var addAngle = Companion_getInstance().w2k(p0, p3) <= 0.0 ? Companion_getInstance_0().r29_1 : Companion_getInstance_0().t29_1;
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance_6();
    var NS = nsteps - 1 | 0;
    var NSd = NS;
    var start = true ? 0 : 1;
    var end = true ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio_0 = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.StrokePointsBuilder.addCurvePointsCap.<anonymous>' call
        var it = toRatio_0(ratio_0);
        var angle = interpolateAngleDenormalized(it, angleStart, angleEnd);
        // Inline function 'korlibs.math.geom.Companion.polar' call
        var this_0 = Companion_getInstance();
        var angle_0 = Angle__plus_impl_26v37k(angle, addAngle);
        // Inline function 'korlibs.math.geom.Companion.polar' call
        var up_2 = this_0.g2a_1;
        var dir = Vector2D.k2c(0.0 + Angle__cosine_impl_bgvzun(angle_0, up_2) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angle_0, up_2) * 1.0);
        this.u3c(mid, dir, 0.0, this.l3c_1);
        this.u3c(mid, dir, this.l3c_1, this.l3c_1);
      }
       while (!(n === end));
    if (equals(ratio, Companion_getInstance_6().mz_1)) {
      // Inline function 'korlibs.math.geom.Companion.polar' call
      // Inline function 'korlibs.math.geom.Companion.polar' call
      var up_3 = Companion_getInstance().g2a_1;
      var tmp$ret$12 = Vector2D.k2c(0.0 + Angle__cosine_impl_bgvzun(angleStart, up_3) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angleStart, up_3) * 1.0);
      this.y3c(mid, tmp$ret$12, this.l3c_1);
    }
  }
  i3d(p0, p3, ratio, mid, nsteps, $super) {
    var tmp;
    if (mid === VOID) {
      // Inline function 'korlibs.math.geom.Companion.middle' call
      Companion_getInstance();
      // Inline function 'korlibs.math.geom.Vector2D.times' call
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var this_0 = Vector2D.k2c(p0.a2a_1 + p3.a2a_1, p0.b2a_1 + p3.b2a_1);
      tmp = Vector2D.k2c(this_0.a2a_1 * 0.5, this_0.b2a_1 * 0.5);
    } else {
      tmp = mid;
    }
    mid = tmp;
    nsteps = nsteps === VOID ? this.o3c_1 : nsteps;
    var tmp_0;
    if ($super === VOID) {
      this.j3d(p0, p3, ratio, mid, nsteps);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.j3d.call(this, p0, p3, new Ratio(ratio), mid, nsteps);
    }
    return tmp_0;
  }
  k3d(curr, nsteps) {
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance_6();
    var NS = nsteps - 1 | 0;
    var NSd = NS;
    var start = false ? 0 : 1;
    var end = false ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.StrokePointsBuilder.addCurvePoints.<anonymous>' call
        var it = toRatio_0(ratio);
        this.y3c(curr.a3d(it), curr.c3d(it), this.l3c_1);
      }
       while (!(n === end));
  }
  l3d(curr, nsteps, $super) {
    nsteps = nsteps === VOID ? numberToInt(clamp(curr.a() / 10.0, 10.0, 100.0)) : nsteps;
    var tmp;
    if ($super === VOID) {
      this.k3d(curr, nsteps);
      tmp = Unit_instance;
    } else {
      tmp = $super.k3d.call(this, curr, nsteps);
    }
    return tmp;
  }
  s3c(curves, join, startCap, endCap, miterLimit, forceClosed) {
    var closed = forceClosed == null ? curves.o3d_1 : forceClosed;
    var curves_0 = curves.n3d_1;
    var inductionVariable = 0;
    var last = curves_0.f1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var curr = getCyclic(curves_0, n + 0 | 0);
        var next = getCyclic(curves_0, n + 1 | 0);
        if (n === 0) {
          if (closed) {
            this.z3c(getCyclic(curves_0, n - 1 | 0), curr, join, miterLimit);
          } else {
            this.h3d(curr, Companion_getInstance_6().mz_1, startCap);
          }
        }
        if (!(curr.e3e() === 1)) {
          this.l3d(curr);
        }
        if (n < (curves_0.f1() - 1 | 0)) {
          this.z3c(curr, next, join, miterLimit);
        } else {
          if (closed) {
            this.z3c(curr, next, join, miterLimit);
          } else {
            this.h3d(curr, Companion_getInstance_6().pz_1, endCap);
          }
        }
      }
       while (inductionVariable <= last);
  }
}
class CurveInfo {
  constructor(index, curve, startLength, endLength, bounds) {
    this.f3e_1 = index;
    this.g3e_1 = curve;
    this.h3e_1 = startLength;
    this.i3e_1 = endLength;
    this.j3e_1 = bounds;
  }
  vz(length) {
    var containsLower = this.h3e_1;
    return length <= this.i3e_1 ? containsLower <= length : false;
  }
  a() {
    return this.i3e_1 - this.h3e_1;
  }
  toString() {
    return 'CurveInfo(index=' + this.f3e_1 + ', curve=' + this.g3e_1.toString() + ', startLength=' + this.h3e_1 + ', endLength=' + this.i3e_1 + ', bounds=' + this.j3e_1.toString() + ')';
  }
  hashCode() {
    var result = this.f3e_1;
    result = imul(result, 31) + this.g3e_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.h3e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i3e_1) | 0;
    result = imul(result, 31) + this.j3e_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveInfo))
      return false;
    var tmp0_other_with_cast = other instanceof CurveInfo ? other : THROW_CCE();
    if (!(this.f3e_1 === tmp0_other_with_cast.f3e_1))
      return false;
    if (!this.g3e_1.equals(tmp0_other_with_cast.g3e_1))
      return false;
    if (!equals(this.h3e_1, tmp0_other_with_cast.h3e_1))
      return false;
    if (!equals(this.i3e_1, tmp0_other_with_cast.i3e_1))
      return false;
    if (!this.j3e_1.equals(tmp0_other_with_cast.j3e_1))
      return false;
    return true;
  }
}
class Curves {
  constructor(beziers, closed) {
    this.m3d_1 = new Mixin();
    this.n3d_1 = beziers;
    this.o3d_1 = closed;
    this.p3d_1 = false;
    var tmp = this;
    tmp.q3d_1 = lazy(Curves$contiguous$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.r3d_1 = lazy(Curves$infos$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.s3d_1 = lazy(Curves$length$delegate$lambda(this));
  }
  yz(_set____db54di) {
    this.m3d_1.yz(_set____db54di);
  }
  zz() {
    return this.m3d_1.zz();
  }
  l3e() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r3d_1;
    infos$factory();
    return this_0.s1();
  }
  a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s3d_1;
    length$factory();
    return this_0.s1();
  }
  m3e(_this__u8e3s4) {
    return _Ratio___init__impl__9mwvn2(_this__u8e3s4.h3e_1 / this.a());
  }
  n3e(_this__u8e3s4) {
    return _Ratio___init__impl__9mwvn2(_this__u8e3s4.i3e_1 / this.a());
  }
  o3e(t) {
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var tmp = this.l3e();
    var index = binarySearch(tmp, VOID, VOID, Curves$findInfo$lambda(pos));
    if (Ratio__compareTo_impl_z2ienc(t, Companion_getInstance_6().mz_1) < 0)
      return first(this.l3e());
    if (Ratio__compareTo_impl_z2ienc(t, Companion_getInstance_6().pz_1) > 0)
      return last(this.l3e());
    var tmp0_elvis_lhs = getOrNull(this.l3e(), index);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.h5(toString('OUTSIDE'));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  a3d(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.o3e(t);
    var posInCurve = pos - info.h3e_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.calc.<anonymous>' call
    return info.g3e_1.a3d(toRatio(ratioInCurve));
  }
  c3d(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.o3e(t);
    var posInCurve = pos - info.h3e_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.normal.<anonymous>' call
    return info.g3e_1.c3d(ratioInCurve);
  }
  b3d(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.o3e(t);
    var posInCurve = pos - info.h3e_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.tangent.<anonymous>' call
    return info.g3e_1.b3d(ratioInCurve);
  }
  p3e(length) {
    if (length <= 0.0)
      return Companion_getInstance_6().mz_1;
    if (length >= this.a())
      return Companion_getInstance_6().pz_1;
    var tmp = this.l3e();
    var curveIndex = binarySearch(tmp, VOID, VOID, Curves$ratioFromLength$lambda(length));
    var index = curveIndex < 0 ? (-curveIndex | 0) + 1 | 0 : curveIndex;
    if (curveIndex < 0) {
      return Companion_getInstance_6().qz_1;
    }
    var info = this.l3e().e1(index);
    var lengthInCurve = length - info.h3e_1;
    var ratioInCurve = info.g3e_1.p3e(lengthInCurve);
    return convertRange(ratioInCurve, Companion_getInstance_6().mz_1, Companion_getInstance_6().pz_1, this.m3e(info), this.n3e(info));
  }
  q3e(len0, len1) {
    return this.r3e(this.p3e(len0), this.p3e(len1));
  }
  r3e(t0, t1) {
    if (Ratio__compareTo_impl_z2ienc(t0, t1) > 0)
      return this.r3e(t1, t0);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(Ratio__compareTo_impl_z2ienc(t0, t1) <= 0)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.h5(toString(message));
    }
    if (equals(t0, t1))
      return new Curves(emptyList(), false);
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t0, this.a());
    var info = this.o3e(t0);
    var posInCurve = pos - info.h3e_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>' call
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos_0 = Ratio__times_impl_ucdh7y(t1, this.a());
    var info_0 = this.o3e(t1);
    var posInCurve_0 = pos_0 - info_0.h3e_1;
    var ratioInCurve_0 = _Ratio___init__impl__9mwvn2(posInCurve_0 / info_0.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>.<anonymous>' call
    var tmp;
    if (info.f3e_1 === info_0.f3e_1) {
      tmp = listOf(info.g3e_1.r3e(ratioInCurve, ratioInCurve_0).s3e_1);
    } else {
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList.j1();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>.<anonymous>.<anonymous>' call
      if (!equals(ratioInCurve, Companion_getInstance_6().pz_1)) {
        this_0.h(info.g3e_1.w3e(ratioInCurve).s3e_1);
      }
      var inductionVariable = info.f3e_1 + 1 | 0;
      var last = info_0.f3e_1;
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.h(this.l3e().e1(index).g3e_1);
        }
         while (inductionVariable < last);
      if (!equals(ratioInCurve_0, Companion_getInstance_6().mz_1)) {
        this_0.h(info_0.g3e_1.x3e(ratioInCurve_0).s3e_1);
      }
      tmp = this_0.g8();
    }
    var tmp$ret$7 = tmp;
    return new Curves(tmp$ret$7, false);
  }
  toString() {
    return 'Curves(beziers=' + toString(this.n3d_1) + ', closed=' + this.o3d_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.n3d_1);
    result = imul(result, 31) + getBooleanHashCode(this.o3d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Curves))
      return false;
    var tmp0_other_with_cast = other instanceof Curves ? other : THROW_CCE();
    if (!equals(this.n3d_1, tmp0_other_with_cast.n3d_1))
      return false;
    if (!(this.o3d_1 === tmp0_other_with_cast.o3d_1))
      return false;
    return true;
  }
}
class ProjectedPoint {
  constructor(p, t, dSq) {
    p = p === VOID ? Vector2D.v2c() : p;
    t = t === VOID ? Companion_getInstance_6().mz_1 : t;
    dSq = dSq === VOID ? 0.0 : dSq;
    this.l3f_1 = p;
    this.m3f_1 = t;
    this.n3f_1 = dSq;
  }
  p3f(other, epsilon) {
    return this.l3f_1.d2l(other.l3f_1, epsilon) && isAlmostEquals(this.m3f_1, other.m3f_1, toRatio_0(epsilon)) && isAlmostEquals_0(this.n3f_1, other.n3f_1, epsilon);
  }
  cz(other, epsilon) {
    return this.p3f(other instanceof ProjectedPoint ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return 'ProjectedPoint(p=' + this.l3f_1.toString() + ', t=' + Ratio__toString_impl_mfgt3e(this.m3f_1) + ', dSq=' + this.n3f_1 + ')';
  }
  hashCode() {
    var result = this.l3f_1.hashCode();
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.m3f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n3f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProjectedPoint))
      return false;
    var tmp0_other_with_cast = other instanceof ProjectedPoint ? other : THROW_CCE();
    if (!this.l3f_1.equals(tmp0_other_with_cast.l3f_1))
      return false;
    if (!equals(this.m3f_1, tmp0_other_with_cast.m3f_1))
      return false;
    if (!equals(this.n3f_1, tmp0_other_with_cast.n3f_1))
      return false;
    return true;
  }
}
class Extrema {
  constructor(xt, yt) {
    this.y3e_1 = xt;
    this.z3e_1 = yt;
    var tmp = this;
    tmp.a3f_1 = lazy(Bezier$Extrema$allt$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.b3f_1 = lazy(Bezier$Extrema$xt01$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.c3f_1 = lazy(Bezier$Extrema$yt01$delegate$lambda(this));
  }
  q3f() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b3f_1;
    xt01$factory();
    return this_0.s1();
  }
  r3f() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c3f_1;
    yt01$factory();
    return this_0.s1();
  }
  j3f(index) {
    return index === 0 ? this.q3f() : this.r3f();
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Extrema) {
      tmp_0 = contentEquals(this.y3e_1, other.y3e_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.z3e_1, other.z3e_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.y3e_1) + imul(contentHashCode(this.z3e_1), 7) | 0;
  }
  toString() {
    return 'Extrema(x=' + contentToString(this.y3e_1) + ', y=' + contentToString(this.z3e_1) + ')';
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.d3f_1 = new Float64Array([-0.06405689286260563, 0.06405689286260563, -0.1911188674736163, 0.1911188674736163, -0.3150426796961634, 0.3150426796961634, -0.4337935076260451, 0.4337935076260451, -0.5454214713888396, 0.5454214713888396, -0.6480936519369755, 0.6480936519369755, -0.7401241915785544, 0.7401241915785544, -0.820001985973903, 0.820001985973903, -0.8864155270044011, 0.8864155270044011, -0.9382745520027328, 0.9382745520027328, -0.9747285559713095, 0.9747285559713095, -0.9951872199970213, 0.9951872199970213]);
    var tmp_0 = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp_0.e3f_1 = new Float64Array([0.12793819534675216, 0.12793819534675216, 0.1258374563468283, 0.1258374563468283, 0.12167047292780339, 0.12167047292780339, 0.1155056680537256, 0.1155056680537256, 0.10744427011596563, 0.10744427011596563, 0.09761865210411388, 0.09761865210411388, 0.08619016153195327, 0.08619016153195327, 0.0733464814110803, 0.0733464814110803, 0.05929858491543678, 0.05929858491543678, 0.04427743881741981, 0.04427743881741981, 0.028531388628933663, 0.028531388628933663, 0.0123412297999872, 0.0123412297999872]);
    this.f3f_1 = 6.283185307179586;
    this.g3f_1 = Line2D.w2c(0, 0, 1, 0);
    this.h3f_1 = new Float64Array(0);
  }
  s3f(p0, p1, p2, p3, t) {
    var out;
    // Inline function 'korlibs.math.geom.bezier.Companion.cubicCalc' call
    var x0 = p0.a2a_1;
    var y0 = p0.b2a_1;
    var x1 = p1.a2a_1;
    var y1 = p1.b2a_1;
    var x2 = p2.a2a_1;
    var y2 = p2.b2a_1;
    var cx = 3.0 * (x1 - x0);
    var bx = 3.0 * (x2 - x1) - cx;
    var ax = p3.a2a_1 - x0 - cx - bx;
    var cy = 3.0 * (y1 - y0);
    var by = 3.0 * (y2 - y1) - cy;
    var ay = p3.b2a_1 - y0 - cy - by;
    var tSquared = Ratio__times_impl_ucdh7y_0(t, t);
    var tCubed = Ratio__times_impl_ucdh7y_0(tSquared, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp = ax * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_0 = tmp + bx * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var x = tmp_0 + cx * _Ratio___get_value__impl__57cli6(t) + x0;
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_1 = ay * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_2 = tmp_1 + by * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var y = tmp_2 + cy * _Ratio___get_value__impl__57cli6(t) + y0;
    out = Vector2D.k2c(x, y);
    return out;
  }
  t3f(p, c, a, t) {
    var out;
    // Inline function 'korlibs.math.geom.bezier.Companion.quadCalc' call
    var x0 = p.a2a_1;
    var y0 = p.b2a_1;
    var xc = c.a2a_1;
    var yc = c.b2a_1;
    var x1 = a.a2a_1;
    var y1 = a.b2a_1;
    var t1 = 1 - Ratio__toDouble_impl_o7epze(t);
    var a_0 = t1 * t1;
    var c_0 = Ratio__times_impl_ucdh7y_0(t, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var b = 2 * t1 * _Ratio___get_value__impl__57cli6(t);
    var x = a_0 * x0 + b * xc + Ratio__times_impl_ucdh7y(c_0, x1);
    var y = a_0 * y0 + b * yc + Ratio__times_impl_ucdh7y(c_0, y1);
    out = Vector2D.k2c(x, y);
    return out;
  }
  u3f(a, b) {
    return a + (b - a) * (2.0 / 3.0);
  }
  v3f(a, b) {
    return b + (a - b) * (2.0 / 3.0);
  }
}
class Bezier {
  static b3g(points, dummy) {
    Companion_getInstance_8();
    var $this = createThis(this);
    $this.t3d_1 = points;
    if ($this.t3d_1.f1() > 4) {
      // Inline function 'kotlin.error' call
      var message = 'Only supports quad and cubic beziers';
      throw IllegalStateException.h5(toString(message));
    }
    var tmp = $this;
    tmp.u3d_1 = lazy(Bezier$aligned$delegate$lambda($this));
    var tmp_0 = $this;
    tmp_0.v3d_1 = lazy(Bezier$dpoints$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.w3d_1 = lazy(Bezier$direction$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.x3d_1 = lazy(Bezier$extrema$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.y3d_1 = lazy(Bezier$outerCircle$delegate$lambda($this));
    var tmp_4 = $this;
    tmp_4.z3d_1 = lazy(Bezier$boundingBox$delegate$lambda($this));
    var tmp_5 = $this;
    tmp_5.a3e_1 = lazy(Bezier$length$delegate$lambda($this));
    var tmp_6 = $this;
    tmp_6.b3e_1 = lazy(Bezier$lut$delegate$lambda($this));
    var tmp_7 = $this;
    tmp_7.c3e_1 = lazy(Bezier$isLinear$delegate$lambda($this));
    var tmp_8 = $this;
    tmp_8.d3e_1 = lazy(Bezier$isSimple$delegate$lambda($this));
    return $this;
  }
  static c3g() {
    Companion_getInstance_8();
    return this.d3g(Vector2D.v2e(0.0, 0.0), Vector2D.v2e(0.0, 0.0));
  }
  static d3g(p0, p1) {
    Companion_getInstance_8();
    return this.b3g(pointArrayListOf(p0, p1), Unit_instance);
  }
  static e3g(p0, p1, p2) {
    Companion_getInstance_8();
    return this.b3g(pointArrayListOf_0(p0, p1, p2), Unit_instance);
  }
  static f3g(p0, p1, p2, p3) {
    Companion_getInstance_8();
    return this.b3g(pointArrayListOf_1(p0, p1, p2, p3), Unit_instance);
  }
  static g3g(points) {
    Companion_getInstance_8();
    return this.b3g(points.u2v(), Unit_instance);
  }
  h3g(other, epsilon) {
    if (!(this.t3d_1.f1() === other.t3d_1.f1()))
      return false;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = until(0, this.t3d_1.f1());
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.h1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var inductionVariable = this_0.b2_1;
      var last = this_0.c2_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.math.geom.bezier.Bezier.isAlmostEquals.<anonymous>' call
          var it = element;
          if (!this.t3d_1.e1(it).d2l(other.t3d_1.e1(it), epsilon)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
         while (!(element === last));
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  cz(other, epsilon) {
    return this.h3g(other instanceof Bezier ? other : THROW_CCE(), epsilon);
  }
  k3f(t) {
    return this.i3g(t);
  }
  k3e() {
    return this.y3f();
  }
  j3g(m) {
    return _getBoundingBox(this, m);
  }
  a3d(t) {
    return this.i3g(t);
  }
  equals(other) {
    var tmp;
    if (other instanceof Bezier) {
      tmp = equals(this.t3d_1, other.t3d_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.t3d_1);
  }
  toString() {
    return 'Bezier(' + toString(this.t3d_1) + ')';
  }
  w3f() {
    return 2;
  }
  e3e() {
    return this.t3d_1.f1() - 1 | 0;
  }
  x3f() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v3d_1;
    dpoints$factory();
    return this_0.s1();
  }
  i3f() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x3d_1;
    extrema$factory();
    return this_0.s1();
  }
  k3g() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y3d_1;
    outerCircle$factory();
    return this_0.s1();
  }
  y3f() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z3d_1;
    boundingBox$factory();
    return this_0.s1();
  }
  a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a3e_1;
    length$factory_0();
    return this_0.s1();
  }
  l3g() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b3e_1;
    lut$factory();
    return this_0.s1();
  }
  p3e(length) {
    return this.l3g().t3g(length).n3g_1;
  }
  u3g(steps, out) {
    out.k3();
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance_6();
    var NS = (steps + 1 | 0) - 1 | 0;
    var NSd = NS;
    var start = true ? 0 : 1;
    var end = true ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.Bezier.getLUT.<anonymous>' call
        var t = toRatio_0(ratio);
        out.v3g(t, this.i3g(t));
      }
       while (!(n === end));
    return out;
  }
  a3g(steps, out, $super) {
    steps = steps === VOID ? 100 : steps;
    out = out === VOID ? CurveLUT.w3g(this, steps + 1 | 0) : out;
    return $super === VOID ? this.u3g(steps, out) : $super.u3g.call(this, steps, out);
  }
  x3g(point, out) {
    out.o3f_1 = this;
    if (this.t3d_1.f1() === 2) {
      var p0 = this.t3d_1.e1(0);
      var p1 = this.t3d_1.e1(1);
      return findNearestLine(this, point.a2a_1, point.b2a_1, p0.a2a_1, p0.b2a_1, p1.a2a_1, p1.b2a_1, out);
    }
    var LUT = this.l3g();
    var l = LUT.y3g();
    var closest = LUT.z3g(point);
    var mpos = closest.b3h_1;
    var t1 = (mpos - 1 | 0) / l;
    var t2 = (mpos + 1 | 0) / l;
    var step = 0.1 / l;
    var mdistSq = closest.a3h_1;
    var t = t1;
    var ft = t;
    mdistSq = mdistSq + 1;
    while (t < t2 + step) {
      var p = this.i3g(toRatio_0(t));
      var d = Companion_getInstance().s2b(point, p);
      if (d < mdistSq) {
        mdistSq = d;
        ft = t;
        out.l3f_1 = p;
      }
      t = t + step;
    }
    out.l3f_1 = this.i3g(toRatio_0(ft));
    out.m3f_1 = ft < 0 ? Companion_getInstance_6().mz_1 : ft > 1 ? Companion_getInstance_6().pz_1 : toRatio_0(ft);
    out.n3f_1 = mdistSq;
    return out;
  }
  c3h() {
    if (this.t3d_1.f1() < 4)
      return Companion_getInstance_8().h3f_1;
    var p = _get_aligned__7fjidv(this);
    var p1 = p.e1(1);
    var p2 = p.e1(2);
    var p3 = p.e1(3);
    var a = p2.a2a_1 * p1.b2a_1;
    var b = p3.a2a_1 * p1.b2a_1;
    var c = p1.a2a_1 * p2.b2a_1;
    var d = p3.a2a_1 * p2.b2a_1;
    var v1 = 18.0 * (-3.0 * a + 2.0 * b + 3.0 * c - d);
    var v2 = 18.0 * (3.0 * a - b - 3.0 * c);
    var v3 = 18.0 * (c - a);
    if (isAlmostZero(v1)) {
      if (!isAlmostZero(v2)) {
        var t = -v3 / v2;
        if (0.0 <= t ? t <= 1.0 : false) {
          // Inline function 'kotlin.doubleArrayOf' call
          return new Float64Array([t]);
        }
      }
      return Companion_getInstance_8().h3f_1;
    }
    var d2 = 2.0 * v1;
    if (isAlmostEquals_0(d2, 0.0))
      return Companion_getInstance_8().h3f_1;
    var trm = v2 * v2 - 4.0 * v1 * v3;
    if (trm < 0)
      return Companion_getInstance_8().h3f_1;
    // Inline function 'kotlin.math.sqrt' call
    var sq = Math.sqrt(trm);
    var out0 = (sq - v2) / d2;
    var out1 = -(v2 + sq) / d2;
    var out = DoubleArrayList.g2p(2);
    if (0.0 <= out0 ? out0 <= 1.0 : false) {
      out.t11(out0);
    }
    if (0.0 <= out1 ? out1 <= 1.0 : false) {
      out.t11(out1);
    }
    return out.tz();
  }
  i3g(t) {
    return compute(Companion_getInstance_8(), t, this.t3d_1);
  }
  d3h(t, normalize) {
    var out = compute(Companion_getInstance_8(), t, this.x3f().e1(0));
    if ((equals(t, Companion_getInstance_6().mz_1) || equals(t, Companion_getInstance_6().pz_1)) && isAlmostZero(out.z2k())) {
      var inductionVariable = 0;
      if (inductionVariable < 10)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.math.pow' call
          var n_0 = -(10 - n | 0) | 0;
          var newT = Math.pow(10.0, n_0);
          var nt = equals(t, Companion_getInstance_6().pz_1) ? 1.0 - newT : newT;
          out = compute(Companion_getInstance_8(), _Ratio___init__impl__9mwvn2(nt), this.x3f().e1(0));
          if (!isAlmostZero(out.z2k()))
            break $l$loop;
        }
         while (inductionVariable < 10);
    }
    if (normalize)
      out = out.b2l();
    return out;
  }
  z3f(t, normalize, $super) {
    normalize = normalize === VOID ? false : normalize;
    return $super === VOID ? this.d3h(t, normalize) : $super.d3h.call(this, new Ratio(t), normalize);
  }
  e3h(t, normalize) {
    return this.d3h(t, normalize).c2l();
  }
  c3d(t) {
    return this.e3h(t, true);
  }
  b3d(t) {
    return this.d3h(t, true);
  }
  f3h(t, out) {
    if (this.e3e() < 2)
      return null;
    var p = this.t3d_1;
    out.z2v(p, 0);
    out.z2v(p, 1);
    out.z2v(p, 2);
    if (this.e3e() === 3) {
      out.z2v(p, 3);
    }
    while (p.f1() > 1) {
      var next = new PointArrayList();
      var inductionVariable = 0;
      var last = p.f1() - 1 | 0;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var p_0 = interpolate(toRatio(t), p.e1(i), p.e1(i + 1 | 0));
          out.w2v(p_0);
          next.w2v(p_0);
        }
         while (inductionVariable < last);
      p = next;
    }
    return out;
  }
  g3h(t, out, $super) {
    out = out === VOID ? new PointArrayList() : out;
    return $super === VOID ? this.f3h(t, out) : $super.f3h.call(this, new Ratio(t), out);
  }
  r3e(t0, t1) {
    return SubBezier.h3h(this.w3e(t0).x3e(map(Companion_getInstance_8(), t1, t0, Companion_getInstance_6().pz_1, Companion_getInstance_6().mz_1, Companion_getInstance_6().pz_1)).s3e_1, t0, t1, this);
  }
  x3e(t) {
    return SubBezier.i3h(this).x3e(t);
  }
  w3e(t) {
    return SubBezier.i3h(this).w3e(t);
  }
  j3h() {
    return Line2D.t2c(this.t3d_1.e1(0), this.t3d_1.e1(this.e3e()));
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp_0 = new Int32Array([0, 3, 5]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$1 = new Int32Array([0, 4, 7, 9]);
    tmp.k3h_1 = listOf_0([null, null, tmp_0, tmp$ret$1]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp_2 = new Int32Array([5, 4, 2]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$3 = new Int32Array([9, 8, 6, 3]);
    tmp_1.l3h_1 = listOf_0([null, null, tmp_2, tmp$ret$3]);
  }
}
class SubBezier {
  static h3h(curve, t1, t2, parent) {
    Companion_getInstance_9();
    var $this = createThis(this);
    $this.s3e_1 = curve;
    $this.t3e_1 = t1;
    $this.u3e_1 = t2;
    $this.v3e_1 = parent;
    return $this;
  }
  static i3h(curve) {
    Companion_getInstance_9();
    return this.h3h(curve, Companion_getInstance_6().mz_1, Companion_getInstance_6().pz_1, null);
  }
  a3d(t) {
    return this.s3e_1.a3d(convertRange(t, this.t3e_1, this.u3e_1, Companion_getInstance_6().mz_1, Companion_getInstance_6().pz_1));
  }
  x3e(t) {
    return _splitLeft$default(this, t);
  }
  w3e(t) {
    return _splitRight$default(this, t);
  }
  toString() {
    return 'SubBezier[' + get_niceStr(Ratio__toDouble_impl_o7epze(this.t3e_1)) + '..' + get_niceStr(Ratio__toDouble_impl_o7epze(this.u3e_1)) + '](' + this.s3e_1.toString() + ')';
  }
}
class ClosestResult {
  constructor(mdistSq, mpos) {
    this.a3h_1 = mdistSq;
    this.b3h_1 = mpos;
  }
}
class Estimation {
  constructor(point, ratio, length) {
    point = point === VOID ? Vector2D.v2c() : point;
    ratio = ratio === VOID ? Companion_getInstance_6().mz_1 : ratio;
    length = length === VOID ? 0.0 : length;
    this.m3g_1 = point;
    this.n3g_1 = ratio;
    this.o3g_1 = length;
  }
  toString() {
    return 'Estimation(point=' + this.m3g_1.e2l() + ', ratio=' + get_niceStr_0(this.n3g_1) + ', length=' + get_niceStr(this.o3g_1) + ')';
  }
  hashCode() {
    var result = this.m3g_1.hashCode();
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.n3g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o3g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Estimation))
      return false;
    var tmp0_other_with_cast = other instanceof Estimation ? other : THROW_CCE();
    if (!this.m3g_1.equals(tmp0_other_with_cast.m3g_1))
      return false;
    if (!equals(this.n3g_1, tmp0_other_with_cast.n3g_1))
      return false;
    if (!equals(this.o3g_1, tmp0_other_with_cast.o3g_1))
      return false;
    return true;
  }
}
class CurveLUT {
  static o3h(curve, points, ts, _estimatedLengths) {
    var $this = createThis(this);
    $this.p3g_1 = curve;
    $this.q3g_1 = points;
    $this.r3g_1 = ts;
    $this.s3g_1 = _estimatedLengths;
    return $this;
  }
  static w3g(curve, capacity) {
    return this.o3h(curve, new PointArrayList(capacity), DoubleArrayList.g2p(capacity), DoubleArrayList.g2p(capacity));
  }
  n3h() {
    if (this.s3g_1.h1()) {
      this.s3g_1.t11(0.0);
    }
    while (this.s3g_1.f1() < this.f1()) {
      var pos = this.s3g_1.f1();
      var prev = last_0(this.s3g_1);
      this.s3g_1.t11(prev + Companion_getInstance().t2k(this.q3g_1.e1(pos - 1 | 0), this.q3g_1.e1(pos)));
    }
    return this.s3g_1;
  }
  y3g() {
    return this.q3g_1.f1() - 1 | 0;
  }
  f1() {
    return this.q3g_1.f1();
  }
  k3() {
    this.q3g_1.hh();
    this.r3g_1.k3();
    this.s3g_1.k3();
  }
  v3g(t, p) {
    this.q3g_1.w2v(p);
    this.r3g_1.t11(Ratio__toDouble_impl_o7epze(t));
  }
  z3g(point) {
    var mdistSq = Infinity;
    var mpos = 0;
    var inductionVariable = 0;
    var last = this.f1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var d = Companion_getInstance().s2b(this.q3g_1.e1(n), point);
        if (d < mdistSq) {
          mdistSq = d;
          mpos = n;
        }
      }
       while (inductionVariable < last);
    return new ClosestResult(mdistSq, mpos);
  }
  m3h(_this__u8e3s4, index, ratio) {
    var ratio0 = toRatio_0(this.r3g_1.e1(index));
    var length0 = this.n3h().e1(index);
    var point0 = this.q3g_1.e1(index);
    if (ratio === 0.0) {
      _this__u8e3s4.n3g_1 = ratio0;
      _this__u8e3s4.o3g_1 = length0;
      _this__u8e3s4.m3g_1 = point0;
    } else {
      var ratio1 = toRatio_0(this.r3g_1.e1(index + 1 | 0));
      var length1 = this.n3h().e1(index + 1 | 0);
      var point1 = this.q3g_1.e1(index + 1 | 0);
      _this__u8e3s4.n3g_1 = interpolate_0(toRatio_0(ratio), ratio0, ratio1);
      _this__u8e3s4.o3g_1 = interpolate_1(toRatio_0(ratio), length0, length1);
      _this__u8e3s4.m3g_1 = interpolate(toRatio_0(ratio), point0, point1);
    }
    return _this__u8e3s4;
  }
  p3h(length, out) {
    return estimateAt(this, this.n3h(), length, out);
  }
  t3g(length, out, $super) {
    out = out === VOID ? new Estimation() : out;
    return $super === VOID ? this.p3h(length, out) : $super.p3h.call(this, length, out);
  }
  toString() {
    var tmp = toString(this.p3g_1);
    var tmp_0 = until(0, this.f1());
    return 'CurveLUT[' + tmp + '](' + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, CurveLUT$toString$lambda(this)) + ')';
  }
  hashCode() {
    var result = hashCode(this.p3g_1);
    result = imul(result, 31) + this.q3g_1.hashCode() | 0;
    result = imul(result, 31) + this.r3g_1.hashCode() | 0;
    result = imul(result, 31) + this.s3g_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveLUT))
      return false;
    var tmp0_other_with_cast = other instanceof CurveLUT ? other : THROW_CCE();
    if (!equals(this.p3g_1, tmp0_other_with_cast.p3g_1))
      return false;
    if (!this.q3g_1.equals(tmp0_other_with_cast.q3g_1))
      return false;
    if (!this.r3g_1.equals(tmp0_other_with_cast.r3g_1))
      return false;
    if (!this.s3g_1.equals(tmp0_other_with_cast.s3g_1))
      return false;
    return true;
  }
}
class Arc {
  constructor() {
    this.q3h_1 = 0.5522847498307933;
    this.r3h_1 = 6.283185307179586;
  }
  s3h(out, center, r, start, end, counterclockwise) {
    var x = center.nl();
    var y = center.ol();
    var startAngle = _Angle___get_normalized__impl__9s30ys(start);
    var endAngle1 = _Angle___get_normalized__impl__9s30ys(end);
    var endAngle = Angle__compareTo_impl_a0hfds(endAngle1, startAngle) < 0 ? Angle__plus_impl_26v37k(endAngle1, Companion_getInstance_0().v29_1) : endAngle1;
    // Inline function 'korlibs.math.geom.min' call
    var a = Companion_getInstance_0().v29_1;
    // Inline function 'korlibs.math.geom.abs' call
    var angle = Angle__minus_impl_xeau7k(endAngle, startAngle);
    var b = _Angle___get_absoluteValue__impl__4qoakv(angle);
    // Inline function 'kotlin.math.min' call
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var a_0 = _Angle___get_radians__impl__n00yt5(a);
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var b_0 = _Angle___get_radians__impl__n00yt5(b);
    var tmp$ret$3 = Math.min(a_0, b_0);
    var remainingAngle = _Angle___init__impl__g23q1m(tmp$ret$3);
    if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_0().q29_1) < 0 && !equals(start, end))
      remainingAngle = Companion_getInstance_0().v29_1;
    var sgn1 = Angle__compareTo_impl_a0hfds(startAngle, endAngle) < 0 ? 1 : -1;
    var sgn = counterclockwise ? -sgn1 | 0 : sgn1;
    if (counterclockwise) {
      remainingAngle = Angle__minus_impl_xeau7k(Companion_getInstance_0().v29_1, remainingAngle);
      if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_0().q29_1) < 0 && !equals(start, end))
        remainingAngle = Companion_getInstance_0().v29_1;
    }
    var a1 = startAngle;
    var index = 0;
    while (Angle__compareTo_impl_a0hfds(remainingAngle, Companion_getInstance_0().q29_1) > 0) {
      var tmp = a1;
      // Inline function 'korlibs.math.geom.min' call
      var a_1 = remainingAngle;
      var b_1 = Companion_getInstance_0().s29_1;
      // Inline function 'kotlin.math.min' call
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var a_2 = _Angle___get_radians__impl__n00yt5(a_1);
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var b_2 = _Angle___get_radians__impl__n00yt5(b_1);
      var tmp$ret$7 = Math.min(a_2, b_2);
      var tmp$ret$8 = _Angle___init__impl__g23q1m(tmp$ret$7);
      var a2 = Angle__plus_impl_26v37k(tmp, Angle__times_impl_v3s9y2(tmp$ret$8, sgn));
      var a_3 = Angle__div_impl_ut2btd(Angle__minus_impl_xeau7k(a2, a1), 2.0);
      var x4 = r * _Angle___get_cosine__impl__vprvmu(a_3);
      var y4 = r * _Angle___get_sine__impl__15nmyi(a_3);
      var x1 = x4;
      var y1 = -y4;
      var f = 0.5522847498307933 * _Angle___get_tangent__impl__vushdy(a_3);
      var x2 = x1 + f * y4;
      var y2 = y1 + f * x4;
      var x3 = x2;
      var y3 = -y2;
      var ar = Angle__plus_impl_26v37k(a_3, a1);
      var cos_ar = _Angle___get_cosine__impl__vprvmu(ar);
      var sin_ar = _Angle___get_sine__impl__15nmyi(ar);
      if (index === 0) {
        out.t3h(Vector2D.k2c(x + r * _Angle___get_cosine__impl__vprvmu(a1), y + r * _Angle___get_sine__impl__15nmyi(a1)));
      }
      out.u3h(Vector2D.k2c(x + x2 * cos_ar - y2 * sin_ar, y + x2 * sin_ar + y2 * cos_ar), Vector2D.k2c(x + x3 * cos_ar - y3 * sin_ar, y + x3 * sin_ar + y3 * cos_ar), Vector2D.k2c(x + r * _Angle___get_cosine__impl__vprvmu(a2), y + r * _Angle___get_sine__impl__15nmyi(a2)));
      index = index + 1 | 0;
      var tmp_0 = remainingAngle;
      // Inline function 'korlibs.math.geom.abs' call
      var angle_0 = Angle__minus_impl_xeau7k(a2, a1);
      var tmp$ret$9 = _Angle___get_absoluteValue__impl__4qoakv(angle_0);
      remainingAngle = Angle__minus_impl_xeau7k(tmp_0, tmp$ret$9);
      a1 = a2;
    }
    if (equals(startAngle, endAngle) && !(index === 0)) {
      out.n6();
    }
  }
}
class Companion_1 {
  j3i(width, height, algo) {
    return new BinPacker(Size2D.f2i(width, height), algo);
  }
  k3i(width, height, algo) {
    return Companion_instance_1.j3i(width, height, algo);
  }
  l3i(width, height, algo, $super) {
    algo = algo === VOID ? MaxRects.n3i(width, height) : algo;
    return $super === VOID ? this.k3i(width, height, algo) : $super.k3i.call(this, width, height, algo);
  }
}
class ImageDoNotFitException extends Error {
  static s3i(width, height, packer) {
    var $this = createThis(this);
    setPropertiesToThrowableInstance($this, "Size '" + width + 'x' + height + "' doesn't fit in '" + packer.d2m() + 'x' + packer.e2m() + "'");
    captureStack($this, $this.r3i_1);
    $this.o3i_1 = width;
    $this.p3i_1 = height;
    $this.q3i_1 = packer;
    return $this;
  }
}
class BinPacker {
  constructor(size, algo) {
    algo = algo === VOID ? MaxRects.w3i(size) : algo;
    this.t3i_1 = size;
    this.u3i_1 = algo;
    this.v3i_1 = FastArrayList.q10();
  }
  d2m() {
    return this.t3i_1.f2b_1;
  }
  e2m() {
    return this.t3i_1.g2b_1;
  }
  v2v(width, height) {
    var tmp0_elvis_lhs = this.x3i(width, height);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw ImageDoNotFitException.s3i(width, height, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  x3i(width, height) {
    var tmp0_elvis_lhs = this.u3i_1.y3i(Size2D.f2i(width, height));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rect = tmp;
    // Inline function 'kotlin.collections.plusAssign' call
    this.v3i_1.h(rect);
    return rect;
  }
}
class MaxRects {
  static w3i(maxSize) {
    var $this = createThis(this);
    $this.m3i_1 = fastArrayListOf([Companion_getInstance_1().i2b(Companion_getInstance().c2a_1, maxSize)]);
    return $this;
  }
  static n3i(width, height) {
    return this.w3i(Size2D.f2i(width, height));
  }
  y3i(size) {
    return this.z3i(size);
  }
  z3i(size) {
    var width = size.nl();
    var height = size.ol();
    if (width <= 0.0 && height <= 0.0)
      return Companion_getInstance_1().z2h(0, 0, 0, 0);
    var newNode = quickFindPositionForNewNodeBestAreaFit(this, width, height);
    if (newNode.n2a_1 === 0.0)
      return null;
    var numRectanglesToProcess = this.m3i_1.f1();
    var i = 0;
    while (i < numRectanglesToProcess) {
      if (splitFreeNode(this, this.m3i_1.e1(i), newNode)) {
        this.m3i_1.p3(i);
        numRectanglesToProcess = numRectanglesToProcess - 1 | 0;
        i = i - 1 | 0;
      }
      i = i + 1 | 0;
    }
    pruneFreeList(this);
    return newNode;
  }
}
class Companion_2 {}
class HitTestDirection extends Enum {}
class Convex {
  i3i(curves) {
    var tmp0_elvis_lhs = toNonCurveSimplePointList(curves);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var points = tmp;
    return this.a3j(points);
  }
  a3j(vertices) {
    var base = 0;
    var n = vertices.f1();
    var TWO_PI = 3.141592653589793 * 2;
    if (n <= 3)
      return true;
    if (vertices.h2c(base) === vertices.h2c(n - 1 | 0) && vertices.i2c(base) === vertices.i2c(n - 1 | 0)) {
      n = n - 1 | 0;
    }
    var old_x = vertices.h2c(n - 2 | 0);
    var old_y = vertices.i2c(n - 2 | 0);
    var new_x = vertices.h2c(n - 1 | 0);
    var new_y = vertices.i2c(n - 1 | 0);
    // Inline function 'kotlin.math.atan2' call
    var y = new_y - old_y;
    var x = new_x - old_x;
    var new_direction = Math.atan2(y, x);
    var old_direction;
    var angle_sum = Companion_getInstance_0().r29_1;
    var orientation = 0.0;
    var inductionVariable = 0;
    var last = n;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        old_x = new_x;
        old_y = new_y;
        old_direction = new_direction;
        var _unary__edvuaz = base;
        base = _unary__edvuaz + 1 | 0;
        var p = _unary__edvuaz;
        new_x = vertices.h2c(p);
        new_y = vertices.i2c(p);
        // Inline function 'kotlin.math.atan2' call
        var y_0 = new_y - old_y;
        var x_0 = new_x - old_x;
        new_direction = Math.atan2(y_0, x_0);
        if (old_x === new_x && old_y === new_y) {
          return false;
        }
        var angle = new_direction - old_direction;
        if (angle <= -3.141592653589793)
          angle = angle + TWO_PI;
        else if (angle > 3.141592653589793)
          angle = angle - TWO_PI;
        if (i === 0) {
          if (angle === 0.0) {
            return false;
          }
          orientation = angle > 0 ? 1.0 : -1.0;
        } else if (orientation * angle < 0.0) {
          return false;
        }
        var tmp = angle_sum;
        // Inline function 'korlibs.math.geom.Companion.fromRadians' call
        Companion_getInstance_0();
        var radians = angle;
        var tmp$ret$2 = _Angle___init__impl__g23q1m(radians);
        angle_sum = Angle__plus_impl_26v37k(tmp, tmp$ret$2);
      }
       while (inductionVariable < last);
    return isAlmostEquals(Companion_getInstance_6().pz_1, _Ratio___get_absoluteValue__impl__92ozif(_Angle___get_ratio__impl__ap3on4(angle_sum)));
  }
}
class AbstractShape2D {}
class Companion_3 {
  constructor() {
    Companion_instance_3 = this;
    this.b3j_1 = values();
  }
  e1(index) {
    return this.b3j_1[umod(index, 4)];
  }
}
class SliceRotation extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.e3j_1 = imul(this.r3_1, 90);
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(8), null);
    while (tmp_0 < 8) {
      var tmp_2 = tmp_0;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var this_0 = new Int32Array([0, 1, 2, 3]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.slice.Companion.INDICES.<anonymous>' call
      var orientation = _SliceOrientation___init__impl__ewylib(tmp_2);
      if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
        swap(this_0, 0, 1);
        swap(this_0, 3, 2);
      }
      rotateRight(this_0, _SliceOrientation___get_rotation__impl__m65r0o(orientation).r3_1);
      tmp_1[tmp_2] = this_0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.f3j_1 = tmp_1;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(8), null);
    while (tmp_4 < 8) {
      var tmp_6 = tmp_4;
      var orientation_0 = _SliceOrientation___init__impl__ewylib(tmp_6);
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_1 = StringBuilder.f();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.slice.Companion.NAMES.<anonymous>' call
      this_1.bc(_SliceOrientation___get_flipX__impl__lgb7bx(orientation_0) ? 'MIRROR_HORIZONTAL_ROTATE_' : 'ROTATE_');
      this_1.ah(_SliceOrientation___get_rotation__impl__m65r0o(orientation_0).e3j_1);
      tmp_5[tmp_6] = this_1.toString();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.g3j_1 = tmp_5;
    var tmp_7 = this;
    var tmp39_rotation = SliceRotation_R0_getInstance();
    tmp_7.h3j_1 = _SliceOrientation___init__impl__ewylib_0(tmp39_rotation, false);
    var tmp_8 = this;
    var tmp40_rotation = SliceRotation_R90_getInstance();
    tmp_8.i3j_1 = _SliceOrientation___init__impl__ewylib_0(tmp40_rotation, false);
    var tmp_9 = this;
    var tmp41_rotation = SliceRotation_R180_getInstance();
    tmp_9.j3j_1 = _SliceOrientation___init__impl__ewylib_0(tmp41_rotation, false);
    var tmp_10 = this;
    var tmp42_rotation = SliceRotation_R270_getInstance();
    tmp_10.k3j_1 = _SliceOrientation___init__impl__ewylib_0(tmp42_rotation, false);
    this.l3j_1 = _SliceOrientation___init__impl__ewylib_0(VOID, true);
    var tmp_11 = this;
    var tmp43_rotation = SliceRotation_R90_getInstance();
    tmp_11.m3j_1 = _SliceOrientation___init__impl__ewylib_0(tmp43_rotation, true);
    var tmp_12 = this;
    var tmp44_rotation = SliceRotation_R180_getInstance();
    tmp_12.n3j_1 = _SliceOrientation___init__impl__ewylib_0(tmp44_rotation, true);
    var tmp_13 = this;
    var tmp45_rotation = SliceRotation_R270_getInstance();
    tmp_13.o3j_1 = _SliceOrientation___init__impl__ewylib_0(tmp45_rotation, true);
    this.p3j_1 = listOf_0([new SliceOrientation(this.h3j_1), new SliceOrientation(this.i3j_1), new SliceOrientation(this.j3j_1), new SliceOrientation(this.k3j_1), new SliceOrientation(this.l3j_1), new SliceOrientation(this.m3j_1), new SliceOrientation(this.n3j_1), new SliceOrientation(this.o3j_1)]);
  }
}
class SliceOrientation {
  constructor(raw) {
    Companion_getInstance_13();
    this.q3j_1 = raw;
  }
  toString() {
    return SliceOrientation__toString_impl_tdph6r(this.q3j_1);
  }
  hashCode() {
    return SliceOrientation__hashCode_impl_7mjkdw(this.q3j_1);
  }
  equals(other) {
    return SliceOrientation__equals_impl_h4gywg(this.q3j_1, other);
  }
}
class SliceCoords {}
function x(index) {
  switch (index) {
    case 0:
      return this.l3l();
    case 1:
      return this.n3l();
    case 2:
      return this.p3l();
    case 3:
      return this.r3l();
    default:
      return NaN;
  }
}
function y(index) {
  switch (index) {
    case 0:
      return this.m3l();
    case 1:
      return this.o3l();
    case 2:
      return this.q3l();
    case 3:
      return this.s3l();
    default:
      return NaN;
  }
}
class SliceCoordsWithBase {}
function get_frameOffsetX() {
  return this.c3l().g2d_1;
}
function get_frameOffsetY() {
  return this.c3l().d2d_1;
}
function get_frameWidth() {
  return this.d2m() + this.c3l().k2d() | 0;
}
function get_frameHeight() {
  return this.e2m() + this.c3l().l2d() | 0;
}
class SliceCoordsWithBaseAndRect {}
function get_left() {
  return this.b3l().r2a();
}
function get_top() {
  return this.b3l().t2a();
}
function get_right() {
  return this.b3l().s2a();
}
function get_bottom() {
  return this.b3l().u2a();
}
function get_area() {
  return this.b3l().l2j();
}
class RectSlice {
  constructor(base, rect, orientation, padding, name) {
    orientation = orientation === VOID ? Companion_getInstance_13().h3j_1 : orientation;
    padding = padding === VOID ? Companion_getInstance_3().c2d_1 : padding;
    name = name === VOID ? null : name;
    this.r3j_1 = base;
    this.s3j_1 = rect;
    this.t3j_1 = orientation;
    this.u3j_1 = padding;
    this.v3j_1 = name;
    this.w3j_1 = this.r3j_1.f1().l2k_1;
    this.x3j_1 = this.r3j_1.f1().m2k_1;
    this.y3j_1 = this.s3j_1.v2i_1;
    this.z3j_1 = this.s3j_1.w2i_1;
    this.a3k_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.t3j_1) ? this.s3j_1.v2i_1 : this.s3j_1.w2i_1;
    this.b3k_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.t3j_1) ? this.s3j_1.w2i_1 : this.s3j_1.v2i_1;
    this.c3k_1 = this.a3k_1 + this.u3j_1.k2d() | 0;
    this.d3k_1 = this.b3k_1 + this.u3j_1.l2d() | 0;
    this.e3k_1 = this.s3j_1.r2a() / this.w3j_1;
    this.f3k_1 = this.s3j_1.s2a() / this.w3j_1;
    this.g3k_1 = this.s3j_1.t2a() / this.x3j_1;
    this.h3k_1 = this.s3j_1.u2a() / this.x3j_1;
    this.i3k_1 = new RectCoords(this.e3k_1, this.g3k_1, this.f3k_1, this.g3k_1, this.f3k_1, this.h3k_1, this.e3k_1, this.h3k_1);
    this.j3k_1 = transformed_1(this.i3k_1, this.t3j_1);
    this.k3k_1 = this.j3k_1.s3k_1;
    this.l3k_1 = this.j3k_1.t3k_1;
    this.m3k_1 = this.j3k_1.u3k_1;
    this.n3k_1 = this.j3k_1.v3k_1;
    this.o3k_1 = this.j3k_1.w3k_1;
    this.p3k_1 = this.j3k_1.x3k_1;
    this.q3k_1 = this.j3k_1.y3k_1;
    this.r3k_1 = this.j3k_1.z3k_1;
  }
  a3l() {
    return this.r3j_1;
  }
  b3l() {
    return this.s3j_1;
  }
  c3l() {
    return this.u3j_1;
  }
  d2m() {
    return this.a3k_1;
  }
  e2m() {
    return this.b3k_1;
  }
  d3l() {
    return this.c3k_1;
  }
  e3l() {
    return this.d3k_1;
  }
  f3l(left, top, right, bottom, name, clamped, orientation) {
    var tmp = this.s3j_1.m2j(left, top, right, bottom, clamped);
    return new RectSlice(this.r3j_1, tmp, orientation, this.u3j_1, name == null ? this.v3j_1 : name);
  }
  g3l(left, top, right, bottom, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.t3j_1 : orientation;
    return $super === VOID ? this.f3l(left, top, right, bottom, name, clamped, orientation) : $super.f3l.call(this, left, top, right, bottom, name, clamped, new SliceOrientation(orientation));
  }
  h3l(x, y, width, height, name, clamped, orientation) {
    return this.f3l(x, y, x + width | 0, y + height | 0, name, clamped, orientation);
  }
  i3l(x, y, width, height, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.t3j_1 : orientation;
    return $super === VOID ? this.h3l(x, y, width, height, name, clamped, orientation) : $super.h3l.call(this, x, y, width, height, name, clamped, new SliceOrientation(orientation));
  }
  j3l(rect, name, clamped, orientation) {
    return this.f3l(rect.r2a(), rect.t2a(), rect.s2a(), rect.u2a(), name, clamped, orientation);
  }
  k3l(rect, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.t3j_1 : orientation;
    return $super === VOID ? this.j3l(rect, name, clamped, orientation) : $super.j3l.call(this, rect, name, clamped, new SliceOrientation(orientation));
  }
  l3l() {
    return this.k3k_1;
  }
  m3l() {
    return this.l3k_1;
  }
  n3l() {
    return this.m3k_1;
  }
  o3l() {
    return this.n3k_1;
  }
  p3l() {
    return this.o3k_1;
  }
  q3l() {
    return this.p3k_1;
  }
  r3l() {
    return this.q3k_1;
  }
  s3l() {
    return this.r3k_1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.slice.RectSlice.toString.<anonymous>' call
    this_0.bc('RectSlice(');
    this_0.bc(this.v3j_1);
    this_0.bc(':');
    this_0.ac(this.s3j_1);
    if (!(this.t3j_1 === Companion_getInstance_13().h3j_1)) {
      this_0.bc(':');
      this_0.ac(new SliceOrientation(this.t3j_1));
    }
    if (this.u3j_1.j2d()) {
      this_0.bc(':');
      this_0.ac(this.u3j_1);
    }
    this_0.bc(')');
    return this_0.toString();
  }
  hashCode() {
    var result = hashCode(this.r3j_1);
    result = imul(result, 31) + this.s3j_1.hashCode() | 0;
    result = imul(result, 31) + SliceOrientation__hashCode_impl_7mjkdw(this.t3j_1) | 0;
    result = imul(result, 31) + this.u3j_1.hashCode() | 0;
    result = imul(result, 31) + (this.v3j_1 == null ? 0 : getStringHashCode(this.v3j_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectSlice))
      return false;
    var tmp0_other_with_cast = other instanceof RectSlice ? other : THROW_CCE();
    if (!equals(this.r3j_1, tmp0_other_with_cast.r3j_1))
      return false;
    if (!this.s3j_1.equals(tmp0_other_with_cast.s3j_1))
      return false;
    if (!(this.t3j_1 === tmp0_other_with_cast.t3j_1))
      return false;
    if (!this.u3j_1.equals(tmp0_other_with_cast.u3j_1))
      return false;
    if (!(this.v3j_1 == tmp0_other_with_cast.v3j_1))
      return false;
    return true;
  }
}
class Companion_5 {
  x3l(base, coords, name, flippedWidthHeight) {
    return new SliceCoordsImpl(base, coords, name, flippedWidthHeight);
  }
  y3l(base, coords, name, flippedWidthHeight, $super) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    return $super === VOID ? this.x3l(base, coords, name, flippedWidthHeight) : $super.x3l.call(this, base, coords, name, flippedWidthHeight);
  }
}
class SliceCoordsImpl {
  constructor(base, coords, name, flippedWidthHeight) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    this.z3l_1 = base;
    this.a3m_1 = coords;
    this.b3m_1 = name;
    this.c3m_1 = flippedWidthHeight;
    this.d3m_1 = Companion_getInstance_3().c2d_1;
    this.e3m_1 = !this.c3m_1 ? this.z3l_1.f1().l2k_1 : this.z3l_1.f1().m2k_1;
    this.f3m_1 = !this.c3m_1 ? this.z3l_1.f1().m2k_1 : this.z3l_1.f1().l2k_1;
    this.g3m_1 = numberToInt(Companion_getInstance().r2k(this.a3m_1.l3l(), this.a3m_1.m3l(), this.a3m_1.n3l(), this.a3m_1.o3l()) * this.e3m_1);
    this.h3m_1 = numberToInt(Companion_getInstance().r2k(this.a3m_1.l3l(), this.a3m_1.m3l(), this.a3m_1.r3l(), this.a3m_1.s3l()) * this.f3m_1);
    this.i3m_1 = this.g3m_1 + this.d3m_1.k2d() | 0;
    this.j3m_1 = this.h3m_1 + this.d3m_1.l2d() | 0;
  }
  a3l() {
    return this.z3l_1;
  }
  c3l() {
    return this.d3m_1;
  }
  d2m() {
    return this.g3m_1;
  }
  e2m() {
    return this.h3m_1;
  }
  d3l() {
    return this.i3m_1;
  }
  e3l() {
    return this.j3m_1;
  }
  l3l() {
    return this.a3m_1.l3l();
  }
  m3l() {
    return this.a3m_1.m3l();
  }
  n3l() {
    return this.a3m_1.n3l();
  }
  o3l() {
    return this.a3m_1.o3l();
  }
  p3l() {
    return this.a3m_1.p3l();
  }
  q3l() {
    return this.a3m_1.q3l();
  }
  r3l() {
    return this.a3m_1.r3l();
  }
  s3l() {
    return this.a3m_1.s3l();
  }
  toString() {
    return 'SliceCoordsImpl(base=' + toString(this.z3l_1) + ', coords=' + toString(this.a3m_1) + ', name=' + this.b3m_1 + ', flippedWidthHeight=' + this.c3m_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.z3l_1);
    result = imul(result, 31) + hashCode(this.a3m_1) | 0;
    result = imul(result, 31) + (this.b3m_1 == null ? 0 : getStringHashCode(this.b3m_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c3m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SliceCoordsImpl))
      return false;
    var tmp0_other_with_cast = other instanceof SliceCoordsImpl ? other : THROW_CCE();
    if (!equals(this.z3l_1, tmp0_other_with_cast.z3l_1))
      return false;
    if (!equals(this.a3m_1, tmp0_other_with_cast.a3m_1))
      return false;
    if (!(this.b3m_1 == tmp0_other_with_cast.b3m_1))
      return false;
    if (!(this.c3m_1 === tmp0_other_with_cast.c3m_1))
      return false;
    return true;
  }
}
class RectCoords {
  constructor(tlX, tlY, trX, trY, brX, brY, blX, blY) {
    this.s3k_1 = tlX;
    this.t3k_1 = tlY;
    this.u3k_1 = trX;
    this.v3k_1 = trY;
    this.w3k_1 = brX;
    this.x3k_1 = brY;
    this.y3k_1 = blX;
    this.z3k_1 = blY;
  }
  l3l() {
    return this.s3k_1;
  }
  m3l() {
    return this.t3k_1;
  }
  n3l() {
    return this.u3k_1;
  }
  o3l() {
    return this.v3k_1;
  }
  p3l() {
    return this.w3k_1;
  }
  q3l() {
    return this.x3k_1;
  }
  r3l() {
    return this.y3k_1;
  }
  s3l() {
    return this.z3k_1;
  }
  toString() {
    return 'RectCoords(tlX=' + this.s3k_1 + ', tlY=' + this.t3k_1 + ', trX=' + this.u3k_1 + ', trY=' + this.v3k_1 + ', brX=' + this.w3k_1 + ', brY=' + this.x3k_1 + ', blX=' + this.y3k_1 + ', blY=' + this.z3k_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.s3k_1);
    result = imul(result, 31) + getNumberHashCode(this.t3k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u3k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v3k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w3k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x3k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y3k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z3k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCoords))
      return false;
    var tmp0_other_with_cast = other instanceof RectCoords ? other : THROW_CCE();
    if (!equals(this.s3k_1, tmp0_other_with_cast.s3k_1))
      return false;
    if (!equals(this.t3k_1, tmp0_other_with_cast.t3k_1))
      return false;
    if (!equals(this.u3k_1, tmp0_other_with_cast.u3k_1))
      return false;
    if (!equals(this.v3k_1, tmp0_other_with_cast.v3k_1))
      return false;
    if (!equals(this.w3k_1, tmp0_other_with_cast.w3k_1))
      return false;
    if (!equals(this.x3k_1, tmp0_other_with_cast.x3k_1))
      return false;
    if (!equals(this.y3k_1, tmp0_other_with_cast.y3k_1))
      return false;
    if (!equals(this.z3k_1, tmp0_other_with_cast.z3k_1))
      return false;
    return true;
  }
}
class Bucket {
  constructor() {
    this.k3m_1 = FastArrayList.q10();
  }
  hh() {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.Bucket.clear.<anonymous>' call
    this.k3m_1.k3();
    return this;
  }
}
class Buckets {
  constructor(pool, ySize) {
    this.l3m_1 = pool;
    this.m3m_1 = ySize;
    this.n3m_1 = FastIntMap();
  }
  f1() {
    return get_size(this.n3m_1);
  }
  o3m(y) {
    return y / this.m3m_1 | 0;
  }
  p3m(index) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.n3m_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(index);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.math.geom.vector.Buckets.getForIndex.<anonymous>' call
      var out = this.l3m_1.z2t();
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(index, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  q3m(y) {
    // Inline function 'korlibs.datastructure.get' call
    var this_0 = this.n3m_1;
    var key = this.o3m(y);
    // Inline function 'kotlin.js.asDynamic' call
    return this_0.get(key);
  }
  k3() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.n3m_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.math.geom.vector.Buckets.clear.<anonymous>' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this_0.get(it);
      var value = ensureNotNull(tmp$ret$2);
      this.l3m_1.a2u(value.hh());
    }
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.n3m_1.clear();
  }
  r3m(edge, threshold) {
    var min = this.o3m(edge.c3n());
    var max = this.o3m(edge.d3n());
    if ((max - min | 0) < threshold) {
      var inductionVariable = min;
      if (inductionVariable <= max)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.p3m(n).k3m_1.h(edge);
        }
         while (!(n === max));
      return true;
    }
    return false;
  }
  e3n(edge, threshold, $super) {
    threshold = threshold === VOID ? 2147483647 : threshold;
    return $super === VOID ? this.r3m(edge, threshold) : $super.r3m.call(this, edge, threshold);
  }
}
class AllBuckets {
  constructor() {
    var tmp = this;
    var tmp_0 = PolygonScanline$AllBuckets$pool$lambda;
    tmp.f3n_1 = Pool.w2t(tmp_0, VOID, PolygonScanline$AllBuckets$pool$lambda_0);
    this.g3n_1 = new Buckets(this.f3n_1, 80);
    this.h3n_1 = new Buckets(this.f3n_1, 320);
    this.i3n_1 = new Buckets(this.f3n_1, 1280);
  }
  j3n(edge) {
    if (this.g3n_1.r3m(edge, 4))
      return Unit_instance;
    if (this.h3n_1.r3m(edge, 4))
      return Unit_instance;
    this.i3n_1.e3n(edge);
  }
  k3() {
    this.g3n_1.k3();
    this.h3n_1.k3();
    this.i3n_1.k3();
  }
}
class XWithWind {
  constructor() {
    this.e3o_1 = IntArrayList.m2o(1024);
    this.f3o_1 = IntArrayList.m2o(1024);
  }
  f1() {
    return this.e3o_1.f1();
  }
  g3o(x, wind) {
    this.e3o_1.s2o(x);
    this.f3o_1.s2o(wind);
  }
  k3() {
    this.e3o_1.k3();
    this.f3o_1.k3();
  }
  toString() {
    return 'XWithWind(' + this.e3o_1.toString() + ', ' + this.f3o_1.toString() + ')';
  }
}
class IntArrayListSort extends SortOps {
  constructor() {
    IntArrayListSort_instance = null;
    super();
    IntArrayListSort_instance = this;
  }
  h3o(subject, l, r) {
    return compareTo(subject.e3o_1.sz(l), subject.e3o_1.sz(r));
  }
  v2p(subject, l, r) {
    return this.h3o(subject instanceof XWithWind ? subject : THROW_CCE(), l, r);
  }
  i3o(subject, indexL, indexR) {
    subject.e3o_1.b2p(indexL, indexR);
    subject.f3o_1.b2p(indexL, indexR);
  }
  x2p(subject, indexL, indexR) {
    return this.i3o(subject instanceof XWithWind ? subject : THROW_CCE(), indexL, indexR);
  }
}
class RastScale {
  u3o() {
    return 20;
  }
  v3o() {
    return 0;
  }
  c3o(_this__u8e3s4) {
    return numberToInt(_this__u8e3s4 * this.u3o()) + this.v3o() | 0;
  }
}
class PolygonScanline extends RastScale {
  constructor() {
    super();
    this.k3n_1 = -1;
    this.l3n_1 = Winding_NON_ZERO_getInstance();
    this.m3n_1 = Companion_getInstance_4().a2b();
    var tmp = this;
    tmp.n3n_1 = Pool.x2t(VOID, PolygonScanline$edgesPool$lambda);
    this.o3n_1 = FastArrayList.q10();
    this.p3n_1 = FastArrayList.q10();
    this.q3n_1 = FastArrayList.q10();
    this.r3n_1 = new AllBuckets();
    this.s3n_1 = true;
    this.t3n_1 = new PointArrayList();
    this.u3n_1 = 0.0;
    this.v3n_1 = 0.0;
    this.w3n_1 = 0.0;
    this.x3n_1 = 0.0;
    this.y3n_1 = false;
    this.z3n_1 = new XWithWind();
    this.a3o_1 = 0;
    this.b3o_1 = new IntSegmentSet();
  }
  k3e() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(this.m3n_1);
  }
  p2u() {
    this.s3n_1 = true;
    this.m3n_1 = Companion_getInstance_4().v2a_1;
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.o3n_1.o10_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.math.geom.vector.PolygonScanline.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.n3n_1.a2u(it);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.p3n_1.o10_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.math.geom.vector.PolygonScanline.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it_0 = array_0[_unary__edvuaz_0];
      this.n3n_1.a2u(it_0);
    }
    this.o3n_1.k3();
    this.p3n_1.k3();
    this.q3n_1.k3();
    this.t3n_1.hh();
    this.r3n_1.k3();
    this.u3n_1 = 0.0;
    this.v3n_1 = 0.0;
    this.w3n_1 = 0.0;
    this.x3n_1 = 0.0;
    this.y3n_1 = false;
  }
  j3o() {
    return this.o3n_1.f1();
  }
  l2c() {
    return this.j3o() > 0;
  }
  k3o(x, y) {
    this.w3n_1 = x;
    this.x3n_1 = y;
    this.u3n_1 = x;
    this.v3n_1 = y;
    this.y3n_1 = true;
  }
  l3o(x, y) {
    if (this.y3n_1) {
      addPoint(this, this.w3n_1, this.x3n_1);
    }
    addEdge(this, this.w3n_1, this.x3n_1, x, y);
    addPoint(this, x, y);
    this.w3n_1 = x;
    this.x3n_1 = y;
    this.y3n_1 = false;
  }
  t3h(p) {
    return this.k3o(p.a2a_1, p.b2a_1);
  }
  g3i(p) {
    return this.l3o(p.a2a_1, p.b2a_1);
  }
  m3o(path) {
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.v2c();
    var l = Vector2D.v2c();
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
    if (false) {
      this.n6();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.w3h_1;
    var n_0 = 0;
    while (n_0 < this_0.f1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.sz(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.x3h_1.e1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.k2c(tmp, path.x3h_1.e1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          this.n3o(it, true);
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.x3h_1.e1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.k2c(tmp_0, path.x3h_1.e1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          this.n3o(it_0, false);
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.x3h_1.e1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.k2c(tmp_1, path.x3h_1.e1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.x3h_1.e1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.k2c(tmp_2, path.x3h_1.e1(_unary__edvuaz_7));
          var sum = Companion_getInstance().t2k(l, c) + Companion_getInstance().t2k(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos = {_v: Vector2D.v2c()};
          var prevPos = {_v: Vector2D.v2c()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_6().mz_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos._v = Companion_getInstance_8().t3f(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_8().t3f(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
              this.n3o(it_1, false);
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.x3h_1.e1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.k2c(tmp_3, path.x3h_1.e1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.x3h_1.e1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.k2c(tmp_4, path.x3h_1.e1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.x3h_1.e1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.k2c(tmp_5, path.x3h_1.e1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance().t2k(l, c0) + Companion_getInstance().t2k(c0, c1) + Companion_getInstance().t2k(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_0 = {_v: Vector2D.v2c()};
          var prevPos_0 = {_v: Vector2D.v2c()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_6().mz_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_8().s3f(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_8().s3f(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
              this.n3o(it_2, false);
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_0._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          var p = i;
          this.n3o(p, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          if (true) {
            this.n6();
          }

          break;
      }
    }
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
    if (false) {
      this.n6();
    }
  }
  n3o(p, move) {
    var tmp;
    if (move) {
      this.t3h(p);
      tmp = Unit_instance;
    } else {
      this.g3i(p);
      tmp = Unit_instance;
    }
    return tmp;
  }
  o3o(x, y, move) {
    var tmp;
    if (move) {
      this.k3o(x, y);
      tmp = Unit_instance;
    } else {
      this.l3o(x, y);
      tmp = Unit_instance;
    }
    return tmp;
  }
  n6() {
    this.l3o(this.u3n_1, this.v3n_1);
  }
  p3o(y, winding, out) {
    this.a3o_1 = 0;
    this.z3n_1.k3();
    out.hh();
    var tmp = this;
    var tmp_0 = this.a3o_1;
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY' call
    var edgesChecked = 0;
    // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY' call
    var this_0 = this.r3n_1;
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_1 = this_0.g3n_1;
    if (this_1.f1() > 0) {
      var tmp47_safe_receiver = this_1.q3m(y);
      if (tmp47_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = tmp47_safe_receiver.k3m_1.o10_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge = array[_unary__edvuaz];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge.r3o(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge.z3m_1) {
              this.z3n_1.g3o(edge.q3o(y), edge.w3m_1);
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_2 = this_0.h3n_1;
    if (this_2.f1() > 0) {
      var tmp47_safe_receiver_0 = this_2.q3m(y);
      if (tmp47_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp47_safe_receiver_0.k3m_1.o10_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge_0 = array_0[_unary__edvuaz_0];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge_0.r3o(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge_0.z3m_1) {
              this.z3n_1.g3o(edge_0.q3o(y), edge_0.w3m_1);
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_3 = this_0.i3n_1;
    if (this_3.f1() > 0) {
      var tmp47_safe_receiver_1 = this_3.q3m(y);
      if (tmp47_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_1 = tmp47_safe_receiver_1.k3m_1.o10_1;
        var n_1 = 0;
        while (n_1 < array_1.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge_1 = array_1[_unary__edvuaz_1];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge_1.r3o(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge_1.z3m_1) {
              this.z3n_1.g3o(edge_1.q3o(y), edge_1.w3m_1);
            }
          }
        }
      }
    }
    tmp.a3o_1 = tmp_0 + edgesChecked | 0;
    genericSort(this.z3n_1, 0, this.z3n_1.f1() - 1 | 0, IntArrayListSort_getInstance());
    var tempX = this.z3n_1.e3o_1;
    var tempW = this.z3n_1.f3o_1;
    if (this.z3n_1.f1() >= 2) {
      switch (winding.r3_1) {
        case 0:
          var progression = step(until(0, tempX.f1() - 1 | 0), 2);
          var inductionVariable = progression.b2_1;
          var last = progression.c2_1;
          var step_0 = progression.d2_1;
          if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + step_0 | 0;
              var a = tempX.sz(i);
              var b = tempX.sz(i + 1 | 0);
              out.l2w(a, b);
            }
             while (!(i === last));
          break;
        case 1:
          var count = 0;
          var startX = 0;
          var endX = 0;
          var pending = false;
          var inductionVariable_0 = 0;
          var last_0 = tempX.f1() - 1 | 0;
          if (inductionVariable_0 < last_0)
            do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var a_0 = tempX.sz(i_0);
              count = count + tempW.sz(i_0) | 0;
              var b_0 = tempX.sz(i_0 + 1 | 0);
              if (!(count === 0)) {
                if (pending && !(a_0 === endX)) {
                  out.l2w(startX, endX);
                  startX = a_0;
                  endX = b_0;
                } else {
                  if (!pending) {
                    startX = a_0;
                  }
                  endX = b_0;
                }
                pending = true;
              }
            }
             while (inductionVariable_0 < last_0);
          if (pending) {
            out.l2w(startX, endX);
          }

          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
    return out;
  }
  s3o(x, y, winding) {
    return this.t3o(this.c3o(x), this.c3o(y), winding);
  }
  t3o(x, y, winding) {
    var ss = this.b3o_1;
    this.p3o(y, winding, ss.hh());
    return ss.hp(x);
  }
}
class Companion_6 {
  constructor() {
    this.w3o_1 = 20;
    this.x3o_1 = 0;
    this.y3o_1 = 80;
    this.z3o_1 = 320;
    this.a3p_1 = 1280;
  }
}
class Companion_7 {
  b3p(a, b) {
    // Inline function 'korlibs.math.geom.vector.Companion._getIntersectXY' call
    var Ax = a.s3m_1;
    var Ay = a.t3m_1;
    var Bx = a.u3m_1;
    var By = a.v3m_1;
    var Cx = b.s3m_1;
    var Cy = b.t3m_1;
    var Dx = b.u3m_1;
    var Dy = b.v3m_1;
    var tmp52_safe_receiver = this.c3p(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy);
    var tmp;
    if (tmp52_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.vector.Companion._getIntersectXY.<anonymous>' call
      tmp = Vector2I.j2j(numberToInt(floorCeil(tmp52_safe_receiver.a2a_1)), numberToInt(floorCeil(tmp52_safe_receiver.b2a_1)));
    }
    var tmp51_safe_receiver = tmp;
    var tmp_0;
    if (tmp51_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.vector.Companion.getIntersectXY.<anonymous>' call
      tmp_0 = Vector2D.x2c(tmp51_safe_receiver.g2j_1, tmp51_safe_receiver.h2j_1);
    }
    return tmp_0;
  }
  d3p(a, b) {
    return Angle__minus_impl_xeau7k(b.e3p(), a.e3p());
  }
  c3p(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    return Companion_instance_15.c3p(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy);
  }
}
class MEdge {
  constructor() {
    this.s3m_1 = 0;
    this.t3m_1 = 0;
    this.u3m_1 = 0;
    this.v3m_1 = 0;
    this.w3m_1 = 0;
    this.x3m_1 = 0;
    this.y3m_1 = 0;
    this.z3m_1 = false;
    this.a3n_1 = false;
    this.b3n_1 = 0;
  }
  h2c(n) {
    return n === 0 ? this.s3m_1 : this.u3m_1;
  }
  i2c(n) {
    return n === 0 ? this.t3m_1 : this.v3m_1;
  }
  f3p(other) {
    return this.d3o(other.s3m_1, other.t3m_1, other.u3m_1, other.v3m_1, other.w3m_1);
  }
  d3o(ax, ay, bx, by, wind) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.MEdge.setTo.<anonymous>' call
    this.s3m_1 = ax;
    this.t3m_1 = ay;
    this.u3m_1 = bx;
    this.v3m_1 = by;
    this.y3m_1 = bx - ax | 0;
    this.x3m_1 = by - ay | 0;
    this.z3m_1 = ay === by;
    this.a3n_1 = ax === bx;
    this.w3m_1 = wind;
    this.b3n_1 = this.a3n_1 ? 0 : ay - (imul(ax, this.x3m_1) / this.y3m_1 | 0) | 0;
    return this;
  }
  c3n() {
    // Inline function 'kotlin.math.min' call
    var a = this.t3m_1;
    var b = this.v3m_1;
    return Math.min(a, b);
  }
  d3n() {
    // Inline function 'kotlin.math.max' call
    var a = this.t3m_1;
    var b = this.v3m_1;
    return Math.max(a, b);
  }
  r3o(y) {
    return y >= this.t3m_1 && y < this.v3m_1;
  }
  q3o(y) {
    return this.a3n_1 || this.x3m_1 === 0 ? this.s3m_1 : imul(y - this.b3n_1 | 0, this.y3m_1) / this.x3m_1 | 0;
  }
  e3p() {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var x0 = this.s3m_1;
    var y0 = this.t3m_1;
    var x1 = this.u3m_1;
    var y1 = this.v3m_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var up = Companion_getInstance().g2a_1;
    return Angle_between(x0, y0, x1, y1, up);
  }
  toString() {
    return 'Edge([' + this.s3m_1 + ',' + this.t3m_1 + ']-[' + this.u3m_1 + ',' + this.v3m_1 + '])';
  }
}
class EdgePoint extends Enum {
  constructor(name, ordinal, n) {
    super(name, ordinal);
    this.z3p_1 = n;
  }
}
class StrokeToFill {
  constructor() {
    this.g3p_1 = 1;
    this.i3p_1 = LineCap_BUTT_getInstance();
    this.j3p_1 = LineCap_BUTT_getInstance();
    this.k3p_1 = LineJoin_BEVEL_getInstance();
    this.l3p_1 = 4.0;
    this.m3p_1 = new PointIntArrayList(1024);
    this.n3p_1 = IntArrayList.m2o(1024);
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(2), null);
    while (tmp_0 < 2) {
      tmp_1[tmp_0] = new PointIntArrayList(1024);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.o3p_1 = tmp_1;
    this.p3p_1 = this.o3p_1[0];
    this.q3p_1 = this.o3p_1[1];
    this.r3p_1 = new MEdge();
    this.s3p_1 = new MEdge();
    this.t3p_1 = new MEdge();
    this.u3p_1 = new MEdge();
    this.v3p_1 = new MEdge();
    this.w3p_1 = new MEdge();
  }
  a3q(_this__u8e3s4, edge, width, angle) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.setEdgeDisplaced.<anonymous>' call
    var ldx = width * _Angle___get_cosine__impl__vprvmu(angle);
    var ldy = width * _Angle___get_sine__impl__15nmyi(angle);
    _this__u8e3s4.d3o(numberToInt(edge.s3m_1 + ldx), numberToInt(edge.t3m_1 + ldy), numberToInt(edge.u3m_1 + ldx), numberToInt(edge.v3m_1 + ldy), edge.w3m_1);
    return _this__u8e3s4;
  }
  b3q(_this__u8e3s4, e) {
    return _this__u8e3s4.l2w(e.s3m_1, e.t3m_1);
  }
  c3q(_this__u8e3s4, e) {
    return _this__u8e3s4.l2w(e.u3m_1, e.v3m_1);
  }
  d3q(_this__u8e3s4, e) {
    _this__u8e3s4.l2w(numberToInt(e.a2a_1), numberToInt(e.b2a_1));
  }
  e3q(out, mainPrev, mainCurr, prev, curr, join, miterLimit, scale, forcedMiter) {
    var rjoin = forcedMiter ? LineJoin_MITER_getInstance() : join;
    switch (rjoin.r3_1) {
      case 2:
        var intersection2 = Vector2D.x2c(mainPrev.u3m_1, mainPrev.v3m_1);
        var intersection = Companion_instance_7.b3p(prev, curr);
        if (!(intersection == null)) {
          var dist = Companion_getInstance().t2k(intersection, intersection2);
          if (forcedMiter || dist <= miterLimit) {
            out.m2w(toInt(intersection));
          } else {
            this.c3q(out, prev);
            this.b3q(out, curr);
          }
        }

        break;
      case 0:
        this.c3q(out, prev);
        this.b3q(out, curr);
        break;
      case 1:
        var i = Companion_instance_7.b3p(prev, curr);
        if (!(i == null)) {
          var count = clamp_0(numberToInt(Companion_getInstance().s2k(prev.u3m_1, prev.v3m_1, curr.s3m_1, curr.t3m_1) * scale), 4, 64);
          var inductionVariable = 0;
          if (inductionVariable <= count)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              this.d3q(out, Companion_getInstance_8().t3f(Vector2D.k2c(prev.u3m_1, prev.v3m_1), Vector2D.k2c(i.a2a_1, i.b2a_1), Vector2D.k2c(curr.s3m_1, curr.t3m_1), _Ratio___init__impl__9mwvn2(n / count)));
            }
             while (!(n === count));
        } else {
          this.c3q(out, prev);
          this.b3q(out, curr);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  f3q(l, r, left, right, epoint, cap, scale) {
    var angle = epoint.equals(EdgePoint_A_getInstance()) ? Angle__unaryMinus_impl_7901fr(left.e3p()) : Angle__unaryPlus_impl_eyi5pl(left.e3p());
    var lx = left.h2c(epoint.z3p_1);
    var ly = left.i2c(epoint.z3p_1);
    var rx = right.h2c(epoint.z3p_1);
    var ry = right.i2c(epoint.z3p_1);
    switch (cap.r3_1) {
      case 0:
        l.l2w(lx, ly);
        r.l2w(rx, ry);
        break;
      case 2:
      case 1:
        var ax = numberToInt(_Angle___get_cosine__impl__vprvmu(angle) * this.g3p_1 / 2);
        var ay = numberToInt(_Angle___get_sine__impl__15nmyi(angle) * this.g3p_1 / 2);
        var lx2 = lx + ax | 0;
        var ly2 = ly + ay | 0;
        var rx2 = rx + ax | 0;
        var ry2 = ry + ay | 0;
        if (cap.equals(LineCap_SQUARE_getInstance())) {
          l.l2w(lx2, ly2);
          r.l2w(rx2, ry2);
        } else {
          var count = clamp_0(numberToInt(Companion_getInstance_22().s2k(lx, ly, rx, ry) * scale), 4, 64);
          l.l2w(lx, ly);
          var inductionVariable = 0;
          if (inductionVariable <= count)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var m = epoint.equals(EdgePoint_A_getInstance()) ? n : count - n | 0;
              var ratio = _Ratio___init__impl__9mwvn2(m / count);
              this.d3q(r, Companion_getInstance_8().s3f(Vector2D.k2c(lx, ly), Vector2D.k2c(lx2, ly2), Vector2D.k2c(rx2, ry2), Vector2D.k2c(rx, ry), ratio));
            }
             while (!(n === count));
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  n3q(scale, closed) {
    if (this.m3p_1.h1())
      return Unit_instance;
    var weightD2 = this.g3p_1 / 2 | 0;
    this.p3p_1.k3();
    this.q3p_1.k3();
    var sp = this.m3p_1;
    var nstrokePoints = sp.f1();
    var inductionVariable = 0;
    if (inductionVariable < nstrokePoints)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var isFirst = n === 0;
        var isLast = n === (nstrokePoints - 1 | 0);
        var isMiddle = !isFirst && (!isLast || closed);
        var n1 = isLast ? closed ? 1 : n : n + 1 | 0;
        this.r3p_1.f3p(this.u3p_1);
        this.s3p_1.f3p(this.v3p_1);
        this.t3p_1.f3p(this.w3p_1);
        var doJoin = !(this.n3p_1.sz(n) === 0);
        this.u3p_1.d3o(sp.h2c(n), sp.i2c(n), sp.h2c(n1), sp.i2c(n1), 1);
        this.a3q(this.v3p_1, this.u3p_1, weightD2, Angle__minus_impl_xeau7k(this.u3p_1.e3p(), get_degrees(90)));
        this.a3q(this.w3p_1, this.u3p_1, weightD2, Angle__plus_impl_26v37k(this.u3p_1.e3p(), get_degrees(90)));
        if (isFirst) {
          this.f3q(this.p3p_1, this.q3p_1, this.v3p_1, this.w3p_1, EdgePoint_A_getInstance(), closed ? LineCap_BUTT_getInstance() : this.i3p_1, scale);
        } else if (isMiddle) {
          var angle = Companion_instance_7.d3p(this.r3p_1, this.u3p_1);
          var leftAngle = Angle__compareTo_impl_a0hfds(angle, get_degrees(0)) > 0;
          if (doJoin) {
            this.e3q(this.p3p_1, this.r3p_1, this.u3p_1, this.s3p_1, this.v3p_1, this.k3p_1, this.l3p_1, scale, leftAngle);
            this.e3q(this.q3p_1, this.r3p_1, this.u3p_1, this.t3p_1, this.w3p_1, this.k3p_1, this.l3p_1, scale, !leftAngle);
          } else {
            this.b3q(this.p3p_1, this.v3p_1);
            this.b3q(this.q3p_1, this.w3p_1);
          }
        } else if (isLast) {
          if (closed) {
            this.f3q(this.p3p_1, this.q3p_1, this.v3p_1, this.w3p_1, EdgePoint_B_getInstance(), LineCap_BUTT_getInstance(), scale);
          } else {
            this.f3q(this.p3p_1, this.q3p_1, this.s3p_1, this.t3p_1, EdgePoint_B_getInstance(), this.j3p_1, scale);
          }
        }
      }
       while (inductionVariable < nstrokePoints);
    var inductionVariable_0 = 0;
    var last = this.p3p_1.f1();
    if (inductionVariable_0 < last)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var x = this.p3p_1.h2c(n_0);
        var y = this.p3p_1.i2c(n_0);
        if (n_0 === 0) {
          _get_outFill__zcv64g(this).t3h(Vector2D.k2c(x * scale, y * scale));
        } else {
          _get_outFill__zcv64g(this).g3i(Vector2D.k2c(x * scale, y * scale));
        }
      }
       while (inductionVariable_0 < last);
    var inductionVariable_1 = 0;
    var last_0 = this.q3p_1.f1();
    if (inductionVariable_1 < last_0)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var m = (this.q3p_1.f1() - n_1 | 0) - 1 | 0;
        _get_outFill__zcv64g(this).g3i(Vector2D.k2c(this.q3p_1.h2c(m) * scale, this.q3p_1.i2c(m) * scale));
      }
       while (inductionVariable_1 < last_0);
    _get_outFill__zcv64g(this).n6();
    _get_outFill__zcv64g(this).y3h_1 = Winding_NON_ZERO_getInstance();
    this.m3p_1.k3();
    this.n3p_1.k3();
  }
  o3q(outFill, weight, startCap, endCap, joins, miterLimit) {
    this.h3p_1 = outFill;
    this.g3p_1 = weight;
    this.i3p_1 = startCap;
    this.j3p_1 = endCap;
    this.k3p_1 = joins;
    this.l3p_1 = miterLimit * weight;
  }
  p3q(stroke, lineWidth, joins, startCap, endCap, miterLimit, outFill) {
    var scale = 20;
    var iscale = 1.0 / 20;
    this.o3q(outFill, numberToInt(lineWidth * scale), startCap, endCap, joins, miterLimit);
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.v2c();
    var l = Vector2D.v2c();
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
    if (false) {
      this.n3q(iscale, true);
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = stroke.w3h_1;
    var n_0 = 0;
    while (n_0 < this_0.f1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.sz(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = stroke.x3h_1.e1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.k2c(tmp, stroke.x3h_1.e1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (true) {
            this.n3q(iscale, false);
          }

          this.m3p_1.l2w(numberToInt(it.a2a_1 * scale), numberToInt(it.b2a_1 * scale));
          this.n3p_1.s2o(0);
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = stroke.x3h_1.e1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.k2c(tmp_0, stroke.x3h_1.e1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (false) {
            this.n3q(iscale, false);
          }

          this.m3p_1.l2w(numberToInt(it_0.a2a_1 * scale), numberToInt(it_0.b2a_1 * scale));
          this.n3p_1.s2o(0);
          l = it_0;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.n3p_1.x2o(this.n3p_1.f1() - 1 | 0, 1);
          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = stroke.x3h_1.e1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.k2c(tmp_1, stroke.x3h_1.e1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = stroke.x3h_1.e1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.k2c(tmp_2, stroke.x3h_1.e1(_unary__edvuaz_7));
          var sum = Companion_getInstance().t2k(l, c) + Companion_getInstance().t2k(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos = {_v: Vector2D.v2c()};
          var prevPos = {_v: Vector2D.v2c()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_6().mz_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos._v = Companion_getInstance_8().t3f(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_8().t3f(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
              if (false) {
                this.n3q(iscale, false);
              }
              this.m3p_1.l2w(numberToInt(it_1.a2a_1 * scale), numberToInt(it_1.b2a_1 * scale));
              this.n3p_1.s2o(0);
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.n3p_1.x2o(this.n3p_1.f1() - 1 | 0, 1);
          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = stroke.x3h_1.e1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.k2c(tmp_3, stroke.x3h_1.e1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = stroke.x3h_1.e1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.k2c(tmp_4, stroke.x3h_1.e1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = stroke.x3h_1.e1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.k2c(tmp_5, stroke.x3h_1.e1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance().t2k(l, c0) + Companion_getInstance().t2k(c0, c1) + Companion_getInstance().t2k(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_0 = {_v: Vector2D.v2c()};
          var prevPos_0 = {_v: Vector2D.v2c()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_6().mz_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_8().s3f(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_8().s3f(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
              if (false) {
                this.n3q(iscale, false);
              }
              this.m3p_1.l2w(numberToInt(it_2.a2a_1 * scale), numberToInt(it_2.b2a_1 * scale));
              this.n3p_1.s2o(0);
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_0._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.n3p_1.x2o(this.n3p_1.f1() - 1 | 0, 1);
          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          var p = i;
          if (false) {
            this.n3q(iscale, false);
          }

          this.m3p_1.l2w(numberToInt(p.a2a_1 * scale), numberToInt(p.b2a_1 * scale));
          this.n3p_1.s2o(0);
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.n3p_1.x2o(this.n3p_1.f1() - 1 | 0, 1);
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (true) {
            this.n3q(iscale, true);
          }

          break;
      }
    }
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
    if (false) {
      this.n3q(iscale, true);
    }
    this.n3q(iscale, false);
  }
}
class VectorBuilder {}
function quadTo(c, a) {
  // Inline function 'korlibs.math.geom.bezier.Companion.quadToCubic' call
  var this_0 = Companion_getInstance_8();
  var x0 = this.v3q().a2a_1;
  var y0 = this.v3q().b2a_1;
  var xc = c.a2a_1;
  var yc = c.b2a_1;
  var x1 = a.a2a_1;
  var y1 = a.b2a_1;
  var cx1 = this_0.u3f(x0, xc);
  var cy1 = this_0.u3f(y0, yc);
  var cx2 = this_0.v3f(xc, x1);
  var cy2 = this_0.v3f(yc, y1);
  this.u3h(Vector2D.k2c(cx1, cy1), Vector2D.k2c(cx2, cy2), Vector2D.k2c(x1, y1));
}
function moveTo(x, y) {
  return this.t3h(Vector2D.k2c(x, y));
}
function lineTo(x, y) {
  return this.g3i(Vector2D.k2c(x, y));
}
function line(p0, p1) {
  this.t3h(p0);
  this.g3i(p1);
}
function isEmpty() {
  return this.u3q() === 0;
}
function isNotEmpty() {
  return !(this.u3q() === 0);
}
function rect(rect) {
  return this.z3q(rect.k2a_1, rect.l2a_1, rect.m2a_1, rect.n2a_1);
}
function rect_0(pos, size) {
  this.z3q(pos.a2a_1, pos.b2a_1, size.f2b_1, size.g2b_1);
}
function rect_1(x, y, width, height) {
  this.t3h(Vector2D.k2c(x, y));
  this.g3i(Vector2D.k2c(x + width, y));
  this.g3i(Vector2D.k2c(x + width, y + height));
  this.g3i(Vector2D.k2c(x, y + height));
  this.n6();
}
function arc(center, r, start, end, counterclockwise) {
  return Arc_instance.s3h(this, center, numberToDouble(r), start, end, counterclockwise);
}
function arc$default(center, r, start, end, counterclockwise, $super) {
  counterclockwise = counterclockwise === VOID ? false : counterclockwise;
  var tmp;
  if ($super === VOID) {
    this.a3r(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  } else {
    arc(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  }
  return tmp;
}
function circle(center, radius) {
  return this.b3r(center, radius, Companion_getInstance_0().r29_1, Companion_getInstance_0().v29_1);
}
function rMoveTo(delta) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.v3q();
  var tmp$ret$0 = Vector2D.k2c(this_0.a2a_1 + delta.a2a_1, this_0.b2a_1 + delta.b2a_1);
  return this.t3h(tmp$ret$0);
}
function rLineTo(delta) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.v3q();
  var tmp$ret$0 = Vector2D.k2c(this_0.a2a_1 + delta.a2a_1, this_0.b2a_1 + delta.b2a_1);
  return this.g3i(tmp$ret$0);
}
function transformed(m) {
  var im = m.y2e();
  var parent = this;
  return new VectorBuilder$transformed$1(parent, im, m);
}
function transformed_0(m, block) {
  return block(this.a2j(m));
}
class VectorBuilder$transformed$1 {
  constructor($parent, $im, $m) {
    this.r3q_1 = $parent;
    this.s3q_1 = $im;
    this.t3q_1 = $m;
    this.q3q_1 = $parent.u3q();
  }
  v3q() {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.s3q_1;
      var p = this.r3q_1.v3q();
      if (this_0.p2a()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.k2c(this_0.e2e(p.a2a_1, p.b2a_1), this_0.h2e(p.a2a_1, p.b2a_1));
    }
    return tmp$ret$0;
  }
  u3q() {
    return this.q3q_1;
  }
  n6() {
    return this.r3q_1.n6();
  }
  g3i(p) {
    return this.r3q_1.g3i(t(this, p));
  }
  t3h(p) {
    return this.r3q_1.g3i(t(this, p));
  }
  h3i(c, a) {
    return this.r3q_1.h3i(t(this, c), t(this, a));
  }
  u3h(c1, c2, a) {
    return this.r3q_1.u3h(t(this, c1), t(this, c2), t(this, a));
  }
}
class Companion_8 {}
class Visitor {}
function close() {
  return Unit_instance;
}
function moveTo_0(p) {
  return Unit_instance;
}
function lineTo_0(p) {
  return Unit_instance;
}
function quadTo_0(c, a) {
  return Unit_instance;
}
function cubicTo(c1, c2, a) {
  return Unit_instance;
}
class VectorPath extends AbstractShape2D {
  constructor(commands, data, winding, optimize) {
    commands = commands === VOID ? IntArrayList.m2o() : commands;
    data = data === VOID ? DoubleArrayList.g2p() : data;
    winding = winding === VOID ? Companion_instance_9.g3r() : winding;
    optimize = optimize === VOID ? true : optimize;
    super();
    this.v3h_1 = new Mixin();
    this.w3h_1 = commands;
    this.x3h_1 = data;
    this.y3h_1 = winding;
    this.z3h_1 = optimize;
    this.a3i_1 = false;
    this.b3i_1 = 0;
    this.c3i_1 = Vector2D.v2c();
    this.d3i_1 = Vector2D.v2c();
    this.e3i_1 = null;
    this.f3i_1 = null;
  }
  yz(_set____db54di) {
    this.v3h_1.yz(_set____db54di);
  }
  zz() {
    return this.v3h_1.zz();
  }
  uz() {
    return new VectorPath(IntArrayList.o2o(this.w3h_1), DoubleArrayList.h2p(this.x3h_1), this.y3h_1);
  }
  equals(other) {
    if (this === other)
      return true;
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof VectorPath) {
      tmp_1 = this.w3h_1.equals(other.w3h_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.x3h_1.equals(other.x3h_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.y3h_1.equals(other.y3h_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return (this.w3h_1.hashCode() + imul(this.x3h_1.hashCode(), 13) | 0) + imul(this.y3h_1.r3_1, 111) | 0;
  }
  h3r(visitor) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.w3h_1;
    var n_0 = 0;
    while (n_0 < this_0.f1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.sz(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.x3h_1.e1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var p0 = Vector2D.k2c(tmp, this.x3h_1.e1(_unary__edvuaz_1));
          visitor.t3h(p0);
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.x3h_1.e1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var p0_0 = Vector2D.k2c(tmp_0, this.x3h_1.e1(_unary__edvuaz_3));
          visitor.g3i(p0_0);
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.x3h_1.e1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var p0_1 = Vector2D.k2c(tmp_1, this.x3h_1.e1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = this.x3h_1.e1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var p1 = Vector2D.k2c(tmp_2, this.x3h_1.e1(_unary__edvuaz_7));
          visitor.h3i(p0_1, p1);
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = this.x3h_1.e1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var p0_2 = Vector2D.k2c(tmp_3, this.x3h_1.e1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = this.x3h_1.e1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var p1_0 = Vector2D.k2c(tmp_4, this.x3h_1.e1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = this.x3h_1.e1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var p2 = Vector2D.k2c(tmp_5, this.x3h_1.e1(_unary__edvuaz_13));
          visitor.u3h(p0_2, p1_0, p2);
          break;
        case 4:
          visitor.n6();
          break;
      }
    }
  }
  k3() {
    this.w3h_1.k3();
    this.x3h_1.k3();
    this.c3i_1 = Vector2D.v2c();
    this.b3i_1 = 0;
    this.i3r().k3n_1 = this.b3i_1 - 1 | 0;
  }
  v3q() {
    return this.c3i_1;
  }
  t3h(p) {
    if (this.w3h_1.l2c() && this.w3h_1.z2o() === 0) {
      if (this.c3i_1.equals(p))
        return Unit_instance;
    }
    this.w3h_1.s2o(0);
    this.x3h_1.l2p(p.a2a_1, p.b2a_1);
    this.c3i_1 = p;
    this.d3i_1 = p;
    this.b3i_1 = this.b3i_1 + 1 | 0;
  }
  g3i(p) {
    if (ensureMoveTo(this, p) && this.z3h_1)
      return Unit_instance;
    if (p.equals(this.c3i_1) && this.z3h_1)
      return Unit_instance;
    this.w3h_1.s2o(1);
    this.x3h_1.l2p(p.a2a_1, p.b2a_1);
    this.c3i_1 = p;
    this.b3i_1 = this.b3i_1 + 1 | 0;
  }
  h3i(c, a) {
    ensureMoveTo(this, c);
    this.w3h_1.s2o(2);
    this.x3h_1.m2p(c.a2a_1, c.b2a_1, a.a2a_1, a.b2a_1);
    this.c3i_1 = a;
    this.b3i_1 = this.b3i_1 + 1 | 0;
  }
  u3h(c1, c2, a) {
    ensureMoveTo(this, c1);
    this.w3h_1.s2o(3);
    this.x3h_1.n2p(c1.a2a_1, c1.b2a_1, c2.a2a_1, c2.b2a_1, a.a2a_1, a.b2a_1);
    this.c3i_1 = a;
    this.b3i_1 = this.b3i_1 + 1 | 0;
  }
  n6() {
    this.w3h_1.s2o(4);
    this.c3i_1 = this.d3i_1;
    this.b3i_1 = this.b3i_1 + 1 | 0;
  }
  u3q() {
    return this.x3h_1.f1() / 2 | 0;
  }
  k3e() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(plus(Companion_getInstance_4().a2b(), this));
  }
  j3r(p) {
    return this.s3o(p.a2a_1, p.b2a_1, this.y3h_1);
  }
  i3r() {
    if (this.f3i_1 == null)
      this.f3i_1 = new PolygonScanline();
    var scanline = ensureNotNull(this.f3i_1);
    if (!(scanline.k3n_1 === this.b3i_1)) {
      scanline.p2u();
      scanline.m3o(this);
      scanline.k3n_1 = this.b3i_1;
    }
    return ensureNotNull(this.f3i_1);
  }
  s3o(x, y, winding) {
    return this.i3r().s3o(x, y, winding);
  }
  k3r(path, transform) {
    this.w3h_1.u2o(path.w3h_1);
    if (transform.b2e()) {
      this.x3h_1.p2p(path.x3h_1);
      this.c3i_1 = path.c3i_1;
    } else {
      var progression = step(until(0, path.x3h_1.f1()), 2);
      var inductionVariable = progression.b2_1;
      var last = progression.c2_1;
      var step_0 = progression.d2_1;
      if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var tmp$ret$0;
          $l$block: {
            // Inline function 'korlibs.math.geom.Matrix.transform' call
            var p = Vector2D.k2c(path.x3h_1.e1(n + 0 | 0), path.x3h_1.e1(n + 1 | 0));
            if (transform.p2a()) {
              tmp$ret$0 = p;
              break $l$block;
            }
            tmp$ret$0 = Vector2D.k2c(transform.e2e(p.a2a_1, p.b2a_1), transform.h2e(p.a2a_1, p.b2a_1));
          }
          var p_0 = tmp$ret$0;
          this.x3h_1.l2p(p_0.a2a_1, p_0.b2a_1);
        }
         while (!(n === last));
      var tmp = this;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = path.c3i_1;
        if (transform.p2a()) {
          tmp$ret$1 = p_1;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.k2c(transform.e2e(p_1.a2a_1, p_1.b2a_1), transform.h2e(p_1.a2a_1, p_1.b2a_1));
      }
      tmp.c3i_1 = tmp$ret$1;
    }
    this.b3i_1 = this.b3i_1 + 1 | 0;
  }
  l3r(path, transform, $super) {
    transform = transform === VOID ? Companion_getInstance_2().m2d_1 : transform;
    var tmp;
    if ($super === VOID) {
      this.k3r(path, transform);
      tmp = Unit_instance;
    } else {
      tmp = $super.k3r.call(this, path, transform);
    }
    return tmp;
  }
  m3r() {
    // Inline function 'kotlin.text.trimEnd' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.w3h_1;
    var n_0 = 0;
    while (n_0 < this_1.f1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.sz(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.x3h_1.e1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.k2c(tmp, this.x3h_1.e1(_unary__edvuaz_1));
          var x = destruct.nl();
          var y = destruct.ol();
          this_0.bc('M' + get_niceStr(x) + ',' + get_niceStr(y) + ' ');
          break;
        case 1:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.x3h_1.e1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.k2c(tmp_0, this.x3h_1.e1(_unary__edvuaz_3));
          var x_0 = destruct_0.nl();
          var y_0 = destruct_0.ol();
          this_0.bc('L' + get_niceStr(x_0) + ',' + get_niceStr(y_0) + ' ');
          break;
        case 2:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.x3h_1.e1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.k2c(tmp_1, this.x3h_1.e1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = this.x3h_1.e1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.k2c(tmp_2, this.x3h_1.e1(_unary__edvuaz_7));
          var x1 = destruct_1.nl();
          var y1 = destruct_1.ol();
          var x2 = destruct_2.nl();
          var y2 = destruct_2.ol();
          this_0.bc('Q' + get_niceStr(x1) + ',' + get_niceStr(y1) + ',' + get_niceStr(x2) + ',' + get_niceStr(y2) + ' ');
          break;
        case 3:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = this.x3h_1.e1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.k2c(tmp_3, this.x3h_1.e1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = this.x3h_1.e1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.k2c(tmp_4, this.x3h_1.e1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = this.x3h_1.e1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.k2c(tmp_5, this.x3h_1.e1(_unary__edvuaz_13));
          var x1_0 = destruct_3.nl();
          var y1_0 = destruct_3.ol();
          var x2_0 = destruct_4.nl();
          var y2_0 = destruct_4.ol();
          var x3 = destruct_5.nl();
          var y3 = destruct_5.ol();
          this_0.bc('C' + get_niceStr(x1_0) + ',' + get_niceStr(y1_0) + ',' + get_niceStr(x2_0) + ',' + get_niceStr(y2_0) + ',' + get_niceStr(x3) + ',' + get_niceStr(y3) + ' ');
          break;
        case 4:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          this_0.bc('Z ');
          break;
      }
    }
    var this_2 = this_0.toString();
    return toString(trimEnd(isCharSequence(this_2) ? this_2 : THROW_CCE()));
  }
  toString() {
    return 'VectorPath(' + this.m3r() + ')';
  }
  n3r(sx, sy) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.transformPoints' call
    var progression = step(until(0, this.x3h_1.f1()), 2);
    var inductionVariable = progression.b2_1;
    var last = progression.c2_1;
    var step_0 = progression.d2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        // Inline function 'korlibs.math.geom.vector.VectorPath.scale.<anonymous>' call
        var it = Vector2D.k2c(this.x3h_1.e1(n + 0 | 0), this.x3h_1.e1(n + 1 | 0));
        var p = Vector2D.k2c(it.a2a_1 * sx, it.b2a_1 * sy);
        this.x3h_1.s2p(n + 0 | 0, p.a2a_1);
        this.x3h_1.s2p(n + 1 | 0, p.b2a_1);
      }
       while (!(n === last));
    this.b3i_1 = this.b3i_1 + 1 | 0;
    return this;
  }
}
class with$1 {
  constructor($bb) {
    this.o3r_1 = $bb;
  }
  t3h(p) {
    this.o3r_1._v = new BoundsBuilder(BoundsBuilder__plus_impl_cz7f7x(this.o3r_1._v.n2b_1, p));
  }
}
class Companion_9 {
  g3r() {
    return Winding_NON_ZERO_getInstance();
  }
}
class Winding extends Enum {
  constructor(name, ordinal, str) {
    super(name, ordinal);
    this.r3r_1 = str;
  }
}
class Companion_10 {}
class LineJoin extends Enum {}
class Companion_11 {}
class LineCap extends Enum {}
class LineScaleMode extends Enum {
  constructor(name, ordinal, hScale, vScale) {
    super(name, ordinal);
    this.u3r_1 = hScale;
    this.v3r_1 = vScale;
    this.w3r_1 = this.u3r_1 || this.v3r_1;
    this.x3r_1 = (this.u3r_1 && this.v3r_1);
  }
}
class Companion_12 {}
class StrokeInfo {
  constructor(thickness, pixelHinting, scaleMode, startCap, endCap, join, miterLimit, dash, dashOffset) {
    thickness = thickness === VOID ? 1.0 : thickness;
    pixelHinting = pixelHinting === VOID ? false : pixelHinting;
    scaleMode = scaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : scaleMode;
    startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
    endCap = endCap === VOID ? LineCap_BUTT_getInstance() : endCap;
    join = join === VOID ? LineJoin_MITER_getInstance() : join;
    miterLimit = miterLimit === VOID ? 20.0 : miterLimit;
    dash = dash === VOID ? null : dash;
    dashOffset = dashOffset === VOID ? 0.0 : dashOffset;
    this.c3c_1 = thickness;
    this.d3c_1 = pixelHinting;
    this.e3c_1 = scaleMode;
    this.f3c_1 = startCap;
    this.g3c_1 = endCap;
    this.h3c_1 = join;
    this.i3c_1 = miterLimit;
    this.j3c_1 = dash;
    this.k3c_1 = dashOffset;
  }
  toString() {
    return 'StrokeInfo(thickness=' + this.c3c_1 + ', pixelHinting=' + this.d3c_1 + ', scaleMode=' + this.e3c_1.toString() + ', startCap=' + this.f3c_1.toString() + ', endCap=' + this.g3c_1.toString() + ', join=' + this.h3c_1.toString() + ', miterLimit=' + this.i3c_1 + ', dash=' + toString_0(this.j3c_1) + ', dashOffset=' + this.k3c_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.c3c_1);
    result = imul(result, 31) + getBooleanHashCode(this.d3c_1) | 0;
    result = imul(result, 31) + this.e3c_1.hashCode() | 0;
    result = imul(result, 31) + this.f3c_1.hashCode() | 0;
    result = imul(result, 31) + this.g3c_1.hashCode() | 0;
    result = imul(result, 31) + this.h3c_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.i3c_1) | 0;
    result = imul(result, 31) + (this.j3c_1 == null ? 0 : hashCode(this.j3c_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k3c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StrokeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof StrokeInfo ? other : THROW_CCE();
    if (!equals(this.c3c_1, tmp0_other_with_cast.c3c_1))
      return false;
    if (!(this.d3c_1 === tmp0_other_with_cast.d3c_1))
      return false;
    if (!this.e3c_1.equals(tmp0_other_with_cast.e3c_1))
      return false;
    if (!this.f3c_1.equals(tmp0_other_with_cast.f3c_1))
      return false;
    if (!this.g3c_1.equals(tmp0_other_with_cast.g3c_1))
      return false;
    if (!this.h3c_1.equals(tmp0_other_with_cast.h3c_1))
      return false;
    if (!equals(this.i3c_1, tmp0_other_with_cast.i3c_1))
      return false;
    if (!equals(this.j3c_1, tmp0_other_with_cast.j3c_1))
      return false;
    if (!equals(this.k3c_1, tmp0_other_with_cast.k3c_1))
      return false;
    return true;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    var tmp_0 = MPoint$Companion$POOL$lambda;
    tmp.g3q_1 = ConcurrentPool.j2u(tmp_0, VOID, MPoint$Companion$POOL$lambda_0);
    this.h3q_1 = new MPoint(0.0, 0.0);
    this.i3q_1 = new MPoint(1.0, 1.0);
    this.j3q_1 = new MPoint(0.0, -1.0);
    this.k3q_1 = new MPoint(0.0, +1.0);
    this.l3q_1 = new MPoint(-1.0, 0.0);
    this.m3q_1 = new MPoint(+1.0, 0.0);
  }
  p2d() {
    return new MPoint(0.0, 0.0);
  }
  b3s(lx, ly, rx, ry) {
    var ret = compareTo(ly, ry);
    return ret === 0 ? compareTo(lx, rx) : ret;
  }
  d2j(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  s2k(x1, y1, x2, y2) {
    return this.d2j(x1, y1, x2, y2);
  }
  c3s(aX, aY, bX, bY) {
    return aX * bX + aY * bY;
  }
}
class MPoint {
  constructor(x, y) {
    Companion_getInstance_22();
    this.y3r_1 = x;
    this.z3r_1 = y;
  }
  d3s(other, epsilon) {
    return isAlmostEquals_0(this.y3r_1, other.y3r_1, epsilon) && isAlmostEquals_0(this.z3r_1, other.z3r_1, epsilon);
  }
  cz(other, epsilon) {
    return this.d3s(other instanceof MPoint ? other : THROW_CCE(), epsilon);
  }
  a3s(x, y) {
    this.y3r_1 = x;
    this.z3r_1 = y;
    return this;
  }
  e3s(other) {
    return Companion_getInstance_22().b3s(this.y3r_1, this.z3r_1, other.y3r_1, other.z3r_1);
  }
  d(other) {
    return this.e3s(other instanceof MPoint ? other : THROW_CCE());
  }
  toString() {
    return '(' + get_niceStr(this.y3r_1) + ', ' + get_niceStr(this.z3r_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.y3r_1);
    result = imul(result, 31) + getNumberHashCode(this.z3r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MPoint))
      return false;
    var tmp0_other_with_cast = other instanceof MPoint ? other : THROW_CCE();
    if (!equals(this.y3r_1, tmp0_other_with_cast.y3r_1))
      return false;
    if (!equals(this.z3r_1, tmp0_other_with_cast.z3r_1))
      return false;
    return true;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    var tmp = this;
    var tmp_0 = MMatrix$Companion$POOL$lambda;
    tmp.m3s_1 = ConcurrentPool.j2u(tmp_0, VOID, MMatrix$Companion$POOL$lambda_0);
  }
}
class MMatrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_23();
    a = a === VOID ? 1.0 : a;
    b = b === VOID ? 0.0 : b;
    c = c === VOID ? 0.0 : c;
    d = d === VOID ? 1.0 : d;
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.f3s_1 = a;
    this.g3s_1 = b;
    this.h3s_1 = c;
    this.i3s_1 = d;
    this.j3s_1 = tx;
    this.k3s_1 = ty;
  }
  n3s() {
    return new Matrix(this.f3s_1, this.g3s_1, this.h3s_1, this.i3s_1, this.j3s_1, this.k3s_1);
  }
  o3s(a, b, c, d, tx, ty) {
    this.f3s_1 = a;
    this.g3s_1 = b;
    this.h3s_1 = c;
    this.i3s_1 = d;
    this.j3s_1 = tx;
    this.k3s_1 = ty;
    return this;
  }
  p3s(that) {
    return this.o3s(that.r2d_1, that.s2d_1, that.t2d_1, that.u2d_1, that.v2d_1, that.w2d_1);
  }
  q3s(dx, dy) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.MMatrix.pretranslate.<anonymous>' call
    this.j3s_1 = this.j3s_1 + (this.f3s_1 * dx + this.h3s_1 * dy);
    this.k3s_1 = this.k3s_1 + (this.g3s_1 * dx + this.i3s_1 * dy);
    return this;
  }
  l3s() {
    return this.o3s(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
  }
  toString() {
    return 'Matrix(a=' + this.f3s_1 + ', b=' + this.g3s_1 + ', c=' + this.h3s_1 + ', d=' + this.i3s_1 + ', tx=' + this.j3s_1 + ', ty=' + this.k3s_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.f3s_1);
    result = imul(result, 31) + getNumberHashCode(this.g3s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h3s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i3s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j3s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k3s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MMatrix))
      return false;
    var tmp0_other_with_cast = other instanceof MMatrix ? other : THROW_CCE();
    if (!equals(this.f3s_1, tmp0_other_with_cast.f3s_1))
      return false;
    if (!equals(this.g3s_1, tmp0_other_with_cast.g3s_1))
      return false;
    if (!equals(this.h3s_1, tmp0_other_with_cast.h3s_1))
      return false;
    if (!equals(this.i3s_1, tmp0_other_with_cast.i3s_1))
      return false;
    if (!equals(this.j3s_1, tmp0_other_with_cast.j3s_1))
      return false;
    if (!equals(this.k3s_1, tmp0_other_with_cast.k3s_1))
      return false;
    return true;
  }
}
class Companion_15 {
  r3s(point, direction, scale, out) {
    return out.s3s(point.a2a_1, point.b2a_1, point.a2a_1 + direction.a2a_1 * scale, point.b2a_1 + direction.b2a_1 * scale);
  }
  d3d(point, direction, scale, out, $super) {
    scale = scale === VOID ? 1.0 : scale;
    out = out === VOID ? MLine.t3s() : out;
    return $super === VOID ? this.r3s(point, direction, scale, out) : $super.r3s.call(this, point, direction, scale, out);
  }
  c3p(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    var a1 = By - Ay;
    var b1 = Ax - Bx;
    var c1 = a1 * Ax + b1 * Ay;
    var a2 = Dy - Cy;
    var b2 = Cx - Dx;
    var c2 = a2 * Cx + b2 * Cy;
    var determinant = a1 * b2 - a2 * b1;
    if (isAlmostZero(determinant))
      return null;
    var x = (b2 * c1 - b1 * c2) / determinant;
    var y = (a1 * c2 - a2 * c1) / determinant;
    return Vector2D.k2c(x, y);
  }
}
class MLine {
  static u3s(a, b) {
    var $this = createThis(this);
    $this.e3d_1 = a;
    $this.f3d_1 = b;
    return $this;
  }
  uz() {
    return MLine.u3s(this.e3d_1, this.f3d_1);
  }
  s3s(x0, y0, x1, y1) {
    this.e3d_1 = Vector2D.k2c(x0, y0);
    this.f3d_1 = Vector2D.k2c(x1, y1);
    return this;
  }
  g3d(scale) {
    var tmp = this;
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this.e3d_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = this.v3s();
    var that = Vector2D.k2c(this_1.a2a_1 * scale, this_1.b2a_1 * scale);
    tmp.e3d_1 = Vector2D.k2c(this_0.a2a_1 - that.a2a_1, this_0.b2a_1 - that.b2a_1);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_2 = this.f3d_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_3 = this.v3s();
    var that_0 = Vector2D.k2c(this_3.a2a_1 * scale, this_3.b2a_1 * scale);
    tmp_0.f3d_1 = Vector2D.k2c(this_2.a2a_1 - that_0.a2a_1, this_2.b2a_1 - that_0.b2a_1);
    return this;
  }
  static t3s() {
    return this.u3s(Vector2D.v2c(), Vector2D.v2c());
  }
  y2c() {
    return this.e3d_1.a2a_1;
  }
  z2c() {
    return this.e3d_1.b2a_1;
  }
  a2d() {
    return this.f3d_1.a2a_1;
  }
  b2d() {
    return this.f3d_1.b2a_1;
  }
  v3s() {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this.f3d_1;
    var that = this.e3d_1;
    return Vector2D.k2c(this_0.a2a_1 - that.a2a_1, this_0.b2a_1 - that.b2a_1);
  }
  toString() {
    return 'Line(' + this.e3d_1.toString() + ', ' + this.f3d_1.toString() + ')';
  }
  w3s(line) {
    return Companion_instance_15.c3p(this.y2c(), this.z2c(), this.a2d(), this.b2d(), line.y2c(), line.z2c(), line.a2d(), line.b2d());
  }
  hashCode() {
    var result = this.e3d_1.hashCode();
    result = imul(result, 31) + this.f3d_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MLine))
      return false;
    var tmp0_other_with_cast = other instanceof MLine ? other : THROW_CCE();
    if (!this.e3d_1.equals(tmp0_other_with_cast.e3d_1))
      return false;
    if (!this.f3d_1.equals(tmp0_other_with_cast.f3d_1))
      return false;
    return true;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    var tmp = this;
    var tmp_0 = MRectangle$Companion$POOL$lambda;
    tmp.b3t_1 = ConcurrentPool.j2u(tmp_0, VOID, MRectangle$Companion$POOL$lambda_0);
  }
  p2d() {
    return new MRectangle(0.0, 0.0, 0.0, 0.0);
  }
}
class MRectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_25();
    this.x3s_1 = x;
    this.y3s_1 = y;
    this.z3s_1 = width;
    this.a3t_1 = height;
  }
  c3t(other, epsilon) {
    return isAlmostEquals_0(this.x3s_1, other.x3s_1, epsilon) && isAlmostEquals_0(this.y3s_1, other.y3s_1, epsilon) && isAlmostEquals_0(this.z3s_1, other.z3s_1, epsilon) && isAlmostEquals_0(this.a3t_1, other.a3t_1, epsilon);
  }
  cz(other, epsilon) {
    return this.c3t(other instanceof MRectangle ? other : THROW_CCE(), epsilon);
  }
  r2a() {
    return this.x3s_1;
  }
  t2a() {
    return this.y3s_1;
  }
  s2a() {
    return this.x3s_1 + this.z3s_1;
  }
  u2a() {
    return this.y3s_1 + this.a3t_1;
  }
  s3s(x, y, width, height) {
    this.x3s_1 = x;
    this.y3s_1 = y;
    this.z3s_1 = width;
    this.a3t_1 = height;
    return this;
  }
  d3t(left, top, right, bottom) {
    return this.s3s(left, top, right - left, bottom - top);
  }
  e3t(left, top, right, bottom) {
    return this.d3t(this.r2a() - left, this.t2a() - top, this.s2a() + right, this.u2a() + bottom);
  }
  f3t(left, top, right, bottom, $super) {
    top = top === VOID ? left : top;
    right = right === VOID ? left : right;
    bottom = bottom === VOID ? top : bottom;
    return $super === VOID ? this.e3t(left, top, right, bottom) : $super.e3t.call(this, left, top, right, bottom);
  }
  hh() {
    return this.s3s(0.0, 0.0, 0.0, 0.0);
  }
  toString() {
    return 'Rectangle(x=' + get_niceStr(this.x3s_1) + ', y=' + get_niceStr(this.y3s_1) + ', width=' + get_niceStr(this.z3s_1) + ', height=' + get_niceStr(this.a3t_1) + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof MRectangle) {
      tmp_2 = isAlmostEquals_0(this.x3s_1, other.x3s_1);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = isAlmostEquals_0(this.y3s_1, other.y3s_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = isAlmostEquals_0(this.z3s_1, other.z3s_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = isAlmostEquals_0(this.a3t_1, other.a3t_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  n3s() {
    return new Rectangle(this.x3s_1, this.y3s_1, this.z3s_1, this.a3t_1);
  }
  hashCode() {
    var result = getNumberHashCode(this.x3s_1);
    result = imul(result, 31) + getNumberHashCode(this.y3s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z3s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a3t_1) | 0;
    return result;
  }
}
class Easings extends Enum {
  toString() {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return replace(super.toString(), _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45)).toLowerCase();
  }
}
class Easings$SMOOTH extends Easings {
  constructor() {
    super('SMOOTH', 0);
    Easings_SMOOTH_instance = this;
  }
  fz(it) {
    return it * it * (3 - 2 * it);
  }
}
class Easings$EASE_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_ELASTIC', 1);
    Easings_EASE_IN_ELASTIC_instance = this;
  }
  fz(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        var inv = it - 1;
        var tmp_0 = -1.0;
        // Inline function 'kotlin.math.pow' call

        var x = 10.0 * inv;
        var tmp_1 = tmp_0 * Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (inv - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_1 * Math.sin(x_0);
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_ELASTIC', 2);
    Easings_EASE_OUT_ELASTIC_instance = this;
  }
  fz(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        // Inline function 'kotlin.math.pow' call

        var x = -10.0 * it;
        var tmp_0 = Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (it - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_0 * Math.sin(x_0) + 1;
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_BOUNCE', 3);
    Easings_EASE_OUT_BOUNCE_instance = this;
  }
  fz(it) {
    var s = 7.5625;
    var p = 2.75;
    var tmp;
    if (it < 1.0 / p) {
      // Inline function 'kotlin.math.pow' call
      tmp = s * Math.pow(it, 2.0);
    } else if (it < 2.0 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_0 = it - 1.5 / p;
      tmp = s * Math.pow(this_0, 2.0) + 0.75;
    } else if (it < 2.5 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_1 = it - 2.25 / p;
      tmp = s * Math.pow(this_1, 2.0) + 0.9375;
    } else {
      // Inline function 'kotlin.math.pow' call
      var this_2 = it - 2.625 / p;
      tmp = s * Math.pow(this_2, 2.0) + 0.984375;
    }
    return tmp;
  }
}
class Easings$LINEAR extends Easings {
  constructor() {
    super('LINEAR', 4);
    Easings_LINEAR_instance = this;
  }
  fz(it) {
    return it;
  }
}
class Easings$EASE extends Easings {
  constructor() {
    super('EASE', 5);
    Easings_EASE_instance = this;
    this.s3t_1 = new EasingCubic(0.25, 0.1, 0.25, 1.0, 'ease');
  }
  fz(it) {
    return this.s3t_1.fz(it);
  }
}
class Easings$EASE_IN extends Easings {
  constructor() {
    super('EASE_IN', 6);
    Easings_EASE_IN_instance = this;
    this.b3u_1 = new EasingCubic(0.42, 0.0, 1.0, 1.0, 'ease-in');
  }
  fz(it) {
    return this.b3u_1.fz(it);
  }
}
class Easings$EASE_OUT extends Easings {
  constructor() {
    super('EASE_OUT', 7);
    Easings_EASE_OUT_instance = this;
    this.e3u_1 = new EasingCubic(0.0, 0.0, 0.58, 1.0, 'ease-out');
  }
  fz(it) {
    return this.e3u_1.fz(it);
  }
}
class Easings$EASE_IN_OUT extends Easings {
  constructor() {
    super('EASE_IN_OUT', 8);
    Easings_EASE_IN_OUT_instance = this;
    this.h3u_1 = new EasingCubic(0.42, 0.0, 0.58, 1.0, 'ease-in-out');
  }
  fz(it) {
    return this.h3u_1.fz(it);
  }
}
class Easings$EASE_IN_OLD extends Easings {
  constructor() {
    super('EASE_IN_OLD', 9);
    Easings_EASE_IN_OLD_instance = this;
  }
  fz(it) {
    return it * it * it;
  }
}
class Easings$EASE_OUT_OLD extends Easings {
  constructor() {
    super('EASE_OUT_OLD', 10);
    Easings_EASE_OUT_OLD_instance = this;
  }
  fz(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_OUT_OLD.invoke.<anonymous>' call
    var inv = it - 1.0;
    return inv * inv * inv + 1;
  }
}
class Easings$EASE_IN_OUT_OLD extends Easings {
  constructor() {
    super('EASE_IN_OUT_OLD', 11);
    Easings_EASE_IN_OUT_OLD_instance = this;
  }
  fz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_IN_OLD_getInstance();
    var end = Easings_EASE_OUT_OLD_getInstance();
    return it < 0.5 ? 0.5 * start.fz(it * 2.0) : 0.5 * end.fz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_OLD extends Easings {
  constructor() {
    super('EASE_OUT_IN_OLD', 12);
    Easings_EASE_OUT_IN_OLD_instance = this;
  }
  fz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_OUT_OLD_getInstance();
    var end = Easings_EASE_IN_OLD_getInstance();
    return it < 0.5 ? 0.5 * start.fz(it * 2.0) : 0.5 * end.fz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BACK extends Easings {
  constructor() {
    super('EASE_IN_BACK', 13);
    Easings_EASE_IN_BACK_instance = this;
  }
  fz(it) {
    // Inline function 'kotlin.math.pow' call
    return Math.pow(it, 2.0) * ((1.70158 + 1.0) * it - 1.70158);
  }
}
class Easings$EASE_OUT_BACK extends Easings {
  constructor() {
    super('EASE_OUT_BACK', 14);
    Easings_EASE_OUT_BACK_instance = this;
  }
  fz(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_OUT_BACK.invoke.<anonymous>' call
    var inv = it - 1.0;
    // Inline function 'kotlin.math.pow' call
    return Math.pow(inv, 2.0) * ((1.70158 + 1.0) * inv + 1.70158) + 1.0;
  }
}
class Easings$EASE_IN_OUT_BACK extends Easings {
  constructor() {
    super('EASE_IN_OUT_BACK', 15);
    Easings_EASE_IN_OUT_BACK_instance = this;
  }
  fz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_IN_BACK_getInstance();
    var end = Easings_EASE_OUT_BACK_getInstance();
    return it < 0.5 ? 0.5 * start.fz(it * 2.0) : 0.5 * end.fz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BACK extends Easings {
  constructor() {
    super('EASE_OUT_IN_BACK', 16);
    Easings_EASE_OUT_IN_BACK_instance = this;
  }
  fz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_OUT_BACK_getInstance();
    var end = Easings_EASE_IN_BACK_getInstance();
    return it < 0.5 ? 0.5 * start.fz(it * 2.0) : 0.5 * end.fz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_OUT_ELASTIC', 17);
    Easings_EASE_IN_OUT_ELASTIC_instance = this;
  }
  fz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_IN_ELASTIC_getInstance();
    var end = Easings_EASE_OUT_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * start.fz(it * 2.0) : 0.5 * end.fz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_IN_ELASTIC', 18);
    Easings_EASE_OUT_IN_ELASTIC_instance = this;
  }
  fz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_OUT_ELASTIC_getInstance();
    var end = Easings_EASE_IN_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * start.fz(it * 2.0) : 0.5 * end.fz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_BOUNCE', 19);
    Easings_EASE_IN_BOUNCE_instance = this;
  }
  fz(it) {
    return 1.0 - Easings_EASE_OUT_BOUNCE_getInstance().fz(1.0 - it);
  }
}
class Easings$EASE_IN_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_OUT_BOUNCE', 20);
    Easings_EASE_IN_OUT_BOUNCE_instance = this;
  }
  fz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_IN_BOUNCE_getInstance();
    var end = Easings_EASE_OUT_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * start.fz(it * 2.0) : 0.5 * end.fz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_IN_BOUNCE', 21);
    Easings_EASE_OUT_IN_BOUNCE_instance = this;
  }
  fz(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_OUT_BOUNCE_getInstance();
    var end = Easings_EASE_IN_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * start.fz(it * 2.0) : 0.5 * end.fz((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_QUAD extends Easings {
  constructor() {
    super('EASE_IN_QUAD', 22);
    Easings_EASE_IN_QUAD_instance = this;
  }
  fz(it) {
    return 1.0 * it * it;
  }
}
class Easings$EASE_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_OUT_QUAD', 23);
    Easings_EASE_OUT_QUAD_instance = this;
  }
  fz(it) {
    return -1.0 * it * (it - 2);
  }
}
class Easings$EASE_IN_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_IN_OUT_QUAD', 24);
    Easings_EASE_IN_OUT_QUAD_instance = this;
  }
  fz(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_IN_OUT_QUAD.invoke.<anonymous>' call
    var t = it * 2.0;
    var tmp;
    if (t < 1) {
      tmp = +1.0 / 2 * t * t;
    } else {
      tmp = -1.0 / 2 * ((t - 1) * (t - 1 - 2) - 1);
    }
    return tmp;
  }
}
class Easings$EASE_SINE extends Easings {
  constructor() {
    super('EASE_SINE', 25);
    Easings_EASE_SINE_instance = this;
  }
  fz(it) {
    // Inline function 'kotlin.math.sin' call
    var x = it * 1.5707964;
    return Math.sin(x);
  }
}
class Easings$EASE_CLAMP_START extends Easings {
  constructor() {
    super('EASE_CLAMP_START', 26);
    Easings_EASE_CLAMP_START_instance = this;
  }
  fz(it) {
    return it <= 0.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_END extends Easings {
  constructor() {
    super('EASE_CLAMP_END', 27);
    Easings_EASE_CLAMP_END_instance = this;
  }
  fz(it) {
    return it < 1.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_MIDDLE extends Easings {
  constructor() {
    super('EASE_CLAMP_MIDDLE', 28);
    Easings_EASE_CLAMP_MIDDLE_instance = this;
  }
  fz(it) {
    return it < 0.5 ? 0.0 : 1.0;
  }
}
class P {
  static y3v(x, y) {
    var $this = createThis(this);
    $this.w3v_1 = x;
    $this.x3v_1 = y;
    return $this;
  }
  static z3v(x, y) {
    return this.y3v(x, y);
  }
  i2i(that) {
    return P.y3v(this.w3v_1 * that, this.x3v_1 * that);
  }
  a3w(that) {
    return P.y3v(this.w3v_1 + that.w3v_1, this.x3v_1 + that.x3v_1);
  }
  toString() {
    return 'P(x=' + this.w3v_1 + ', y=' + this.x3v_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.w3v_1);
    result = imul(result, 31) + getNumberHashCode(this.x3v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof P))
      return false;
    var tmp0_other_with_cast = other instanceof P ? other : THROW_CCE();
    if (!equals(this.w3v_1, tmp0_other_with_cast.w3v_1))
      return false;
    if (!equals(this.x3v_1, tmp0_other_with_cast.x3v_1))
      return false;
    return true;
  }
}
class EasingCubic {
  constructor(x1, y1, x2, y2, name) {
    name = name === VOID ? null : name;
    this.t3t_1 = x1;
    this.u3t_1 = y1;
    this.v3t_1 = x2;
    this.w3t_1 = y2;
    this.x3t_1 = name;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y3t_1 = [P.z3v(0.0, 0.0), P.z3v(clamp_1(this.t3t_1, 0.0, 1.0), this.u3t_1), P.z3v(clamp_1(this.v3t_1, 0.0, 1.0), this.w3t_1), P.z3v(1.0, 1.0)];
  }
  toString() {
    var tmp0_elvis_lhs = this.x3t_1;
    return tmp0_elvis_lhs == null ? 'cubic-bezier(' + this.t3t_1 + ', ' + this.u3t_1 + ', ' + this.v3t_1 + ', ' + this.w3t_1 + ')' : tmp0_elvis_lhs;
  }
  fz(it) {
    var pivotLeft = it < 0.0 ? it * 10.0 : 0.0;
    var pivotRight = it > 1.0 ? it * 10.0 : 1.0;
    var pivot = it;
    var lastX = 0.0;
    var lastY = 0.0;
    var steps = 0;
    var inductionVariable = 0;
    if (inductionVariable < 50)
      $l$loop_0: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        steps = steps + 1 | 0;
        var res = calc(this, pivot);
        lastX = res.w3v_1;
        lastY = res.x3v_1;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = lastX - it;
        if (Math.abs(this_0) < 0.001)
          break $l$loop_0;
        if (it < lastX) {
          pivotRight = pivot;
          pivot = (pivotLeft + pivot) * 0.5;
        } else if (it > lastX) {
          pivotLeft = pivot;
          pivot = (pivotRight + pivot) * 0.5;
        } else {
          break $l$loop_0;
        }
      }
       while (inductionVariable < 50);
    return lastY;
  }
}
//endregion
function insertAt($this, n, min, max) {
  $this.t3b_1.a2p(n, min);
  $this.u3b_1.a2p(n, max);
}
function removeAt($this, n, count) {
  $this.t3b_1.c2p(n, count);
  $this.u3b_1.c2p(n, count);
}
function toStrokePointsList(_this__u8e3s4, info, mode, generateDebug, forceClosed) {
  mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
  generateDebug = generateDebug === VOID ? false : generateDebug;
  forceClosed = forceClosed === VOID ? null : forceClosed;
  return toStrokePointsList_0(_this__u8e3s4, info.c3c_1, info.h3c_1, info.f3c_1, info.g3c_1, info.i3c_1, mode, info.j3c_1, info.k3c_1, generateDebug, forceClosed);
}
var StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance;
var StrokePointsMode_NON_SCALABLE_POS_instance;
var StrokePointsMode_entriesInitialized;
function StrokePointsMode_initEntries() {
  if (StrokePointsMode_entriesInitialized)
    return Unit_instance;
  StrokePointsMode_entriesInitialized = true;
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance = new StrokePointsMode('SCALABLE_POS_NORMAL_WIDTH', 0);
  StrokePointsMode_NON_SCALABLE_POS_instance = new StrokePointsMode('NON_SCALABLE_POS', 1);
}
function toStrokePointsList_0(_this__u8e3s4, width, join, startCap, endCap, miterLimit, mode, lineDash, lineDashOffset, generateDebug, forceClosed) {
  join = join === VOID ? LineJoin_MITER_getInstance() : join;
  startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
  endCap = endCap === VOID ? LineCap_BUTT_getInstance() : endCap;
  miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
  mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
  lineDash = lineDash === VOID ? null : lineDash;
  lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
  generateDebug = generateDebug === VOID ? false : generateDebug;
  forceClosed = forceClosed === VOID ? null : forceClosed;
  var tmp;
  if (!(lineDash == null)) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList.j1();
    var tmp0_iterator = _this__u8e3s4.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.math.geom.bezier.toStrokePointsList.<anonymous>' call
      var list = toDashes(element, lineDash.tz(), lineDashOffset);
      addAll(destination, list);
    }
    tmp = destination;
  } else {
    tmp = _this__u8e3s4;
  }
  var curvesList = tmp;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(curvesList, 10));
  var tmp0_iterator_0 = curvesList.b1();
  while (tmp0_iterator_0.c1()) {
    var item = tmp0_iterator_0.d1();
    // Inline function 'korlibs.math.geom.bezier.toStrokePointsList.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = new StrokePointsBuilder(width / 2.0, mode, generateDebug);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.bezier.toStrokePointsList.<anonymous>.<anonymous>' call
    this_0.s3c(item, join, startCap, endCap, miterLimit, forceClosed);
    destination_0.h(this_0);
  }
  return destination_0;
}
function StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance() {
  StrokePointsMode_initEntries();
  return StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance;
}
function StrokePointsMode_NON_SCALABLE_POS_getInstance() {
  StrokePointsMode_initEntries();
  return StrokePointsMode_NON_SCALABLE_POS_instance;
}
function get_isConvex(_this__u8e3s4) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = isConvex$delegate;
    var property = isConvex$factory();
    var tmp0_elvis_lhs = this_0.c10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var isConvex$delegate;
function Curves$contiguous$delegate$lambda(this$0) {
  return function () {
    var inductionVariable = 1;
    var last = this$0.n3d_1.f1();
    var tmp;
    if (inductionVariable < last) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var curr = this$0.n3d_1.e1(n - 1 | 0);
        var next = this$0.n3d_1.e1(n);
        if (!curr.t3d_1.m2q().dz(next.t3d_1.l2q()))
          return false;
      }
       while (inductionVariable < last);
      tmp = Unit_instance;
    }
    return true;
  };
}
function Curves$infos$delegate$lambda(this$0) {
  return function () {
    var pos = 0.0;
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.n3d_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.math.geom.bezier.Curves.infos$delegate.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var start = pos;
      pos = pos + item.a();
      var tmp$ret$0 = new CurveInfo(index_0, item, start, pos, item.k3e());
      destination.h(tmp$ret$0);
    }
    return destination;
  };
}
function Curves$length$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.datastructure.sumOfDouble' call
    var sum = 0.0;
    var _iterator__ex2g4s = this$0.l3e().b1();
    while (_iterator__ex2g4s.c1()) {
      var element = _iterator__ex2g4s.d1();
      var tmp = sum;
      // Inline function 'korlibs.math.geom.bezier.Curves.length$delegate.<anonymous>.<anonymous>' call
      sum = tmp + element.a();
    }
    return sum;
  };
}
function Curves$findInfo$lambda($pos) {
  return function (it) {
    return it.vz($pos) ? 0 : it.i3e_1 < $pos ? -1 : 1;
  };
}
function Curves$ratioFromLength$lambda($length) {
  return function (it) {
    return it.i3e_1 < $length ? -1 : it.h3e_1 > $length ? 1 : 0;
  };
}
function Bezier$Extrema$allt$delegate$lambda(this$0) {
  return function () {
    return combineSmallDistinctSorted(Companion_getInstance_8(), this$0.y3e_1, this$0.z3e_1);
  };
}
function Bezier$Extrema$xt01$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.doubleArrayOf' call
    return primitiveArrayConcat([new Float64Array([0.0]), this$0.y3e_1, new Float64Array([1.0])]);
  };
}
function Bezier$Extrema$yt01$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.doubleArrayOf' call
    return primitiveArrayConcat([new Float64Array([0.0]), this$0.z3e_1, new Float64Array([1.0])]);
  };
}
function map($this, v, ds, de, ts, te) {
  return convertRange(v, ds, de, ts, te);
}
function angle($this, o, v1, v2) {
  var dx1 = v1.a2a_1 - o.a2a_1;
  var dy1 = v1.b2a_1 - o.b2a_1;
  var dx2 = v2.a2a_1 - o.a2a_1;
  var dy2 = v2.b2a_1 - o.b2a_1;
  var cross = dx1 * dy2 - dy1 * dx2;
  var dot = dx1 * dx2 + dy1 * dy2;
  // Inline function 'kotlin.math.atan2' call
  return Math.atan2(cross, dot);
}
function compute($this, t, points) {
  var p = points;
  var order = p.f1() - 1 | 0;
  if (equals(t, Companion_getInstance_6().mz_1))
    return p.e1(0);
  if (equals(t, Companion_getInstance_6().pz_1))
    return p.e1(order);
  if (order === 0)
    return p.e1(0);
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance_6().pz_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y_0(t, t));
  var tmp;
  switch (order) {
    case 1:
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_0 = p.e1(0);
      var this_1 = Vector2D.k2c(this_0.a2a_1 * mt, this_0.b2a_1 * mt);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_2 = p.e1(1);
      var scale = Ratio__toDouble_impl_o7epze(t);
      var that = Vector2D.k2c(this_2.a2a_1 * scale, this_2.b2a_1 * scale);
      tmp = Vector2D.k2c(this_1.a2a_1 + that.a2a_1, this_1.b2a_1 + that.b2a_1);
      break;
    case 2:
      var a = mt2;
      // Inline function 'korlibs.math.interpolation.times' call

      var b = mt * _Ratio___get_value__impl__57cli6(t) * 2;
      var c = t2;
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_3 = p.e1(0);
      var this_4 = Vector2D.k2c(this_3.a2a_1 * a, this_3.b2a_1 * a);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_5 = p.e1(1);
      var that_0 = Vector2D.k2c(this_5.a2a_1 * b, this_5.b2a_1 * b);
      var this_6 = Vector2D.k2c(this_4.a2a_1 + that_0.a2a_1, this_4.b2a_1 + that_0.b2a_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_7 = p.e1(2);
      var that_1 = Vector2D.k2c(this_7.a2a_1 * c, this_7.b2a_1 * c);
      tmp = Vector2D.k2c(this_6.a2a_1 + that_1.a2a_1, this_6.b2a_1 + that_1.b2a_1);
      break;
    case 3:
      var a_0 = mt2 * mt;
      // Inline function 'korlibs.math.interpolation.times' call

      var b_0 = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
      var c_0 = mt * t2 * 3;
      var d = Ratio__times_impl_ucdh7y(t, t2);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_8 = p.e1(0);
      var this_9 = Vector2D.k2c(this_8.a2a_1 * a_0, this_8.b2a_1 * a_0);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_10 = p.e1(1);
      var that_2 = Vector2D.k2c(this_10.a2a_1 * b_0, this_10.b2a_1 * b_0);
      var this_11 = Vector2D.k2c(this_9.a2a_1 + that_2.a2a_1, this_9.b2a_1 + that_2.b2a_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_12 = p.e1(2);
      var that_3 = Vector2D.k2c(this_12.a2a_1 * c_0, this_12.b2a_1 * c_0);
      var this_13 = Vector2D.k2c(this_11.a2a_1 + that_3.a2a_1, this_11.b2a_1 + that_3.b2a_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_14 = p.e1(3);
      var that_4 = Vector2D.k2c(this_14.a2a_1 * d, this_14.b2a_1 * d);
      tmp = Vector2D.k2c(this_13.a2a_1 + that_4.a2a_1, this_13.b2a_1 + that_4.b2a_1);
      break;
    default:
      var reason = 'higher order curves';
      throw NotImplementedError.be('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function derive($this, points) {
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.j1();
  var current = points;
  while (current.f1() >= 2) {
    var new_0 = new PointArrayList(current.f1() - 1 | 0);
    var c = current.f1() - 1 | 0;
    var inductionVariable = 0;
    var last = current.f1() - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        // Inline function 'korlibs.math.geom.Vector2D.minus' call
        var this_0 = current.e1(n + 1 | 0);
        var that = current.e1(n);
        var this_1 = Vector2D.k2c(this_0.a2a_1 - that.a2a_1, this_0.b2a_1 - that.b2a_1);
        var tmp$ret$2 = Vector2D.k2c(this_1.a2a_1 * c, this_1.b2a_1 * c);
        new_0.w2v(tmp$ret$2);
      }
       while (inductionVariable < last);
    out.h(new_0);
    current = new_0;
  }
  return out;
}
function align($this, points, line, out) {
  var p1 = line.r2c_1;
  var p2 = line.s2c_1;
  var tx = p1.a2a_1;
  var ty = p1.b2a_1;
  // Inline function 'kotlin.math.atan2' call
  var y = p2.b2a_1 - ty;
  var x = p2.a2a_1 - tx;
  var a = -Math.atan2(y, x);
  // Inline function 'korlibs.math.geom.fastForEach' call
  var inductionVariable = 0;
  var last = points.f1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.math.geom.bezier.Companion.align.<anonymous>' call
      var destruct = points.e1(n);
      var x_0 = destruct.nl();
      var y_0 = destruct.ol();
      var tmp = x_0 - tx;
      // Inline function 'kotlin.math.cos' call
      var tmp_0 = tmp * Math.cos(a);
      var tmp_1 = y_0 - ty;
      // Inline function 'kotlin.math.sin' call
      var tmp_2 = tmp_0 - tmp_1 * Math.sin(a);
      var tmp_3 = x_0 - tx;
      // Inline function 'kotlin.math.sin' call
      var tmp_4 = tmp_3 * Math.sin(a);
      var tmp_5 = y_0 - ty;
      // Inline function 'kotlin.math.cos' call
      var tmp$ret$4 = Math.cos(a);
      out.v2v(tmp_2, tmp_4 + tmp_5 * tmp$ret$4);
    }
     while (inductionVariable < last);
  return out;
}
function align$default($this, points, line, out, $super) {
  out = out === VOID ? new PointArrayList() : out;
  return align($this, points, line, out);
}
function droots($this, p) {
  switch (p.length) {
    case 3:
      var a = p[0];
      var b = p[1];
      var c = p[2];
      var d = a - 2 * b + c;
      if (!(d === 0.0)) {
        // Inline function 'kotlin.math.sqrt' call
        var x = b * b - a * c;
        var m1 = -Math.sqrt(x);
        var m2 = -a + b;
        var v1 = -(m1 + m2) / d;
        var v2 = -(-m1 + m2) / d;
        return doubleArrayOfValid01$default($this, v1, v2);
      } else if (!(b === c) && d === 0.0) {
        return doubleArrayOfValid01$default($this, (2.0 * b - c) / (2.0 * (b - c)));
      }

      break;
    case 2:
      var a_0 = p[0];
      var b_0 = p[1];
      if (!(a_0 === b_0))
        return doubleArrayOfValid01$default($this, a_0 / (a_0 - b_0));
      break;
    default:
      break;
  }
  return doubleArrayOfValid01$default($this);
}
function doubleArrayOfValid01($this, v1, v2, v3) {
  var v1Valid = 0.0 <= v1 ? v1 <= 1.0 : false;
  var v2Valid = 0.0 <= v2 ? v2 <= 1.0 : false;
  var v3Valid = 0.0 <= v3 ? v3 <= 1.0 : false;
  var validCount = 0;
  if (v1Valid) {
    validCount = validCount + 1 | 0;
  }
  if (v2Valid) {
    validCount = validCount + 1 | 0;
  }
  if (v3Valid) {
    validCount = validCount + 1 | 0;
  }
  if (validCount === 0)
    return $this.h3f_1;
  var index = 0;
  var out = new Float64Array(validCount);
  if (v1Valid) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    out[_unary__edvuaz] = normalizeZero(v1);
  }
  if (v2Valid) {
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    out[_unary__edvuaz_0] = normalizeZero(v2);
  }
  if (v3Valid) {
    var _unary__edvuaz_1 = index;
    index = _unary__edvuaz_1 + 1 | 0;
    out[_unary__edvuaz_1] = normalizeZero(v3);
  }
  return out;
}
function doubleArrayOfValid01$default($this, v1, v2, v3, $super) {
  v1 = v1 === VOID ? NaN : v1;
  v2 = v2 === VOID ? NaN : v2;
  v3 = v3 === VOID ? NaN : v3;
  return doubleArrayOfValid01($this, v1, v2, v3);
}
function combineSmallDistinctSorted($this, a, b) {
  var out = DoubleArrayList.g2p(a.length + b.length | 0);
  out.k2p(a);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < b.length) {
    // Inline function 'korlibs.math.geom.bezier.Companion.combineSmallDistinctSorted.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = b[_unary__edvuaz];
    if (!out.vz(it)) {
      out.t11(it);
    }
  }
  sort(out);
  return out.tz();
}
function _get_aligned__7fjidv($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.u3d_1;
  aligned$factory();
  return this_0.s1();
}
function _getBoundingBox($this, m) {
  var xmin = 0.0;
  var ymin = 0.0;
  var xmax = 0.0;
  var ymax = 0.0;
  var inductionVariable = 0;
  if (inductionVariable <= 1)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ext = $this.i3f().j3f(n);
      var min = Infinity;
      var max = -Infinity;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_0 = 0;
      while (n_0 < ext.length) {
        // Inline function 'korlibs.math.geom.bezier.Bezier._getBoundingBox.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        var t = ext[_unary__edvuaz];
        var p = $this.k3f(_Ratio___init__impl__9mwvn2(t));
        var value = n === 0 ? transformX(p, m) : transformY(p, m);
        // Inline function 'kotlin.math.min' call
        var a = min;
        min = Math.min(a, value);
        // Inline function 'kotlin.math.max' call
        var a_0 = max;
        max = Math.max(a_0, value);
      }
      if (n === 0) {
        xmin = min;
        xmax = max;
      } else {
        ymin = min;
        ymax = max;
      }
    }
     while (inductionVariable <= 1);
  return Companion_getInstance_1().c2i(xmin, ymin, xmax, ymax);
}
function findNearestLine($this, pX, pY, aX, aY, bX, bY, out) {
  out.o3f_1 = $this;
  var atobX = bX - aX;
  var atobY = bY - aY;
  var atopX = pX - aX;
  var atopY = pY - aY;
  var len = atobX * atobX + atobY * atobY;
  var dot = atopX * atobX + atopY * atobY;
  // Inline function 'kotlin.math.min' call
  // Inline function 'kotlin.math.max' call
  var b = dot / len;
  var b_0 = Math.max(0.0, b);
  var tmp$ret$1 = Math.min(1.0, b_0);
  var t = toRatio_0(tmp$ret$1);
  var tmp = out;
  // Inline function 'korlibs.math.interpolation.times' call
  var tmp_0 = aX + atobX * _Ratio___get_value__impl__57cli6(t);
  // Inline function 'korlibs.math.interpolation.times' call
  var tmp$ret$3 = atobY * _Ratio___get_value__impl__57cli6(t);
  tmp.l3f_1 = Vector2D.k2c(tmp_0, aY + tmp$ret$3);
  out.m3f_1 = t;
  out.n3f_1 = Companion_getInstance().u2k(out.l3f_1.a2a_1, out.l3f_1.b2a_1, pX, pY);
  return out;
}
var Companion_instance;
function Companion_getInstance_8() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function Bezier$aligned$delegate$lambda(this$0) {
  return function () {
    return align$default(Companion_getInstance_8(), this$0.t3d_1, Line2D.t2c(this$0.t3d_1.l2q(), this$0.t3d_1.m2q()));
  };
}
function Bezier$dpoints$delegate$lambda(this$0) {
  return function () {
    return derive(Companion_getInstance_8(), this$0.t3d_1);
  };
}
function Bezier$direction$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var p0 = this$0.t3d_1.e1(0);
    var p1 = this$0.t3d_1.e1(this$0.e3e());
    var up = this$0.t3d_1.e1(1);
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0 = p0.a2a_1;
    var y0 = p0.b2a_1;
    var x1 = p1.a2a_1;
    var y1 = p1.b2a_1;
    var tmp$ret$1 = Angle_between(x0, y0, x1, y1, up);
    return new Angle(tmp$ret$1);
  };
}
function Bezier$extrema$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.w3f());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.b2_1;
    var last = this_0.c2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.bezier.Bezier.extrema$delegate.<anonymous>.<anonymous>' call
        var dim = item;
        var tmp = Companion_getInstance_8();
        // Inline function 'korlibs.datastructure.mapDouble' call
        var this_1 = this$0.x3f().e1(0).o2v(dim);
        // Inline function 'kotlin.also' call
        var this_2 = new Float64Array(this_1.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
        var inductionVariable_0 = 0;
        var last_0 = this_1.length;
        if (inductionVariable_0 < last_0)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.math.geom.bezier.Bezier.extrema$delegate.<anonymous>.<anonymous>.<anonymous>' call
            this_2[n] = this_1[n];
          }
           while (inductionVariable_0 < last_0);
        var out = droots(tmp, this_2);
        if (this$0.e3e() === 3)
          out = combineSmallDistinctSorted(Companion_getInstance_8(), out, droots(Companion_getInstance_8(), this$0.x3f().e1(1).o2v(dim)));
        var tmp$ret$3 = out;
        destination.h(tmp$ret$3);
      }
       while (!(item === last));
    var out_0 = destination;
    return new Extrema(out_0.e1(0), out_0.e1(1));
  };
}
function Bezier$outerCircle$delegate$lambda(this$0) {
  return function () {
    return outerCircle(this$0.y3f());
  };
}
function Bezier$boundingBox$delegate$lambda(this$0) {
  return function () {
    return _getBoundingBox(this$0, Companion_getInstance_2().n2d_1);
  };
}
function Bezier$length$delegate$lambda(this$0) {
  return function () {
    var z = 0.5;
    var sum = 0.0;
    var inductionVariable = 0;
    var last = Companion_getInstance_8().d3f_1.length - 1 | 0;
    var tmp;
    if (inductionVariable <= last) {
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var t = _Ratio___init__impl__9mwvn2(z * Companion_getInstance_8().d3f_1[i] + z);
        var temp = this$0.z3f(t);
        sum = sum + Companion_getInstance_8().e3f_1[i] * temp.a();
      }
       while (inductionVariable <= last);
      tmp = Unit_instance;
    }
    return z * sum;
  };
}
function Bezier$lut$delegate$lambda(this$0) {
  return function () {
    return this$0.a3g();
  };
}
function Bezier$isLinear$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this$0.t3d_1.e1(this$0.e3e());
    var that = this$0.t3d_1.e1(0);
    var baseLength = Vector2D.k2c(this_0.a2a_1 - that.a2a_1, this_0.b2a_1 - that.b2a_1).a();
    // Inline function 'korlibs.datastructure.sumOfDouble' call
    var sum = 0.0;
    var progression = until(0, _get_aligned__7fjidv(this$0).f1());
    var inductionVariable = progression.b2_1;
    var last = progression.c2_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = sum;
        // Inline function 'korlibs.math.geom.bezier.Bezier.isLinear$delegate.<anonymous>.<anonymous>' call
        var it = element;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_1 = _get_aligned__7fjidv(this$0).i2c(it);
        sum = tmp + Math.abs(this_1);
      }
       while (!(element === last));
    return sum < baseLength / 50.0;
  };
}
function Bezier$isSimple$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (this$0.e3e() === 3) {
      var a1 = angle(Companion_getInstance_8(), this$0.t3d_1.e1(0), this$0.t3d_1.e1(3), this$0.t3d_1.e1(1));
      var a2 = angle(Companion_getInstance_8(), this$0.t3d_1.e1(0), this$0.t3d_1.e1(3), this$0.t3d_1.e1(2));
      var tmp_0;
      if (a1 > 0.0 && a2 < 0.0 || (a1 < 0.0 && a2 > 0.0)) {
        return false;
      }
      tmp = tmp_0;
    }
    var n1 = this$0.c3d(Companion_getInstance_6().mz_1);
    var n2 = this$0.c3d(Companion_getInstance_6().pz_1);
    var s = n1.a2a_1 * n2.a2a_1 + n1.b2a_1 * n2.b2a_1;
    // Inline function 'kotlin.math.abs' call
    // Inline function 'kotlin.math.acos' call
    var x = Math.acos(s);
    return Math.abs(x) < 3.141592653589793 / 3.0;
  };
}
function BezierCurveFromIndices($this, indices, points) {
  var p = new PointArrayList(indices.length);
  var inductionVariable = 0;
  var last = indices.length;
  while (inductionVariable < last) {
    var index = indices[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    p.z2v(points, index);
  }
  return Bezier.g3g(p);
}
var Companion_instance_0;
function Companion_getInstance_9() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function _split($this, t, hull, left) {
  var rt = convertRange(t, Companion_getInstance_6().mz_1, Companion_getInstance_6().pz_1, $this.t3e_1, $this.u3e_1);
  var rt1 = left ? $this.t3e_1 : rt;
  var rt2 = left ? rt : $this.u3e_1;
  var tmp;
  if ($this.s3e_1.e3e() < 2) {
    var p1 = $this.a3d(rt1);
    var p2 = $this.a3d(rt2);
    tmp = Bezier.d3g(p1, p2);
  } else {
    var indices = left ? Companion_getInstance_9().k3h_1 : Companion_getInstance_9().l3h_1;
    tmp = BezierCurveFromIndices(Companion_getInstance_9(), ensureNotNull(indices.e1($this.s3e_1.e3e())), ensureNotNull(hull));
  }
  var curve = tmp;
  return SubBezier.h3h(curve, rt1, rt2, $this.v3e_1);
}
function _splitLeft($this, t, hull) {
  return _split($this, t, hull, true);
}
function _splitLeft$default($this, t, hull, $super) {
  hull = hull === VOID ? $this.s3e_1.g3h(t) : hull;
  return _splitLeft($this, t, hull);
}
function _splitRight($this, t, hull) {
  return _split($this, t, hull, false);
}
function _splitRight$default($this, t, hull, $super) {
  hull = hull === VOID ? $this.s3e_1.g3h(t) : hull;
  return _splitRight($this, t, hull);
}
function estimateAt($this, values, value, out) {
  var result = binarySearch_0(values, value);
  if (_BSearchResult___get_found__impl__om04iz(result))
    return $this.m3h(out, _BSearchResult___get_index__impl__b5kraz(result), 0.0);
  var index = _BSearchResult___get_nearIndex__impl__s8nq43(result);
  if (value <= 0.0)
    return $this.m3h(out, 0, 0.0);
  if (index >= (values.f1() - 1 | 0))
    return $this.m3h(out, $this.q3g_1.f1() - 1 | 0, 0.0);
  var ratio0 = values.e1(index);
  var ratio1 = values.e1(index + 1 | 0);
  var ratio = convertRange_0(value, ratio0, ratio1, 0.0, 1.0);
  return $this.m3h(out, index, ratio);
}
function CurveLUT$toString$lambda(this$0) {
  return function (it) {
    return '' + this$0.r3g_1.e1(it) + ',len=' + this$0.n3h().e1(it) + ': ' + this$0.q3g_1.e1(it).toString();
  };
}
function toCurves(_this__u8e3s4, closed) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return new Curves(_this__u8e3s4, closed);
}
function toNonCurveSimplePointList(_this__u8e3s4, out) {
  out = out === VOID ? new PointArrayList() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var curves = _this__u8e3s4;
  var beziers = curves.n3d_1;
  var epsilon = 1.0E-5;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < beziers.f1()) {
    // Inline function 'korlibs.math.geom.bezier.toNonCurveSimplePointList.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var bezier = beziers.e1(_unary__edvuaz);
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(bezier.c3h().length === 0))
      return null;
    var points = bezier.t3d_1;
    // Inline function 'korlibs.math.geom.fastForEach' call
    var inductionVariable = 0;
    var last = points.f1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.bezier.toNonCurveSimplePointList.<anonymous>.<anonymous>' call
        var p = points.e1(n_0);
        if (out.h1() || !out.m2q().d2l(p, epsilon)) {
          out.w2v(p);
        }
      }
       while (inductionVariable < last);
  }
  if (out.m2q().d2l(out.l2q(), epsilon)) {
    out.a2w(out.f1() - 1 | 0);
  }
  return out;
}
var Arc_instance;
function Arc_getInstance() {
  return Arc_instance;
}
function toVectorPath(_this__u8e3s4, out) {
  out = out === VOID ? new VectorPath() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var first = {_v: true};
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < _this__u8e3s4.f1()) {
    // Inline function 'korlibs.math.geom.bezier.toVectorPath.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var curves = _this__u8e3s4.e1(_unary__edvuaz);
    if (curves instanceof Curves) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = curves.n3d_1;
      var n_0 = 0;
      while (n_0 < this_0.f1()) {
        // Inline function 'korlibs.math.geom.bezier.toVectorPath.<anonymous>.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_0.e1(_unary__edvuaz_0);
        toVectorPath$bezier(first, out, it);
      }
      if (curves.o3d_1) {
        out.n6();
      }
    } else {
      if (curves instanceof Bezier) {
        toVectorPath$bezier(first, out, curves);
      } else {
        throw NotImplementedError.be();
      }
    }
  }
  return out;
}
function toVectorPath_0(_this__u8e3s4, out) {
  out = out === VOID ? new VectorPath() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return toVectorPath(listOf(_this__u8e3s4), out);
}
function toBezier(_this__u8e3s4) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return Bezier.d3g(Vector2D.k2c(_this__u8e3s4.y2c(), _this__u8e3s4.z2c()), Vector2D.k2c(_this__u8e3s4.a2d(), _this__u8e3s4.b2d()));
}
function toDashes(_this__u8e3s4, pattern, offset) {
  offset = offset === VOID ? 0.0 : offset;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  if (pattern == null)
    return listOf(_this__u8e3s4);
  // Inline function 'kotlin.check' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.all' call
    var inductionVariable = 0;
    var last = pattern.length;
    while (inductionVariable < last) {
      var element = pattern[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.math.geom.bezier.toDashes.<anonymous>' call
      if (!(element <= 0.0)) {
        tmp$ret$1 = false;
        break $l$block;
      }
    }
    tmp$ret$1 = true;
  }
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!tmp$ret$1) {
    // Inline function 'kotlin.check.<anonymous>' call
    var message = 'Check failed.';
    throw IllegalStateException.h5(toString(message));
  }
  var length = _this__u8e3s4.a();
  var current = offset;
  var dashNow = true;
  var index = 0;
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.j1();
  while (current < length) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var len = getCyclic_0(pattern, _unary__edvuaz);
    if (dashNow) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = _this__u8e3s4.q3e(current, current + len);
      out.h(element_0);
    }
    current = current + len;
    dashNow = !dashNow;
  }
  return out;
}
function toVectorPath$bezier(first, $out, bezier) {
  var points = bezier.t3d_1;
  if (first._v) {
    $out.t3h(points.l2q());
    first._v = false;
  }
  switch (bezier.e3e()) {
    case 1:
      $out.g3i(points.e1(1));
      break;
    case 2:
      $out.h3i(points.e1(1), points.e1(2));
      break;
    case 3:
      $out.u3h(points.e1(1), points.e1(2), points.e1(3));
      break;
    default:
      // Inline function 'kotlin.TODO' call

      throw NotImplementedError.be();
  }
}
function isConvex$delegate$lambda($this$extraPropertyThis) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return $this$extraPropertyThis.p3d_1 || Convex_instance.i3i($this$extraPropertyThis);
}
function isConvex$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return it;
}
function isConvex$factory() {
  return getPropertyCallableRef('isConvex', 1, KProperty1, function (receiver) {
    return get_isConvex(receiver);
  }, null);
}
function infos$factory() {
  return getPropertyCallableRef('infos', 1, KProperty1, function (receiver) {
    return receiver.l3e();
  }, null);
}
function length$factory() {
  return getPropertyCallableRef('length', 1, KProperty1, function (receiver) {
    return receiver.a();
  }, null);
}
function aligned$factory() {
  return getPropertyCallableRef('aligned', 1, KProperty1, function (receiver) {
    return _get_aligned__7fjidv(receiver);
  }, null);
}
function dpoints$factory() {
  return getPropertyCallableRef('dpoints', 1, KProperty1, function (receiver) {
    return receiver.x3f();
  }, null);
}
function extrema$factory() {
  return getPropertyCallableRef('extrema', 1, KProperty1, function (receiver) {
    return receiver.i3f();
  }, null);
}
function outerCircle$factory() {
  return getPropertyCallableRef('outerCircle', 1, KProperty1, function (receiver) {
    return receiver.k3g();
  }, null);
}
function boundingBox$factory() {
  return getPropertyCallableRef('boundingBox', 1, KProperty1, function (receiver) {
    return receiver.y3f();
  }, null);
}
function length$factory_0() {
  return getPropertyCallableRef('length', 1, KProperty1, function (receiver) {
    return receiver.a();
  }, null);
}
function lut$factory() {
  return getPropertyCallableRef('lut', 1, KProperty1, function (receiver) {
    return receiver.l3g();
  }, null);
}
function xt01$factory() {
  return getPropertyCallableRef('xt01', 1, KProperty1, function (receiver) {
    return receiver.q3f();
  }, null);
}
function yt01$factory() {
  return getPropertyCallableRef('yt01', 1, KProperty1, function (receiver) {
    return receiver.r3f();
  }, null);
}
var properties_initialized__MathGeom_bezier_kt_sxrpnw;
function _init_properties__MathGeom_bezier_kt__br5r2i() {
  if (!properties_initialized__MathGeom_bezier_kt_sxrpnw) {
    properties_initialized__MathGeom_bezier_kt_sxrpnw = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_0 = isConvex$delegate$lambda;
    var transform = isConvex$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.e10_1 = transform;
    isConvex$delegate = this_0;
  }
}
var Companion_instance_1;
function Companion_getInstance_10() {
  return Companion_instance_1;
}
function quickFindPositionForNewNodeBestAreaFit($this, width, height) {
  var score = 1.7976931348623157E308;
  var areaFit;
  var bestNode = Companion_getInstance_1().p2d();
  var _iterator__ex2g4s = $this.m3i_1.b1();
  while (_iterator__ex2g4s.c1()) {
    var r = _iterator__ex2g4s.d1();
    if (r.m2a_1 >= width && r.n2a_1 >= height) {
      areaFit = r.m2a_1 * r.n2a_1 - width * height;
      if (areaFit < score) {
        bestNode = new Rectangle(r.k2a_1, r.l2a_1, width, height);
        score = areaFit;
      }
    }
  }
  return bestNode;
}
function splitFreeNode($this, freeNode, usedNode) {
  var newNode;
  if (usedNode.r2a() >= freeNode.s2a() || usedNode.s2a() <= freeNode.k2a_1 || usedNode.t2a() >= freeNode.u2a() || usedNode.u2a() <= freeNode.t2a()) {
    return false;
  }
  if (usedNode.k2a_1 < freeNode.s2a() && usedNode.s2a() > freeNode.k2a_1) {
    if (usedNode.l2a_1 > freeNode.l2a_1 && usedNode.l2a_1 < freeNode.u2a()) {
      newNode = freeNode.z2i(VOID, VOID, VOID, usedNode.l2a_1 - freeNode.l2a_1);
      $this.m3i_1.h(newNode);
    }
    if (usedNode.u2a() < freeNode.u2a()) {
      newNode = freeNode.z2i(VOID, usedNode.u2a(), VOID, freeNode.u2a() - usedNode.u2a());
      $this.m3i_1.h(newNode);
    }
  }
  if (usedNode.l2a_1 < freeNode.u2a() && usedNode.u2a() > freeNode.l2a_1) {
    if (usedNode.k2a_1 > freeNode.k2a_1 && usedNode.k2a_1 < freeNode.s2a()) {
      newNode = freeNode.z2i(VOID, VOID, usedNode.k2a_1 - freeNode.k2a_1);
      $this.m3i_1.h(newNode);
    }
    if (usedNode.s2a() < freeNode.s2a()) {
      newNode = freeNode.z2i(usedNode.s2a(), VOID, freeNode.s2a() - usedNode.s2a());
      $this.m3i_1.h(newNode);
    }
  }
  return true;
}
function pruneFreeList($this) {
  var len = $this.m3i_1.f1();
  var i = 0;
  while (i < len) {
    var j = i + 1 | 0;
    var tmpRect = $this.m3i_1.e1(i);
    $l$loop: while (j < len) {
      var tmpRect2 = $this.m3i_1.e1(j);
      if (Companion_getInstance_1().e2i(tmpRect, tmpRect2)) {
        $this.m3i_1.p3(i);
        i = i - 1 | 0;
        len = len - 1 | 0;
        break $l$loop;
      }
      if (Companion_getInstance_1().e2i(tmpRect2, tmpRect)) {
        $this.m3i_1.p3(j);
        len = len - 1 | 0;
        j = j - 1 | 0;
      }
      j = j + 1 | 0;
    }
    i = i + 1 | 0;
  }
}
var HitTestDirection_ANY_instance;
var HitTestDirection_UP_instance;
var HitTestDirection_RIGHT_instance;
var HitTestDirection_DOWN_instance;
var HitTestDirection_LEFT_instance;
var Companion_instance_2;
function Companion_getInstance_11() {
  return Companion_instance_2;
}
var HitTestDirection_entriesInitialized;
function HitTestDirection_initEntries() {
  if (HitTestDirection_entriesInitialized)
    return Unit_instance;
  HitTestDirection_entriesInitialized = true;
  HitTestDirection_ANY_instance = new HitTestDirection('ANY', 0);
  HitTestDirection_UP_instance = new HitTestDirection('UP', 1);
  HitTestDirection_RIGHT_instance = new HitTestDirection('RIGHT', 2);
  HitTestDirection_DOWN_instance = new HitTestDirection('DOWN', 3);
  HitTestDirection_LEFT_instance = new HitTestDirection('LEFT', 4);
}
function HitTestDirection_ANY_getInstance() {
  HitTestDirection_initEntries();
  return HitTestDirection_ANY_instance;
}
var Convex_instance;
function Convex_getInstance() {
  return Convex_instance;
}
function get_cachedPoints(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = cachedPoints$delegate;
    var property = cachedPoints$factory();
    var tmp0_elvis_lhs = this_0.c10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cachedPoints$delegate;
function getPoints2(_this__u8e3s4, out) {
  out = out === VOID ? new PointArrayList() : out;
  _init_properties__MathGeom_shape_kt__uqeev8();
  // Inline function 'korlibs.math.geom.shape.emitPoints2' call
  var i = Vector2D.v2c();
  var l = Vector2D.v2c();
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.w3h_1;
  var n_0 = 0;
  while (n_0 < this_0.f1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.sz(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.k2c(tmp, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_1));
        i = it;
        // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call

        out.w2v(it);
        l = it;
        break;
      case 1:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.k2c(tmp_0, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_3));
        // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call

        out.w2v(it_0);
        l = it_0;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 2:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.k2c(tmp_1, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.k2c(tmp_2, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_7));
        var sum = Companion_getInstance().t2k(l, c) + Companion_getInstance().t2k(c, a);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_0 = numberToInt(sum);
        var rcurveSteps = Math.max(a_0, 20);
        var dt = 1.0 / rcurveSteps;
        var lastPos = {_v: Vector2D.v2c()};
        var prevPos = {_v: Vector2D.v2c()};
        var emittedCount = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio = Companion_getInstance_6().mz_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos._v = Companion_getInstance_8().t3f(l, c, a, ratio);
        var nStart = false ? 0 : 1;
        var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
        var inductionVariable = nStart;
        if (inductionVariable <= nEnd)
          do {
            var n_1 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_1 = Companion_getInstance_8().t3f(l, c, a, ratio_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call
            out.w2v(it_1);
            emittedCount._v = emittedCount._v + 1 | 0;
            lastPos._v = prevPos._v;
            prevPos._v = it_1;
          }
           while (!(n_1 === nEnd));
        l = a;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 3:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c0 = Vector2D.k2c(tmp_3, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c1 = Vector2D.k2c(tmp_4, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_1 = Vector2D.k2c(tmp_5, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_13));
        var sum_0 = Companion_getInstance().t2k(l, c0) + Companion_getInstance().t2k(c0, c1) + Companion_getInstance().t2k(c1, a_1);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_2 = numberToInt(sum_0);
        var rcurveSteps_0 = Math.max(a_2, 20);
        var dt_0 = 1.0 / rcurveSteps_0;
        var lastPos_0 = {_v: Vector2D.v2c()};
        var prevPos_0 = {_v: Vector2D.v2c()};
        var emittedCount_0 = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio_1 = Companion_getInstance_6().mz_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos_0._v = Companion_getInstance_8().s3f(l, c0, c1, a_1, ratio_1);
        var nStart_0 = false ? 0 : 1;
        var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
        var inductionVariable_0 = nStart_0;
        if (inductionVariable_0 <= nEnd_0)
          do {
            var n_2 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_2 = Companion_getInstance_8().s3f(l, c0, c1, a_1, ratio_2);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call
            out.w2v(it_2);
            emittedCount_0._v = emittedCount_0._v + 1 | 0;
            lastPos_0._v = prevPos_0._v;
            prevPos_0._v = it_2;
          }
           while (!(n_2 === nEnd_0));
        l = a_1;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 4:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call

        var p = i;
        out.w2v(p);
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
    }
  }
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  return out;
}
function getPoints2List(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.j1();
  var current = {_v: new PointArrayList()};
  // Inline function 'korlibs.math.geom.shape.emitPoints2' call
  var i = Vector2D.v2c();
  var l = Vector2D.v2c();
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.w3h_1;
  var n_0 = 0;
  while (n_0 < this_0.f1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.sz(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.k2c(tmp, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_1));
        i = it;
        // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call

        if (true) {
          getPoints2List$flush(current, out);
        }

        current._v.w2v(it);
        l = it;
        break;
      case 1:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.k2c(tmp_0, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_3));
        // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call

        if (false) {
          getPoints2List$flush(current, out);
        }

        current._v.w2v(it_0);
        l = it_0;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 2:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.k2c(tmp_1, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.k2c(tmp_2, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_7));
        var sum = Companion_getInstance().t2k(l, c) + Companion_getInstance().t2k(c, a);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_0 = numberToInt(sum);
        var rcurveSteps = Math.max(a_0, 20);
        var dt = 1.0 / rcurveSteps;
        var lastPos = {_v: Vector2D.v2c()};
        var prevPos = {_v: Vector2D.v2c()};
        var emittedCount = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio = Companion_getInstance_6().mz_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos._v = Companion_getInstance_8().t3f(l, c, a, ratio);
        var nStart = false ? 0 : 1;
        var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
        var inductionVariable = nStart;
        if (inductionVariable <= nEnd)
          do {
            var n_1 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_1 = Companion_getInstance_8().t3f(l, c, a, ratio_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call
            if (false) {
              getPoints2List$flush(current, out);
            }
            current._v.w2v(it_1);
            emittedCount._v = emittedCount._v + 1 | 0;
            lastPos._v = prevPos._v;
            prevPos._v = it_1;
          }
           while (!(n_1 === nEnd));
        l = a;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 3:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c0 = Vector2D.k2c(tmp_3, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c1 = Vector2D.k2c(tmp_4, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_1 = Vector2D.k2c(tmp_5, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_13));
        var sum_0 = Companion_getInstance().t2k(l, c0) + Companion_getInstance().t2k(c0, c1) + Companion_getInstance().t2k(c1, a_1);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_2 = numberToInt(sum_0);
        var rcurveSteps_0 = Math.max(a_2, 20);
        var dt_0 = 1.0 / rcurveSteps_0;
        var lastPos_0 = {_v: Vector2D.v2c()};
        var prevPos_0 = {_v: Vector2D.v2c()};
        var emittedCount_0 = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio_1 = Companion_getInstance_6().mz_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos_0._v = Companion_getInstance_8().s3f(l, c0, c1, a_1, ratio_1);
        var nStart_0 = false ? 0 : 1;
        var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
        var inductionVariable_0 = nStart_0;
        if (inductionVariable_0 <= nEnd_0)
          do {
            var n_2 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_2 = Companion_getInstance_8().s3f(l, c0, c1, a_1, ratio_2);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call
            if (false) {
              getPoints2List$flush(current, out);
            }
            current._v.w2v(it_2);
            emittedCount_0._v = emittedCount_0._v + 1 | 0;
            lastPos_0._v = prevPos_0._v;
            prevPos_0._v = it_2;
          }
           while (!(n_2 === nEnd_0));
        l = a_1;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 4:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call

        var p = i;
        if (false) {
          getPoints2List$flush(current, out);
        }

        current._v.w2v(p);
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
    }
  }
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  getPoints2List$flush(current, out);
  return out;
}
function getPoints2List$flush(current, out) {
  if (!current._v.l2c())
    return Unit_instance;
  out.h(current._v);
  current._v = new PointArrayList();
}
function cachedPoints$delegate$lambda($this$PropertyThis) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  return getPoints2($this$PropertyThis);
}
function cachedPoints$factory() {
  return getPropertyCallableRef('cachedPoints', 1, KProperty1, function (receiver) {
    return get_cachedPoints(receiver);
  }, null);
}
var properties_initialized__MathGeom_shape_kt_lonmli;
function _init_properties__MathGeom_shape_kt__uqeev8() {
  if (!properties_initialized__MathGeom_shape_kt_lonmli) {
    properties_initialized__MathGeom_shape_kt_lonmli = true;
    cachedPoints$delegate = new PropertyThis(VOID, cachedPoints$delegate$lambda);
  }
}
var SliceRotation_R0_instance;
var SliceRotation_R90_instance;
var SliceRotation_R180_instance;
var SliceRotation_R270_instance;
var Companion_instance_3;
function Companion_getInstance_12() {
  SliceRotation_initEntries();
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function values() {
  return [SliceRotation_R0_getInstance(), SliceRotation_R90_getInstance(), SliceRotation_R180_getInstance(), SliceRotation_R270_getInstance()];
}
var SliceRotation_entriesInitialized;
function SliceRotation_initEntries() {
  if (SliceRotation_entriesInitialized)
    return Unit_instance;
  SliceRotation_entriesInitialized = true;
  SliceRotation_R0_instance = new SliceRotation('R0', 0);
  SliceRotation_R90_instance = new SliceRotation('R90', 1);
  SliceRotation_R180_instance = new SliceRotation('R180', 2);
  SliceRotation_R270_instance = new SliceRotation('R270', 3);
  Companion_getInstance_12();
}
function _SliceOrientation___init__impl__ewylib(raw) {
  return raw;
}
function _SliceOrientation___get_raw__impl__tj3u8w($this) {
  return $this;
}
function _SliceOrientation___get_rotation__impl__m65r0o($this) {
  return Companion_getInstance_12().e1(extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 2));
}
function _SliceOrientation___get_flipX__impl__lgb7bx($this) {
  return !(extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 2, 1) === 0);
}
function _SliceOrientation___init__impl__ewylib_0(rotation, flipX) {
  rotation = rotation === VOID ? SliceRotation_R0_getInstance() : rotation;
  flipX = flipX === VOID ? false : flipX;
  return _SliceOrientation___init__impl__ewylib(insert_0(insert(0, rotation.r3_1, 0, 2), flipX, 2));
}
function _SliceOrientation___get_indices__impl__km5on3($this) {
  return Companion_getInstance_13().f3j_1[extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
function _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq($this) {
  return _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R90_getInstance()) || _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R270_getInstance());
}
function SliceOrientation__toString_impl_tdph6r($this) {
  return Companion_getInstance_13().g3j_1[extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
var Companion_instance_4;
function Companion_getInstance_13() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function SliceOrientation__hashCode_impl_7mjkdw($this) {
  return $this;
}
function SliceOrientation__equals_impl_h4gywg($this, other) {
  if (!(other instanceof SliceOrientation))
    return false;
  if (!($this === (other instanceof SliceOrientation ? other.q3j_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_5;
function Companion_getInstance_14() {
  return Companion_instance_5;
}
function transformed_1(_this__u8e3s4, orientation) {
  var i = _SliceOrientation___get_indices__impl__km5on3(orientation);
  return new RectCoords(_this__u8e3s4.v3l(i[0]), _this__u8e3s4.w3l(i[0]), _this__u8e3s4.v3l(i[1]), _this__u8e3s4.w3l(i[1]), _this__u8e3s4.v3l(i[2]), _this__u8e3s4.w3l(i[2]), _this__u8e3s4.v3l(i[3]), _this__u8e3s4.w3l(i[3]));
}
function SliceRotation_R0_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R0_instance;
}
function SliceRotation_R90_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R90_instance;
}
function SliceRotation_R180_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R180_instance;
}
function SliceRotation_R270_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R270_instance;
}
function PolygonScanline$AllBuckets$pool$lambda(it) {
  it.hh();
  return Unit_instance;
}
function PolygonScanline$AllBuckets$pool$lambda_0(it) {
  return new Bucket();
}
function addPoint($this, x, y) {
  $this.t3n_1.v2v(x, y);
}
function addEdge($this, ax, ay, bx, by) {
  if (ax === bx && ay === by)
    return Unit_instance;
  var isHorizontal = ay === by;
  var iax = $this.c3o(ax);
  var ibx = $this.c3o(bx);
  var iay = $this.c3o(ay);
  var iby = $this.c3o(by);
  var edge = ay < by ? $this.n3n_1.z2t().d3o(iax, iay, ibx, iby, 1) : $this.n3n_1.z2t().d3o(ibx, iby, iax, iay, -1);
  $this.q3n_1.h(edge);
  if (isHorizontal) {
    $this.p3n_1.h(edge);
  } else {
    $this.o3n_1.h(edge);
    $this.r3n_1.j3n(edge);
  }
  $this.m3n_1 = BoundsBuilder__plus_impl_cz7f7x($this.m3n_1, Vector2D.k2c(ax, ay));
  $this.m3n_1 = BoundsBuilder__plus_impl_cz7f7x($this.m3n_1, Vector2D.k2c(bx, by));
}
var IntArrayListSort_instance;
function IntArrayListSort_getInstance() {
  if (IntArrayListSort_instance === VOID)
    new IntArrayListSort();
  return IntArrayListSort_instance;
}
function PolygonScanline$edgesPool$lambda(it) {
  return new MEdge();
}
var Companion_instance_6;
function Companion_getInstance_15() {
  return Companion_instance_6;
}
var Companion_instance_7;
function Companion_getInstance_16() {
  return Companion_instance_7;
}
var EdgePoint_A_instance;
var EdgePoint_B_instance;
var EdgePoint_entriesInitialized;
function EdgePoint_initEntries() {
  if (EdgePoint_entriesInitialized)
    return Unit_instance;
  EdgePoint_entriesInitialized = true;
  EdgePoint_A_instance = new EdgePoint('A', 0, 0);
  EdgePoint_B_instance = new EdgePoint('B', 1, 1);
}
function _get_outFill__zcv64g($this) {
  var tmp = $this.h3p_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('outFill');
  }
}
function EdgePoint_A_getInstance() {
  EdgePoint_initEntries();
  return EdgePoint_A_instance;
}
function EdgePoint_B_getInstance() {
  EdgePoint_initEntries();
  return EdgePoint_B_instance;
}
function strokeToFill(_this__u8e3s4, lineWidth, joins, startCap, endCap, miterLimit, lineDash, lineDashOffset, temp, outFill) {
  joins = joins === VOID ? LineJoin_MITER_getInstance() : joins;
  startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
  endCap = endCap === VOID ? startCap : endCap;
  miterLimit = miterLimit === VOID ? 4.0 : miterLimit;
  lineDash = lineDash === VOID ? null : lineDash;
  lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
  temp = temp === VOID ? new StrokeToFill() : temp;
  outFill = outFill === VOID ? new VectorPath(VOID, VOID, Winding_NON_ZERO_getInstance()) : outFill;
  var tmp;
  if (!(lineDash == null)) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = toCurvesList(_this__u8e3s4);
    var destination = ArrayList.j1();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
      var list = toDashes(element, lineDash.tz(), lineDashOffset);
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator_0 = destination.b1();
    while (tmp0_iterator_0.c1()) {
      var item = tmp0_iterator_0.d1();
      // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
      var tmp$ret$3 = toVectorPath_0(item);
      destination_0.h(tmp$ret$3);
    }
    tmp = destination_0;
  } else {
    tmp = listOf(_this__u8e3s4);
  }
  var strokePaths = tmp;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < strokePaths.f1()) {
    // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var strokePath = strokePaths.e1(_unary__edvuaz);
    temp.p3q(strokePath, lineWidth, joins, startCap, endCap, miterLimit, outFill);
  }
  return outFill;
}
function strokeToFill_0(_this__u8e3s4, info, temp, outFill) {
  temp = temp === VOID ? new StrokeToFill() : temp;
  outFill = outFill === VOID ? new VectorPath(VOID, VOID, Winding_NON_ZERO_getInstance()) : outFill;
  return strokeToFill(_this__u8e3s4, info.c3c_1, info.h3c_1, info.f3c_1, info.g3c_1, info.i3c_1, info.j3c_1, info.k3c_1, temp, outFill);
}
function t($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.t3q_1;
    if (this_0.p2a()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.k2c(this_0.e2e(p.a2a_1, p.b2a_1), this_0.h2e(p.a2a_1, p.b2a_1));
  }
  return tmp$ret$0;
}
var _bvhCurvesCacheVersion$delegate;
var _bvhCurvesCache$delegate;
function set__curvesCacheVersion(_this__u8e3s4, _set____db54di) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var this_0 = _curvesCacheVersion$delegate;
  var property = _curvesCacheVersion$factory();
  var tmp0_elvis_lhs = this_0.a10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__curvesCacheVersion(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _curvesCacheVersion$delegate;
    var property = _curvesCacheVersion$factory_0();
    var tmp = _this__u8e3s4.zz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a10_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _curvesCacheVersion$delegate;
function set__curvesCache(_this__u8e3s4, _set____db54di) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var this_0 = _curvesCache$delegate;
  var property = _curvesCache$factory();
  var tmp0_elvis_lhs = this_0.a10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__curvesCache(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _curvesCache$delegate;
    var property = _curvesCache$factory_0();
    var tmp = _this__u8e3s4.zz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a10_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _curvesCache$delegate;
var Companion_instance_8;
function Companion_getInstance_17() {
  return Companion_instance_8;
}
function ensureMoveTo($this, p) {
  if ($this.l2c())
    return false;
  $this.t3h(p);
  return true;
}
function getCurvesList(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  if (!(get__curvesCacheVersion(_this__u8e3s4) === _this__u8e3s4.b3i_1)) {
    set__curvesCacheVersion(_this__u8e3s4, _this__u8e3s4.b3i_1);
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.arrayListOf' call
    var this_0 = ArrayList.j1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>' call
    var currentClosed = {_v: false};
    // Inline function 'kotlin.collections.arrayListOf' call
    var current = {_v: ArrayList.j1()};
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges' call
    var m = Vector2D.v2c();
    var l = Vector2D.v2c();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = _this__u8e3s4.w3h_1;
    var n_0 = 0;
    while (n_0 < this_1.f1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.sz(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.k2c(tmp, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_1));
          m = it;
          l = it;
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
          break;
        case 1:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.k2c(tmp_0, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_2 = current._v;
          var element = Bezier.d3g(p1, it_0);
          this_2.h(element);
          l = it_0;
          break;
        case 2:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var p1_0 = Vector2D.k2c(tmp_1, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var p2 = Vector2D.k2c(tmp_2, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_7));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1_1 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_3 = current._v;
          var element_0 = Bezier.e3g(p1_1, p1_0, p2);
          this_3.h(element_0);
          l = p2;
          break;
        case 3:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var p1_2 = Vector2D.k2c(tmp_3, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var p2_0 = Vector2D.k2c(tmp_4, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = _this__u8e3s4.x3h_1.e1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var p3 = Vector2D.k2c(tmp_5, _this__u8e3s4.x3h_1.e1(_unary__edvuaz_13));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1_3 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_4 = current._v;
          var element_1 = Bezier.f3g(p1_3, p1_2, p2_0, p3);
          this_4.h(element_1);
          l = p3;
          break;
        case 4:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var equal = true ? l.dz(m) : l.equals(m);
          if (!equal) {
            // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call
            var p1_4 = l;
            var p2_1 = m;
            // Inline function 'kotlin.collections.plusAssign' call
            var this_5 = current._v;
            var element_2 = Bezier.d3g(p1_4, p2_1);
            this_5.h(element_2);
          }

          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          currentClosed._v = true;
          getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
          break;
      }
    }
    getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
    set__curvesCache(_this__u8e3s4, this_0);
  }
  return ensureNotNull(get__curvesCache(_this__u8e3s4));
}
function plus(_this__u8e3s4, path) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return with_0(_this__u8e3s4, path);
}
function with_0(_this__u8e3s4, path, transform) {
  transform = transform === VOID ? Companion_getInstance_2().n2d_1 : transform;
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var bb = {_v: new BoundsBuilder(_this__u8e3s4)};
  var curvesList = getCurvesList(path);
  if (curvesList.h1() && path.l2c()) {
    path.h3r(new with$1(bb));
  }
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < curvesList.f1()) {
    // Inline function 'korlibs.math.geom.vector.with.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = curvesList.e1(_unary__edvuaz).n3d_1;
    var n_0 = 0;
    while (n_0 < this_0.f1()) {
      // Inline function 'korlibs.math.geom.vector.with.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var bezier = this_0.e1(_unary__edvuaz_0);
      bb._v = new BoundsBuilder(BoundsBuilder__plus_impl_cz7f7x_0(bb._v.n2b_1, bezier.j3g(transform)));
    }
  }
  return bb._v.n2b_1;
}
function write(_this__u8e3s4, path) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.w3h_1;
  var n_0 = 0;
  while (n_0 < this_0.f1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.sz(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.x3h_1.e1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.k2c(tmp, path.x3h_1.e1(_unary__edvuaz_1));
        _this__u8e3s4.t3h(it);
        break;
      case 1:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.x3h_1.e1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.k2c(tmp_0, path.x3h_1.e1(_unary__edvuaz_3));
        _this__u8e3s4.g3i(it_0);
        break;
      case 2:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.x3h_1.e1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var p1 = Vector2D.k2c(tmp_1, path.x3h_1.e1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.x3h_1.e1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var p2 = Vector2D.k2c(tmp_2, path.x3h_1.e1(_unary__edvuaz_7));
        _this__u8e3s4.h3i(p1, p2);
        break;
      case 3:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.x3h_1.e1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var p1_0 = Vector2D.k2c(tmp_3, path.x3h_1.e1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.x3h_1.e1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var p2_0 = Vector2D.k2c(tmp_4, path.x3h_1.e1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.x3h_1.e1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var p3 = Vector2D.k2c(tmp_5, path.x3h_1.e1(_unary__edvuaz_13));
        _this__u8e3s4.u3h(p1_0, p2_0, p3);
        break;
      case 4:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        _this__u8e3s4.n6();
        break;
    }
  }
}
function getCurves(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var curvesList = getCurvesList(_this__u8e3s4);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.j1();
  var tmp0_iterator = curvesList.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.math.geom.vector.getCurves.<anonymous>' call
    var list = element.n3d_1;
    addAll(destination, list);
  }
  var tmp = destination;
  var tmp59_safe_receiver = lastOrNull(curvesList);
  var tmp0_elvis_lhs = tmp59_safe_receiver == null ? null : tmp59_safe_receiver.o3d_1;
  return toCurves(tmp, tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs);
}
function toCurvesList(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return getCurvesList(_this__u8e3s4);
}
function applyTransform(_this__u8e3s4, m) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp;
  if (m.q2a()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.transformPoints' call
    var progression = step(until(0, _this__u8e3s4.x3h_1.f1()), 2);
    var inductionVariable = progression.b2_1;
    var last = progression.c2_1;
    var step_0 = progression.d2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        // Inline function 'korlibs.math.geom.vector.applyTransform.<anonymous>' call
        var it = Vector2D.k2c(_this__u8e3s4.x3h_1.e1(n + 0 | 0), _this__u8e3s4.x3h_1.e1(n + 1 | 0));
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          if (m.p2a()) {
            tmp$ret$0 = it;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.k2c(m.e2e(it.a2a_1, it.b2a_1), m.h2e(it.a2a_1, it.b2a_1));
        }
        var p = tmp$ret$0;
        _this__u8e3s4.x3h_1.s2p(n + 0 | 0, p.a2a_1);
        _this__u8e3s4.x3h_1.s2p(n + 1 | 0, p.b2a_1);
      }
       while (!(n === last));
    _this__u8e3s4.b3i_1 = _this__u8e3s4.b3i_1 + 1 | 0;
    tmp = _this__u8e3s4;
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function getCurvesList$_anonymous_$flush_1e57i7(current, $out, currentClosed, $this_getCurvesList) {
  if (current._v.h1())
    return Unit_instance;
  // Inline function 'kotlin.also' call
  var this_0 = new Curves(current._v, currentClosed._v);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>$flush.<anonymous>' call
  this_0.p3d_1 = $this_getCurvesList.a3i_1;
  $out.h(this_0);
  currentClosed._v = false;
  // Inline function 'kotlin.collections.arrayListOf' call
  current._v = ArrayList.j1();
}
function _bvhCurvesCacheVersion$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return -1;
}
function _bvhCurvesCache$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return null;
}
function _curvesCacheVersion$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return -1;
}
function _curvesCache$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return null;
}
function _curvesCacheVersion$factory() {
  return getPropertyCallableRef('_curvesCacheVersion', 1, KMutableProperty1, function (receiver) {
    return get__curvesCacheVersion(receiver);
  }, function (receiver, value) {
    return set__curvesCacheVersion(receiver, value);
  });
}
function _curvesCacheVersion$factory_0() {
  return getPropertyCallableRef('_curvesCacheVersion', 1, KMutableProperty1, function (receiver) {
    return get__curvesCacheVersion(receiver);
  }, function (receiver, value) {
    return set__curvesCacheVersion(receiver, value);
  });
}
function _curvesCache$factory() {
  return getPropertyCallableRef('_curvesCache', 1, KMutableProperty1, function (receiver) {
    return get__curvesCache(receiver);
  }, function (receiver, value) {
    return set__curvesCache(receiver, value);
  });
}
function _curvesCache$factory_0() {
  return getPropertyCallableRef('_curvesCache', 1, KMutableProperty1, function (receiver) {
    return get__curvesCache(receiver);
  }, function (receiver, value) {
    return set__curvesCache(receiver, value);
  });
}
var properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk;
function _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe() {
  if (!properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk) {
    properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _bvhCurvesCacheVersion$delegate$lambda;
    _bvhCurvesCacheVersion$delegate = new Property(null, default_0);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_1 = _bvhCurvesCache$delegate$lambda;
    _bvhCurvesCache$delegate = new Property(null, default_1);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_2 = _curvesCacheVersion$delegate$lambda;
    _curvesCacheVersion$delegate = new Property(null, default_2);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_3 = _curvesCache$delegate$lambda;
    _curvesCache$delegate = new Property(null, default_3);
  }
}
var Winding_EVEN_ODD_instance;
var Winding_NON_ZERO_instance;
var Companion_instance_9;
function Companion_getInstance_18() {
  return Companion_instance_9;
}
var Winding_entriesInitialized;
function Winding_initEntries() {
  if (Winding_entriesInitialized)
    return Unit_instance;
  Winding_entriesInitialized = true;
  Winding_EVEN_ODD_instance = new Winding('EVEN_ODD', 0, 'evenOdd');
  Winding_NON_ZERO_instance = new Winding('NON_ZERO', 1, 'nonZero');
}
var LineJoin_BEVEL_instance;
var LineJoin_ROUND_instance;
var LineJoin_MITER_instance;
var Companion_instance_10;
function Companion_getInstance_19() {
  return Companion_instance_10;
}
var LineJoin_entriesInitialized;
function LineJoin_initEntries() {
  if (LineJoin_entriesInitialized)
    return Unit_instance;
  LineJoin_entriesInitialized = true;
  LineJoin_BEVEL_instance = new LineJoin('BEVEL', 0);
  LineJoin_ROUND_instance = new LineJoin('ROUND', 1);
  LineJoin_MITER_instance = new LineJoin('MITER', 2);
}
var LineCap_BUTT_instance;
var LineCap_SQUARE_instance;
var LineCap_ROUND_instance;
var Companion_instance_11;
function Companion_getInstance_20() {
  return Companion_instance_11;
}
var LineCap_entriesInitialized;
function LineCap_initEntries() {
  if (LineCap_entriesInitialized)
    return Unit_instance;
  LineCap_entriesInitialized = true;
  LineCap_BUTT_instance = new LineCap('BUTT', 0);
  LineCap_SQUARE_instance = new LineCap('SQUARE', 1);
  LineCap_ROUND_instance = new LineCap('ROUND', 2);
}
var LineScaleMode_NONE_instance;
var LineScaleMode_HORIZONTAL_instance;
var LineScaleMode_VERTICAL_instance;
var LineScaleMode_NORMAL_instance;
var LineScaleMode_entriesInitialized;
function LineScaleMode_initEntries() {
  if (LineScaleMode_entriesInitialized)
    return Unit_instance;
  LineScaleMode_entriesInitialized = true;
  LineScaleMode_NONE_instance = new LineScaleMode('NONE', 0, false, false);
  LineScaleMode_HORIZONTAL_instance = new LineScaleMode('HORIZONTAL', 1, true, false);
  LineScaleMode_VERTICAL_instance = new LineScaleMode('VERTICAL', 2, false, true);
  LineScaleMode_NORMAL_instance = new LineScaleMode('NORMAL', 3, true, true);
}
var Companion_instance_12;
function Companion_getInstance_21() {
  return Companion_instance_12;
}
function Winding_EVEN_ODD_getInstance() {
  Winding_initEntries();
  return Winding_EVEN_ODD_instance;
}
function Winding_NON_ZERO_getInstance() {
  Winding_initEntries();
  return Winding_NON_ZERO_instance;
}
function LineJoin_BEVEL_getInstance() {
  LineJoin_initEntries();
  return LineJoin_BEVEL_instance;
}
function LineJoin_MITER_getInstance() {
  LineJoin_initEntries();
  return LineJoin_MITER_instance;
}
function LineCap_BUTT_getInstance() {
  LineCap_initEntries();
  return LineCap_BUTT_instance;
}
function LineCap_SQUARE_getInstance() {
  LineCap_initEntries();
  return LineCap_SQUARE_instance;
}
function LineScaleMode_NONE_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_NONE_instance;
}
function LineScaleMode_NORMAL_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_NORMAL_instance;
}
function MPoint$Companion$POOL$lambda(it) {
  it.a3s(0.0, 0.0);
  return Unit_instance;
}
function MPoint$Companion$POOL$lambda_0(it) {
  return Companion_getInstance_22().p2d();
}
var Companion_instance_13;
function Companion_getInstance_22() {
  if (Companion_instance_13 === VOID)
    new Companion_13();
  return Companion_instance_13;
}
function MMatrix$Companion$POOL$lambda(it) {
  it.l3s();
  return Unit_instance;
}
function MMatrix$Companion$POOL$lambda_0(it) {
  return new MMatrix();
}
var Companion_instance_14;
function Companion_getInstance_23() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
var Companion_instance_15;
function Companion_getInstance_24() {
  return Companion_instance_15;
}
function MRectangle$Companion$POOL$lambda(it) {
  it.hh();
  return Unit_instance;
}
function MRectangle$Companion$POOL$lambda_0(it) {
  return Companion_getInstance_25().p2d();
}
var Companion_instance_16;
function Companion_getInstance_25() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
function get_immutable(_this__u8e3s4) {
  return _this__u8e3s4;
}
function get_mutable(_this__u8e3s4) {
  return new MRectangle(_this__u8e3s4.k2a_1, _this__u8e3s4.l2a_1, _this__u8e3s4.m2a_1, _this__u8e3s4.n2a_1);
}
function toMatrix4(_this__u8e3s4) {
  if (_this__u8e3s4.p2a())
    return Companion_getInstance_5().s2g_1;
  return Companion_getInstance_5().v2g(_this__u8e3s4.r2d_1, _this__u8e3s4.t2d_1, 0.0, _this__u8e3s4.v2d_1, _this__u8e3s4.s2d_1, _this__u8e3s4.u2d_1, 0.0, _this__u8e3s4.w2d_1, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
}
function lineIntersectionPoint(_this__u8e3s4, l1, l2) {
  return l1.w3s(l2);
}
function projectedPoint(_this__u8e3s4, point) {
  return projectedPoint_0(Companion_instance_15, _this__u8e3s4.e3d_1, _this__u8e3s4.f3d_1, point);
}
function projectedPoint_0(_this__u8e3s4, v1, v2, point) {
  return projectedPoint_1(_this__u8e3s4, v1.a2a_1, v1.b2a_1, v2.a2a_1, v2.b2a_1, point.a2a_1, point.b2a_1);
}
function projectedPoint_1(_this__u8e3s4, v1x, v1y, v2x, v2y, px, py) {
  var e1x = v2x - v1x;
  var e1y = v2y - v1y;
  var e2x = px - v1x;
  var e2y = py - v1y;
  var valDp = Companion_getInstance_22().c3s(e1x, e1y, e2x, e2y);
  // Inline function 'kotlin.math.hypot' call
  var lenLineE1 = hypot(e1x, e1y);
  // Inline function 'kotlin.math.hypot' call
  var lenLineE2 = hypot(e2x, e2y);
  if (lenLineE1 === 0.0 || lenLineE2 === 0.0) {
    return Vector2D.k2c(px, py);
  }
  var cos = valDp / (lenLineE1 * lenLineE2);
  var projLenOfLine = cos * lenLineE2;
  return Vector2D.k2c(v1x + projLenOfLine * e1x / lenLineE1, v1y + projLenOfLine * e1y / lenLineE1);
}
function floorCeil(v) {
  var tmp;
  if (v < 0.0) {
    // Inline function 'kotlin.math.ceil' call
    tmp = Math.ceil(v);
  } else {
    // Inline function 'kotlin.math.floor' call
    tmp = Math.floor(v);
  }
  return tmp;
}
function get__ALL_LIST() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.getValue' call
  var this_0 = _ALL_LIST$delegate;
  _ALL_LIST$factory();
  return this_0.s1();
}
var _ALL_LIST$delegate;
var _ALL$delegate;
var Easings_SMOOTH_instance;
var Easings_EASE_IN_ELASTIC_instance;
var Easings_EASE_OUT_ELASTIC_instance;
var Easings_EASE_OUT_BOUNCE_instance;
var Easings_LINEAR_instance;
var Easings_EASE_instance;
var Easings_EASE_IN_instance;
var Easings_EASE_OUT_instance;
var Easings_EASE_IN_OUT_instance;
var Easings_EASE_IN_OLD_instance;
var Easings_EASE_OUT_OLD_instance;
var Easings_EASE_IN_OUT_OLD_instance;
var Easings_EASE_OUT_IN_OLD_instance;
var Easings_EASE_IN_BACK_instance;
var Easings_EASE_OUT_BACK_instance;
var Easings_EASE_IN_OUT_BACK_instance;
var Easings_EASE_OUT_IN_BACK_instance;
var Easings_EASE_IN_OUT_ELASTIC_instance;
var Easings_EASE_OUT_IN_ELASTIC_instance;
var Easings_EASE_IN_BOUNCE_instance;
var Easings_EASE_IN_OUT_BOUNCE_instance;
var Easings_EASE_OUT_IN_BOUNCE_instance;
var Easings_EASE_IN_QUAD_instance;
var Easings_EASE_OUT_QUAD_instance;
var Easings_EASE_IN_OUT_QUAD_instance;
var Easings_EASE_SINE_instance;
var Easings_EASE_CLAMP_START_instance;
var Easings_EASE_CLAMP_END_instance;
var Easings_EASE_CLAMP_MIDDLE_instance;
function values_0() {
  return [Easings_SMOOTH_getInstance(), Easings_EASE_IN_ELASTIC_getInstance(), Easings_EASE_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_BOUNCE_getInstance(), Easings_LINEAR_getInstance(), Easings_EASE_getInstance(), Easings_EASE_IN_getInstance(), Easings_EASE_OUT_getInstance(), Easings_EASE_IN_OUT_getInstance(), Easings_EASE_IN_OLD_getInstance(), Easings_EASE_OUT_OLD_getInstance(), Easings_EASE_IN_OUT_OLD_getInstance(), Easings_EASE_OUT_IN_OLD_getInstance(), Easings_EASE_IN_BACK_getInstance(), Easings_EASE_OUT_BACK_getInstance(), Easings_EASE_IN_OUT_BACK_getInstance(), Easings_EASE_OUT_IN_BACK_getInstance(), Easings_EASE_IN_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_IN_ELASTIC_getInstance(), Easings_EASE_IN_BOUNCE_getInstance(), Easings_EASE_IN_OUT_BOUNCE_getInstance(), Easings_EASE_OUT_IN_BOUNCE_getInstance(), Easings_EASE_IN_QUAD_getInstance(), Easings_EASE_OUT_QUAD_getInstance(), Easings_EASE_IN_OUT_QUAD_getInstance(), Easings_EASE_SINE_getInstance(), Easings_EASE_CLAMP_START_getInstance(), Easings_EASE_CLAMP_END_getInstance(), Easings_EASE_CLAMP_MIDDLE_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values_0());
  return $ENTRIES;
}
var Easings_entriesInitialized;
function Easings_initEntries() {
  if (Easings_entriesInitialized)
    return Unit_instance;
  Easings_entriesInitialized = true;
  Easings_SMOOTH_instance = new Easings$SMOOTH();
  Easings_EASE_IN_ELASTIC_instance = new Easings$EASE_IN_ELASTIC();
  Easings_EASE_OUT_ELASTIC_instance = new Easings$EASE_OUT_ELASTIC();
  Easings_EASE_OUT_BOUNCE_instance = new Easings$EASE_OUT_BOUNCE();
  Easings_LINEAR_instance = new Easings$LINEAR();
  Easings_EASE_instance = new Easings$EASE();
  Easings_EASE_IN_instance = new Easings$EASE_IN();
  Easings_EASE_OUT_instance = new Easings$EASE_OUT();
  Easings_EASE_IN_OUT_instance = new Easings$EASE_IN_OUT();
  Easings_EASE_IN_OLD_instance = new Easings$EASE_IN_OLD();
  Easings_EASE_OUT_OLD_instance = new Easings$EASE_OUT_OLD();
  Easings_EASE_IN_OUT_OLD_instance = new Easings$EASE_IN_OUT_OLD();
  Easings_EASE_OUT_IN_OLD_instance = new Easings$EASE_OUT_IN_OLD();
  Easings_EASE_IN_BACK_instance = new Easings$EASE_IN_BACK();
  Easings_EASE_OUT_BACK_instance = new Easings$EASE_OUT_BACK();
  Easings_EASE_IN_OUT_BACK_instance = new Easings$EASE_IN_OUT_BACK();
  Easings_EASE_OUT_IN_BACK_instance = new Easings$EASE_OUT_IN_BACK();
  Easings_EASE_IN_OUT_ELASTIC_instance = new Easings$EASE_IN_OUT_ELASTIC();
  Easings_EASE_OUT_IN_ELASTIC_instance = new Easings$EASE_OUT_IN_ELASTIC();
  Easings_EASE_IN_BOUNCE_instance = new Easings$EASE_IN_BOUNCE();
  Easings_EASE_IN_OUT_BOUNCE_instance = new Easings$EASE_IN_OUT_BOUNCE();
  Easings_EASE_OUT_IN_BOUNCE_instance = new Easings$EASE_OUT_IN_BOUNCE();
  Easings_EASE_IN_QUAD_instance = new Easings$EASE_IN_QUAD();
  Easings_EASE_OUT_QUAD_instance = new Easings$EASE_OUT_QUAD();
  Easings_EASE_IN_OUT_QUAD_instance = new Easings$EASE_IN_OUT_QUAD();
  Easings_EASE_SINE_instance = new Easings$EASE_SINE();
  Easings_EASE_CLAMP_START_instance = new Easings$EASE_CLAMP_START();
  Easings_EASE_CLAMP_END_instance = new Easings$EASE_CLAMP_END();
  Easings_EASE_CLAMP_MIDDLE_instance = new Easings$EASE_CLAMP_MIDDLE();
}
var $ENTRIES;
function calc($this, it) {
  var t = toRatio_1(it);
  var p = $this.y3t_1;
  var order = p.length - 1 | 0;
  if (equals(t, Companion_getInstance_6().mz_1))
    return p[0];
  if (equals(t, Companion_getInstance_6().pz_1))
    return p[order];
  if (order === 0)
    return p[0];
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance_6().pz_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y_0(t, t));
  var a = mt2 * mt;
  // Inline function 'korlibs.math.interpolation.times' call
  var b = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
  var c = mt * t2 * 3;
  var d = Ratio__times_impl_ucdh7y(t, t2);
  return p[0].i2i(a).a3w(p[1].i2i(b)).a3w(p[2].i2i(c)).a3w(p[3].i2i(d));
}
function get_EASE_IN_OUT_QUAD(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_OUT_QUAD_getInstance();
}
function _ALL_LIST$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  return get_entries();
}
function _ALL$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = get__ALL_LIST();
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.pc(capacity);
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.math.interpolation._ALL$delegate.<anonymous>.<anonymous>' call
    var tmp$ret$0 = element.q3_1;
    destination.h3(tmp$ret$0, element);
  }
  return destination;
}
function Easings_SMOOTH_getInstance() {
  Easings_initEntries();
  return Easings_SMOOTH_instance;
}
function Easings_EASE_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_ELASTIC_instance;
}
function Easings_EASE_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BOUNCE_instance;
}
function Easings_LINEAR_getInstance() {
  Easings_initEntries();
  return Easings_LINEAR_instance;
}
function Easings_EASE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_instance;
}
function Easings_EASE_IN_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_instance;
}
function Easings_EASE_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_instance;
}
function Easings_EASE_IN_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_instance;
}
function Easings_EASE_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OLD_instance;
}
function Easings_EASE_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_OLD_instance;
}
function Easings_EASE_IN_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_OLD_instance;
}
function Easings_EASE_OUT_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_OLD_instance;
}
function Easings_EASE_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BACK_instance;
}
function Easings_EASE_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BACK_instance;
}
function Easings_EASE_IN_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BACK_instance;
}
function Easings_EASE_OUT_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BACK_instance;
}
function Easings_EASE_IN_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_ELASTIC_instance;
}
function Easings_EASE_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BOUNCE_instance;
}
function Easings_EASE_IN_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BOUNCE_instance;
}
function Easings_EASE_OUT_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BOUNCE_instance;
}
function Easings_EASE_IN_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_QUAD_instance;
}
function Easings_EASE_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_QUAD_instance;
}
function Easings_EASE_IN_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_QUAD_instance;
}
function Easings_EASE_SINE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_SINE_instance;
}
function Easings_EASE_CLAMP_START_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_START_instance;
}
function Easings_EASE_CLAMP_END_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_END_instance;
}
function Easings_EASE_CLAMP_MIDDLE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_MIDDLE_instance;
}
function _ALL_LIST$factory() {
  return getPropertyCallableRef('_ALL_LIST', 0, KProperty0, function () {
    return get__ALL_LIST();
  }, null);
}
var properties_initialized_Easings_kt_w5y1uw;
function _init_properties_Easings_kt__swvzhy() {
  if (!properties_initialized_Easings_kt_w5y1uw) {
    properties_initialized_Easings_kt_w5y1uw = true;
    var tmp = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL_LIST$delegate = lazy_0(tmp, _ALL_LIST$delegate$lambda);
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL$delegate = lazy_0(tmp_0, _ALL$delegate$lambda);
  }
}
function get_niceStr_0(_this__u8e3s4) {
  return get_niceStr(Ratio__toDouble_impl_o7epze(_this__u8e3s4));
}
//region block: post-declaration
initMetadataForClass(IntSegmentSet, 'IntSegmentSet', IntSegmentSet);
initMetadataForClass(StrokePointsMode, 'StrokePointsMode');
initMetadataForClass(StrokePointsBuilder, 'StrokePointsBuilder');
initMetadataForClass(CurveInfo, 'CurveInfo');
initMetadataForClass(Curves, 'Curves');
protoOf(ProjectedPoint).dz = isAlmostEquals$default;
initMetadataForClass(ProjectedPoint, 'ProjectedPoint', ProjectedPoint, VOID, [IsAlmostEquals]);
initMetadataForClass(Extrema, 'Extrema');
initMetadataForCompanion(Companion);
protoOf(Bezier).dz = isAlmostEquals$default;
initMetadataForClass(Bezier, 'Bezier', Bezier.c3g, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(SubBezier, 'SubBezier');
initMetadataForClass(ClosestResult, 'ClosestResult');
initMetadataForClass(Estimation, 'Estimation', Estimation);
initMetadataForClass(CurveLUT, 'CurveLUT');
initMetadataForObject(Arc, 'Arc');
initMetadataForCompanion(Companion_1);
initMetadataForClass(ImageDoNotFitException, 'ImageDoNotFitException');
initMetadataForClass(BinPacker, 'BinPacker');
initMetadataForClass(MaxRects, 'MaxRects');
initMetadataForCompanion(Companion_2);
initMetadataForClass(HitTestDirection, 'HitTestDirection');
initMetadataForObject(Convex, 'Convex');
initMetadataForClass(AbstractShape2D, 'AbstractShape2D');
initMetadataForCompanion(Companion_3);
initMetadataForClass(SliceRotation, 'SliceRotation');
initMetadataForCompanion(Companion_4);
initMetadataForClass(SliceOrientation, 'SliceOrientation');
initMetadataForInterface(SliceCoords, 'SliceCoords');
initMetadataForInterface(SliceCoordsWithBase, 'SliceCoordsWithBase', VOID, VOID, [SliceCoords]);
initMetadataForInterface(SliceCoordsWithBaseAndRect, 'SliceCoordsWithBaseAndRect', VOID, VOID, [SliceCoordsWithBase]);
protoOf(RectSlice).r2a = get_left;
protoOf(RectSlice).t2a = get_top;
protoOf(RectSlice).s2a = get_right;
protoOf(RectSlice).u2a = get_bottom;
protoOf(RectSlice).l2j = get_area;
protoOf(RectSlice).t3l = get_frameOffsetX;
protoOf(RectSlice).u3l = get_frameOffsetY;
protoOf(RectSlice).v3l = x;
protoOf(RectSlice).w3l = y;
initMetadataForClass(RectSlice, 'RectSlice', VOID, VOID, [SliceCoordsWithBaseAndRect]);
initMetadataForCompanion(Companion_5);
protoOf(SliceCoordsImpl).t3l = get_frameOffsetX;
protoOf(SliceCoordsImpl).u3l = get_frameOffsetY;
protoOf(SliceCoordsImpl).v3l = x;
protoOf(SliceCoordsImpl).w3l = y;
initMetadataForClass(SliceCoordsImpl, 'SliceCoordsImpl', VOID, VOID, [SliceCoordsWithBase]);
protoOf(RectCoords).v3l = x;
protoOf(RectCoords).w3l = y;
initMetadataForClass(RectCoords, 'RectCoords', VOID, VOID, [SliceCoords]);
initMetadataForClass(Bucket, 'Bucket', Bucket);
initMetadataForClass(Buckets, 'Buckets');
initMetadataForClass(AllBuckets, 'AllBuckets', AllBuckets);
initMetadataForClass(XWithWind, 'XWithWind', XWithWind);
initMetadataForObject(IntArrayListSort, 'IntArrayListSort');
initMetadataForClass(RastScale, 'RastScale', RastScale);
initMetadataForClass(PolygonScanline, 'PolygonScanline', PolygonScanline);
initMetadataForCompanion(Companion_6);
initMetadataForCompanion(Companion_7);
initMetadataForClass(MEdge, 'MEdge', MEdge);
initMetadataForClass(EdgePoint, 'EdgePoint');
initMetadataForClass(StrokeToFill, 'StrokeToFill', StrokeToFill);
initMetadataForInterface(VectorBuilder, 'VectorBuilder');
protoOf(VectorBuilder$transformed$1).w3q = line;
protoOf(VectorBuilder$transformed$1).x3q = rect;
protoOf(VectorBuilder$transformed$1).y3q = rect_0;
protoOf(VectorBuilder$transformed$1).z3q = rect_1;
protoOf(VectorBuilder$transformed$1).a3r = arc;
protoOf(VectorBuilder$transformed$1).b3r = arc$default;
protoOf(VectorBuilder$transformed$1).c3r = circle;
protoOf(VectorBuilder$transformed$1).d3r = rMoveTo;
protoOf(VectorBuilder$transformed$1).e3r = rLineTo;
protoOf(VectorBuilder$transformed$1).a2j = transformed;
initMetadataForClass(VectorBuilder$transformed$1, VOID, VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_8);
initMetadataForInterface(Visitor, 'Visitor');
protoOf(VectorPath).w3q = line;
protoOf(VectorPath).h1 = isEmpty;
protoOf(VectorPath).l2c = isNotEmpty;
protoOf(VectorPath).x3q = rect;
protoOf(VectorPath).y3q = rect_0;
protoOf(VectorPath).z3q = rect_1;
protoOf(VectorPath).a3r = arc;
protoOf(VectorPath).b3r = arc$default;
protoOf(VectorPath).c3r = circle;
protoOf(VectorPath).d3r = rMoveTo;
protoOf(VectorPath).e3r = rLineTo;
protoOf(VectorPath).a2j = transformed;
protoOf(VectorPath).f3r = transformed_0;
initMetadataForClass(VectorPath, 'VectorPath', VectorPath, VOID, [AbstractShape2D, VectorBuilder]);
protoOf(with$1).n6 = close;
protoOf(with$1).g3i = lineTo_0;
protoOf(with$1).h3i = quadTo_0;
protoOf(with$1).u3h = cubicTo;
initMetadataForClass(with$1, VOID, VOID, VOID, [Visitor]);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Winding, 'Winding');
initMetadataForCompanion(Companion_10);
initMetadataForClass(LineJoin, 'LineJoin');
initMetadataForCompanion(Companion_11);
initMetadataForClass(LineCap, 'LineCap');
initMetadataForClass(LineScaleMode, 'LineScaleMode');
initMetadataForCompanion(Companion_12);
initMetadataForClass(StrokeInfo, 'StrokeInfo', StrokeInfo);
initMetadataForCompanion(Companion_13);
protoOf(MPoint).dz = isAlmostEquals$default;
initMetadataForClass(MPoint, 'MPoint', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_14);
initMetadataForClass(MMatrix, 'MMatrix', MMatrix);
initMetadataForCompanion(Companion_15);
initMetadataForClass(MLine, 'MLine', MLine.t3s);
initMetadataForCompanion(Companion_16);
protoOf(MRectangle).dz = isAlmostEquals$default;
initMetadataForClass(MRectangle, 'MRectangle', VOID, VOID, [IsAlmostEquals]);
protoOf(Easings).gz = invoke;
protoOf(Easings).hz = invoke_0;
initMetadataForClass(Easings, 'Easings', VOID, VOID, [Easing, Enum]);
initMetadataForClass(Easings$SMOOTH, 'SMOOTH');
initMetadataForClass(Easings$EASE_IN_ELASTIC, 'EASE_IN_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_ELASTIC, 'EASE_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_BOUNCE, 'EASE_OUT_BOUNCE');
initMetadataForClass(Easings$LINEAR, 'LINEAR');
initMetadataForClass(Easings$EASE, 'EASE');
initMetadataForClass(Easings$EASE_IN, 'EASE_IN');
initMetadataForClass(Easings$EASE_OUT, 'EASE_OUT');
initMetadataForClass(Easings$EASE_IN_OUT, 'EASE_IN_OUT');
initMetadataForClass(Easings$EASE_IN_OLD, 'EASE_IN_OLD');
initMetadataForClass(Easings$EASE_OUT_OLD, 'EASE_OUT_OLD');
initMetadataForClass(Easings$EASE_IN_OUT_OLD, 'EASE_IN_OUT_OLD');
initMetadataForClass(Easings$EASE_OUT_IN_OLD, 'EASE_OUT_IN_OLD');
initMetadataForClass(Easings$EASE_IN_BACK, 'EASE_IN_BACK');
initMetadataForClass(Easings$EASE_OUT_BACK, 'EASE_OUT_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_BACK, 'EASE_IN_OUT_BACK');
initMetadataForClass(Easings$EASE_OUT_IN_BACK, 'EASE_OUT_IN_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_ELASTIC, 'EASE_IN_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_IN_ELASTIC, 'EASE_OUT_IN_ELASTIC');
initMetadataForClass(Easings$EASE_IN_BOUNCE, 'EASE_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_OUT_BOUNCE, 'EASE_IN_OUT_BOUNCE');
initMetadataForClass(Easings$EASE_OUT_IN_BOUNCE, 'EASE_OUT_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_QUAD, 'EASE_IN_QUAD');
initMetadataForClass(Easings$EASE_OUT_QUAD, 'EASE_OUT_QUAD');
initMetadataForClass(Easings$EASE_IN_OUT_QUAD, 'EASE_IN_OUT_QUAD');
initMetadataForClass(Easings$EASE_SINE, 'EASE_SINE');
initMetadataForClass(Easings$EASE_CLAMP_START, 'EASE_CLAMP_START');
initMetadataForClass(Easings$EASE_CLAMP_END, 'EASE_CLAMP_END');
initMetadataForClass(Easings$EASE_CLAMP_MIDDLE, 'EASE_CLAMP_MIDDLE');
initMetadataForClass(P, 'P');
protoOf(EasingCubic).gz = invoke;
protoOf(EasingCubic).hz = invoke_0;
initMetadataForClass(EasingCubic, 'EasingCubic', VOID, VOID, [Easing]);
//endregion
//region block: init
Arc_instance = new Arc();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Convex_instance = new Convex();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
Companion_instance_12 = new Companion_12();
Companion_instance_15 = new Companion_15();
//endregion
//region block: exports
export {
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance3u9930f4wm838,
  HitTestDirection_ANY_getInstance as HitTestDirection_ANY_getInstance1hlnrhgqmsigf,
  LineCap_BUTT_getInstance as LineCap_BUTT_getInstancetv7srcehoz43,
  LineJoin_MITER_getInstance as LineJoin_MITER_getInstance35lw9h64apo2h,
  LineScaleMode_NONE_getInstance as LineScaleMode_NONE_getInstance2mlqkio15xcm4,
  LineScaleMode_NORMAL_getInstance as LineScaleMode_NORMAL_getInstance1wxue9rdh6hry,
  Winding_EVEN_ODD_getInstance as Winding_EVEN_ODD_getInstancemyc10vdu2m52,
  Winding_NON_ZERO_getInstance as Winding_NON_ZERO_getInstance38kh1ikwl48ly,
  arc$default as arc$default4sjbw0e0mkug,
  _SliceOrientation___get_flipX__impl__lgb7bx as _SliceOrientation___get_flipX__impl__lgb7bx2vjjbyotgryi3,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2n27zigfr3r41,
  _SliceOrientation___get_rotation__impl__m65r0o as _SliceOrientation___get_rotation__impl__m65r0o2xos42p9chv89,
  Companion_getInstance_8 as Companion_getInstance154uzbkgf0e3s,
  Companion_instance_1 as Companion_instanceeeaudfwfrq87,
  Companion_instance_5 as Companion_instance2i0t7ux7bzoqc,
  Companion_getInstance_13 as Companion_getInstance2kfoysd3on6as,
  Companion_getInstance_22 as Companion_getInstance3d17rumlj92i7,
  ProjectedPoint as ProjectedPoint37gr1oedqap6n,
  get_isConvex as get_isConvex3nm4n5empqw0n,
  toBezier as toBezier1cphbqwqpx0d3,
  toStrokePointsList as toStrokePointsList2dojuc3rfktd4,
  ImageDoNotFitException as ImageDoNotFitException2gm4q4wt4lh58,
  get_cachedPoints as get_cachedPoints16ehjcv6uuio1,
  getPoints2List as getPoints2List1zux0vi6zk0wt,
  RectSlice as RectSlicec5msorw5q4el,
  SliceOrientation as SliceOrientation5szkqzxt7oev,
  PolygonScanline as PolygonScanline1ccjpk6mqxyxd,
  RastScale as RastScale3rcmuinujik1d,
  StrokeInfo as StrokeInfo1cunqczl43ffk,
  StrokeToFill as StrokeToFill127v8ehrppf9e,
  arc as arc1vjl2w7wqv39k,
  circle as circle1t8rrxfrm1ku9,
  isEmpty as isEmpty3b7xkdp0by4c8,
  lineTo as lineTo35eirmrqxz1l0,
  line as line3u2mk0n2uhnlh,
  moveTo as moveTo1v59p8psmu2yv,
  rLineTo as rLineTo1671hm1vy9pme,
  rMoveTo as rMoveTo38ittbd8h3wn5,
  rect as rect1tyihxx4629c2,
  rect_0 as rect31bppuugx2wch,
  rect_1 as rect3nqbmqh4a4l2a,
  transformed as transformed2t6vo3srmaaf9,
  VectorBuilder as VectorBuilder2g8a28qau4ty9,
  VectorPath as VectorPath1chx1oqdw6sb9,
  applyTransform as applyTransform1vhqlmleb4dce,
  getCurves as getCurves2yjahbp68cxj3,
  plus as plus1r33v70e4ipd7,
  strokeToFill_0 as strokeToFill34bvxzbc34djp,
  strokeToFill as strokeToFill2j5wye7yyxd99,
  toCurvesList as toCurvesList2ibv2opnrpohn,
  write as write11msa0gyjblqp,
  MMatrix as MMatrix1y71lv7vv6y8t,
  get_immutable as get_immutablepxpdoj6e54ll,
  get_mutable as get_mutableqzgwrema46rx,
  toMatrix4 as toMatrix42ci5k1es0x1v1,
  get_EASE_IN_OUT_QUAD as get_EASE_IN_OUT_QUAD21w3u6e1aoexb,
  IntSegmentSet as IntSegmentSet3br6yjcm9q2bd,
};
//endregion
